<template>
  <div class="form form-invoice">
    <h5>{{ $t("message.contracts.document_rwb") }}</h5>
    <b-tabs pills content-class="mt-3" small>
      <b-tab :title="$t('message.contracts.rwb_tab_data')">
        <span :class="['bmd-form-group mb-2 d-block form-label-group']">
          <textarea
            type="text"
            class="form-control"
            v-model="RWB.consignor_notice"
            :placeholder="$t('message.contracts.rwb_consignor_notice')"
            autocomplete="off"
            style="cursor: auto"
            id="rwb_consignor_notice"
          ></textarea>
          <label
            for="rwb_consignor_notice"
            class="form-label-group-label shorter"
            >{{ $t("message.contracts.rwb_consignor_notice") }}</label
          >
        </span>
        <div class="row">
          <div class="col-md-6">
            <span :class="['bmd-form-group mb-1 d-block form-label-group']">
              <label
                for="rwb_places_quantity"
                :class="[
                  'form-label-group-label shorter',
                  RWB.places_quantity != '' ? 'high' : '',
                ]"
                >{{ $t("message.contracts.rwb_places_quantity") }}</label
              >
              <cleave
                id="rwb_places_quantity"
                v-model="RWB.places_quantity"
                :options="cleaveInt"
                class="form-control"
                :placeholder="$t('message.contracts.rwb_places_quantity')"
                autocomplete="off"
                style="cursor: auto"
              ></cleave>
            </span>
          </div>
          <div class="col-md-6">
            <span :class="['bmd-form-group mb-1 d-block form-label-group']">
              <label
                for="rwb_gross_weight_quantity"
                :class="[
                  'form-label-group-label shorter',
                  RWB.gross_weight_quantity != '' ? 'high' : '',
                ]"
                >{{ $t("message.contracts.rwb_gross_weight_quantity") }}</label
              >
              <cleave
                id="rwb_gross_weight_quantity"
                v-model="RWB.gross_weight_quantity"
                :options="cleaveWeight"
                class="form-control"
                :placeholder="$t('message.contracts.rwb_gross_weight_quantity')"
                autocomplete="off"
                style="cursor: auto"
              ></cleave>
            </span>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <span :class="['bmd-form-group mb-2 d-block form-label-group']">
              <textarea
                type="text"
                class="form-control"
                v-model="RWB.departure_mode_description"
                :placeholder="
                  $t('message.contracts.rwb_departure_mode_description')
                "
                autocomplete="off"
                style="cursor: auto"
                id="rwb_departure_mode_description"
              ></textarea>
              <label
                for="rwb_departure_mode_description"
                class="form-label-group-label shorter"
                >{{
                  $t("message.contracts.rwb_departure_mode_description")
                }}</label
              >
            </span>
          </div>
          <div class="col-md-6">
            <span :class="['bmd-form-group mb-2 d-block form-label-group']">
              <textarea
                type="text"
                class="form-control"
                v-model="RWB.loader_mode_description"
                :placeholder="
                  $t('message.contracts.rwb_loader_mode_description')
                "
                autocomplete="off"
                style="cursor: auto"
                id="rwb_loader_mode_description"
              ></textarea>
              <label
                for="rwb_loader_mode_description"
                class="form-label-group-label shorter"
                >{{
                  $t("message.contracts.rwb_loader_mode_description")
                }}</label
              >
            </span>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <span :class="['bmd-form-group mb-1 d-block form-label-group']">
              <label
                for="rwb_additional_sheet_quantity"
                :class="[
                  'form-label-group-label shorter',
                  RWB.additional_sheet_quantity != '' ? 'high' : '',
                ]"
                >{{
                  $t("message.contracts.rwb_additional_sheet_quantity")
                }}</label
              >
              <cleave
                id="rwb_additional_sheet_quantity"
                v-model="RWB.additional_sheet_quantity"
                :options="cleaveInt"
                class="form-control"
                :placeholder="
                  $t('message.contracts.rwb_additional_sheet_quantity')
                "
                autocomplete="off"
                style="cursor: auto"
              ></cleave>
            </span>
          </div>
          <div class="col-md-6">
            <span :class="['bmd-form-group mb-1 d-block form-label-group']">
              <label
                for="rwb_cargo_value"
                :class="[
                  'form-label-group-label shorter',
                  RWB.cargo_value != '' ? 'high' : '',
                ]"
                >{{ $t("message.contracts.rwb_cargo_value") }}</label
              >
              <cleave
                id="rwb_cargo_value"
                v-model="RWB.cargo_value"
                :options="cleaveWeight"
                class="form-control"
                :placeholder="$t('message.contracts.rwb_cargo_value')"
                autocomplete="off"
                style="cursor: auto"
              ></cleave>
            </span>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <span :class="['bmd-form-group mb-2 d-block form-label-group']">
              <textarea
                type="text"
                class="form-control"
                v-model="RWB.customs_notice"
                :placeholder="$t('message.contracts.rwb_customs_notice')"
                autocomplete="off"
                style="cursor: auto"
                id="rwb_customs_notice"
              ></textarea>
              <label
                for="rwb_customs_notice"
                class="form-label-group-label shorter"
                >{{ $t("message.contracts.rwb_customs_notice") }}</label
              >
            </span>
          </div>
          <div class="col-md-6">
            <span :class="['bmd-form-group mb-2 d-block form-label-group']">
              <textarea
                type="text"
                class="form-control"
                v-model="RWB.weight_definition_mode_description"
                :placeholder="
                  $t('message.contracts.rwb_weight_definition_mode_description')
                "
                autocomplete="off"
                style="cursor: auto"
                id="rwb_weight_definition_mode_description"
              ></textarea>
              <label
                for="rwb_weight_definition_mode_description"
                class="form-label-group-label shorter"
                >{{
                  $t("message.contracts.rwb_weight_definition_mode_description")
                }}</label
              >
            </span>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <span :class="['bmd-form-group mb-2 d-block form-label-group']">
              <textarea
                type="text"
                class="form-control"
                v-model="RWB.carrier_notice"
                :placeholder="$t('message.contracts.rwb_carrier_notice')"
                autocomplete="off"
                style="cursor: auto"
                id="rwb_carrier_notice"
              ></textarea>
              <label
                for="rwb_carrier_notice"
                class="form-label-group-label shorter"
                >{{ $t("message.contracts.rwb_carrier_notice") }}</label
              >
            </span>
          </div>
          <div class="col-md-6">
            <span :class="['bmd-form-group mb-2 d-block form-label-group']">
              <textarea
                type="text"
                class="form-control"
                v-model="RWB.commerce_akt"
                :placeholder="$t('message.contracts.rwb_commerce_akt')"
                autocomplete="off"
                style="cursor: auto"
                id="rwb_commerce_akt"
              ></textarea>
              <label
                for="rwb_commerce_akt"
                class="form-label-group-label shorter"
                >{{ $t("message.contracts.rwb_commerce_akt") }}</label
              >
            </span>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <span :class="['bmd-form-group mb-2 d-block form-label-group']">
              <textarea
                type="text"
                class="form-control"
                v-model="RWB.prolongation"
                :placeholder="$t('message.contracts.rwb_prolongation')"
                autocomplete="off"
                style="cursor: auto"
                id="rwb_prolongation"
              ></textarea>
              <label
                for="rwb_prolongation"
                class="form-label-group-label shorter"
                >{{ $t("message.contracts.rwb_prolongation") }}</label
              >
            </span>
          </div>
          <div class="col-md-6">
            <span :class="['bmd-form-group mb-2 d-block form-label-group']">
              <textarea
                type="text"
                class="form-control"
                v-model="RWB.issue_marks"
                :placeholder="$t('message.contracts.rwb_issue_marks')"
                autocomplete="off"
                style="cursor: auto"
                id="rwb_issue_marks"
              ></textarea>
              <label
                for="rwb_issue_marks"
                class="form-label-group-label shorter"
                >{{ $t("message.contracts.rwb_issue_marks") }}</label
              >
            </span>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <span :class="['bmd-form-group mb-1 d-block form-label-group']">
              <label
                for="rwb_amount60"
                :class="[
                  'form-label-group-label shorter',
                  RWB.amount60 != '' ? 'high' : '',
                ]"
                >{{ $t("message.contracts.rwb_amount60") }}</label
              >
              <cleave
                id="rwb_amount60"
                v-model="RWB.amount60"
                :options="cleaveWeight"
                class="form-control"
                :placeholder="$t('message.contracts.rwb_amount60')"
                autocomplete="off"
                style="cursor: auto"
              ></cleave>
            </span>
          </div>
          <div class="col-md-6">
            <span :class="['bmd-form-group mb-1 d-block form-label-group']">
              <label
                for="rwb_amount61"
                :class="[
                  'form-label-group-label shorter',
                  RWB.amount61 != '' ? 'high' : '',
                ]"
                >{{ $t("message.contracts.rwb_amount61") }}</label
              >
              <cleave
                id="rwb_amount61"
                v-model="RWB.amount61"
                :options="cleaveWeight"
                class="form-control"
                :placeholder="$t('message.contracts.rwb_amount61')"
                autocomplete="off"
                style="cursor: auto"
              ></cleave>
            </span>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <span :class="['bmd-form-group mb-1 d-block form-label-group']">
              <label
                for="rwb_amount62"
                :class="[
                  'form-label-group-label shorter',
                  RWB.amount62 != '' ? 'high' : '',
                ]"
                >{{ $t("message.contracts.rwb_amount62") }}</label
              >
              <cleave
                id="rwb_amount62"
                v-model="RWB.amount62"
                :options="cleaveWeight"
                class="form-control"
                :placeholder="$t('message.contracts.rwb_amount62')"
                autocomplete="off"
                style="cursor: auto"
              ></cleave>
            </span>
          </div>
          <div class="col-md-6">
            <span :class="['bmd-form-group mb-1 d-block form-label-group']">
              <label
                for="rwb_amount63"
                :class="[
                  'form-label-group-label shorter',
                  RWB.amount63 != '' ? 'high' : '',
                ]"
                >{{ $t("message.contracts.rwb_amount63") }}</label
              >
              <cleave
                id="rwb_amount63"
                v-model="RWB.amount63"
                :options="cleaveWeight"
                class="form-control"
                :placeholder="$t('message.contracts.rwb_amount63')"
                autocomplete="off"
                style="cursor: auto"
              ></cleave>
            </span>
          </div>
        </div>

        <span :class="['bmd-form-group mb-2 d-block form-label-group']">
          <textarea
            type="text"
            class="form-control"
            v-model="RWB.calculation_notice"
            :placeholder="$t('message.contracts.rwb_calculation_notice')"
            autocomplete="off"
            style="cursor: auto"
            id="rwb_calculation_notice"
          ></textarea>
          <label
            for="rwb_calculation_notice"
            class="form-label-group-label shorter"
            >{{ $t("message.contracts.rwb_calculation_notice") }}</label
          >
        </span>

        <span :class="['bmd-form-group mb-2 d-block form-label-group']">
          <textarea
            type="text"
            class="form-control"
            v-model="RWB.addition_payment"
            :placeholder="$t('message.contracts.rwb_addition_payment')"
            autocomplete="off"
            style="cursor: auto"
            id="rwb_addition_payment"
          ></textarea>
          <label
            for="rwb_addition_payment"
            class="form-label-group-label shorter"
            >{{ $t("message.contracts.rwb_addition_payment") }}</label
          >
        </span>

        <span :class="['bmd-form-group mb-2 d-block form-label-group']">
          <textarea
            type="text"
            class="form-control"
            v-model="RWB.consignor_option_notice"
            :placeholder="$t('message.contracts.rwb_consignor_option_notice')"
            autocomplete="off"
            style="cursor: auto"
            id="rwb_consignor_option_notice"
          ></textarea>
          <label
            for="rwb_consignor_option_notice"
            class="form-label-group-label shorter"
            >{{ $t("message.contracts.rwb_consignor_option_notice") }}</label
          >
        </span>

        <div class="row">
          <div class="col-md-6">
            <span
              :class="[
                'bmd-form-group mb-2 mt-2 d-block form-label-group',
                consignor_focused ? 'focused' : '',
              ]"
            >
              <v-select
                id="rwb_consignor"
                :options="companies"
                label="display_text"
                :class="[
                  'form-control',
                  typeof RWB.consignor !== 'undefined' &&
                  RWB.consignor.value !== ''
                    ? 'vs--selected'
                    : '',
                ]"
                @search="fetchContragents"
                v-model="RWB.consignor"
                :placeholder="$t('message.contracts.rwb_consignor')"
                @focus="consignor_focused = true"
                @blur="consignor_focused = false"
              ></v-select>
              <label
                for="rwb_consignor"
                class="form-label-group-label shorter"
                >{{ $t("message.contracts.rwb_consignor") }}</label
              >
            </span>
          </div>
          <div class="col-md-6">
            <span
              :class="[
                'bmd-form-group mb-2 mt-2 d-block form-label-group',
                consignee_focused ? 'focused' : '',
              ]"
            >
              <v-select
                id="rwb_consignee"
                :options="companies"
                label="display_text"
                :class="[
                  'form-control',
                  typeof RWB.consignee !== 'undefined' &&
                  RWB.consignee.value !== ''
                    ? 'vs--selected'
                    : '',
                ]"
                @search="fetchContragents"
                v-model="RWB.consignee"
                :placeholder="$t('message.contracts.rwb_consignee')"
                @focus="consignee_focused = true"
                @blur="consignee_focused = false"
              ></v-select>
              <label
                for="rwb_consignee"
                class="form-label-group-label shorter"
                >{{ $t("message.contracts.rwb_consignee") }}</label
              >
            </span>
          </div>
        </div>

        <!--<div class="row">-->
        <!--<div class="col-md-12"> -->
        <code-value
          :label="$t('message.contracts.rwb_departure_station_name')"
          :value_placeholder="
            $t('message.contracts.rwb_departure_station_name')
          "
          :code_placeholder="$t('message.contracts.rwb_departure_station_code')"
          code_class="col-6"
          message_class="col-6"
          type="rw_station"
          v-model="RWB.departure_station"
        ></code-value>
        <!--<span :class="['bmd-form-group mb-2 d-block form-label-group shorter',  departure_station_focused?'focused':'']">
						
						<v-select id="rwb_departure_station" :options="rw_stations" label="display_text" :class="['form-control', typeof RWB.departure_station !== 'undefined' && RWB.departure_station.value!==''?'vs--selected':'']" @search="fetchStations"  v-model="RWB.departure_station" :placeholder="$t('message.contracts.rwb_departure_country')" @focus="departure_station_focused=true" @blur="departure_station_focused=false"></v-select>	
						<label for="rwb_departure_station" class="form-label-group-label shorter">{{$t('message.contracts.rwb_departure_station_name')}}</label>
					</span>-->
        <!--</div>-->
        <!--<div class="col-md-6">
					<span :class="['bmd-form-group mb-2 d-block form-label-group' ]">
						<input type="text" class="form-control" v-model="RWB.departure_station_code" :placeholder="$t('message.contracts.rwb_departure_station_code')" autocomplete="off" style="cursor: auto;" id="rwb_departure_station_code" />
						<label for="rwb_departure_station_code" class="form-label-group-label shorter">{{$t('message.contracts.rwb_departure_station_code')}}</label>
					</span>
				</div>
				<div class="col-md-6">
					<span :class="['bmd-form-group mb-2 d-block form-label-group' ]">
						<input type="text" class="form-control" v-model="RWB.departure_station_name" :placeholder="$t('message.contracts.rwb_departure_station_name')" autocomplete="off" style="cursor: auto;" id="rwb_departure_station_name" />
						<label for="rwb_departure_station_name" class="form-label-group-label shorter">{{$t('message.contracts.rwb_departure_station_name')}}</label>
					</span>
				</div> -->
        <!--</div>-->

        <div class="row">
          <div class="col-md-4">
            <span :class="['bmd-form-group mb-2 d-block form-label-group']">
              <input
                type="text"
                class="form-control"
                v-model="RWB.departure_rwcode"
                :placeholder="$t('message.contracts.rwb_departure_rwcode')"
                autocomplete="off"
                style="cursor: auto"
                id="rwb_departure_rwcode"
              />
              <label
                for="rwb_departure_rwcode"
                class="form-label-group-label shorter"
                >{{ $t("message.contracts.rwb_departure_rwcode") }}</label
              >
            </span>
          </div>
          <div class="col-md-4">
            <span :class="['bmd-form-group mb-2 d-block form-label-group']">
              <input
                type="text"
                class="form-control"
                v-model="RWB.departure_rwname"
                :placeholder="$t('message.contracts.rwb_departure_rwname')"
                autocomplete="off"
                style="cursor: auto"
                id="rwb_departure_rwname"
              />
              <label
                for="rwb_departure_rwname"
                class="form-label-group-label shorter"
                >{{ $t("message.contracts.rwb_departure_rwname") }}</label
              >
            </span>
          </div>

          <div class="col-md-4">
            <span
              :class="[
                'bmd-form-group mb-2 d-block form-label-group shorter',
                departure_country_focused ? 'focused' : '',
              ]"
            >
              <v-select
                id="rwb_departure_country"
                :options="countries"
                label="display_text"
                :class="[
                  'form-control',
                  typeof RWB.departure_country !== 'undefined' &&
                  RWB.departure_country.value !== ''
                    ? 'vs--selected'
                    : '',
                ]"
                @search="fetchCountries"
                v-model="RWB.departure_country"
                :placeholder="$t('message.contracts.rwb_departure_country')"
                @focus="departure_country_focused = true"
                @blur="departure_country_focused = false"
              ></v-select>
              <label
                for="rwb_departure_country"
                class="form-label-group-label shorter"
                >{{ $t("message.contracts.rwb_departure_country") }}</label
              >
            </span>
          </div>
        </div>

        <div class="row">
          <div class="col-md-4">
            <span :class="['bmd-form-group mb-2 d-block form-label-group']">
              <input
                type="text"
                class="form-control"
                v-model="RWB.destination_rwcode"
                :placeholder="$t('message.contracts.rwb_destination_rwcode')"
                autocomplete="off"
                style="cursor: auto"
                id="rwb_destination_rwcode"
              />
              <label
                for="rwb_destination_rwcode"
                class="form-label-group-label shorter"
                >{{ $t("message.contracts.rwb_destination_rwcode") }}</label
              >
            </span>
          </div>
          <div class="col-md-8">
            <code-value
              :label="
                $t('message.contracts.rwb_destination_rwand_station_name')
              "
              :value_placeholder="
                $t('message.contracts.rwb_destination_rwand_station_name')
              "
              :code_placeholder="
                $t('message.contracts.rwb_destination_station_code')
              "
              type="rw_station"
              code_class="col-6"
              message_class="col-6"
              v-model="RWB.destination_station"
            ></code-value>
            <!--<span :class="['bmd-form-group mb-2 d-block form-label-group shorter',  destination_station_focused?'focused':'']">
						<v-select id="rwb_destination_station" :options="rw_stations" label="display_text" :class="['form-control', typeof RWB.destination_station !== 'undefined' && RWB.destination_station.value!==''?'vs--selected':'']" @search="fetchStations"  v-model="RWB.destination_station" :placeholder="$t('message.contracts.rwb_destination_rwand_station_name')" @focus="destination_station_focused=true" @blur="destination_station_focused=false"></v-select>	
						<label for="rwb_destination_station" class="form-label-group-label shorter">{{$t('message.contracts.rwb_destination_rwand_station_name')}}</label>
					</span>-->
          </div>
          <!--<div class="col-md-4">
					<span :class="['bmd-form-group mb-2 d-block form-label-group' ]">
						<input type="text" class="form-control" v-model="RWB.destination_station_code" :placeholder="$t('message.contracts.rwb_destination_station_code')" autocomplete="off" style="cursor: auto;" id="rwb_destination_station_code" />
						<label for="rwb_destination_station_code" class="form-label-group-label shorter">{{$t('message.contracts.rwb_destination_station_code')}}</label>
					</span>
				</div>
				<div class="col-md-4">
					<span :class="['bmd-form-group mb-2 d-block form-label-group' ]">
						<input type="text" class="form-control" v-model="RWB.destination_rwand_station_name" :placeholder="$t('message.contracts.rwb_destination_rwand_station_name')" autocomplete="off" style="cursor: auto;" id="rwb_destination_rwand_station_name" />
						<label for="rwb_destination_rwand_station_name" class="form-label-group-label shorter">{{$t('message.contracts.rwb_destination_rwand_station_name')}}</label>
					</span>
				</div> -->
        </div>

        <div class="row">
          <div class="col-md-12">
            <code-value
              :label="$t('message.contracts.rwb_border_station_name')"
              :value_placeholder="
                $t('message.contracts.rwb_border_station_name')
              "
              :code_placeholder="
                $t('message.contracts.rwb_border_station_code')
              "
              type="rw_station"
              code_class="col-6"
              message_class="col-6"
              v-model="RWB.border_station"
            ></code-value>
            <!--<span :class="['bmd-form-group mb-2 d-block form-label-group shorter',  border_station_focused?'focused':'']">
						<v-select id="rwb_border_station" :options="rw_stations" label="display_text" :class="['form-control', typeof RWB.border_station !== 'undefined' && RWB.border_station.value!==''?'vs--selected':'']" @search="fetchStations"  v-model="RWB.border_station" :placeholder="$t('message.contracts.rwb_border_station_name')" @focus="border_station_focused=true" @blur="border_station_focused=false"></v-select>	
						<label for="rwb_border_station" class="form-label-group-label shorter">{{$t('message.contracts.rwb_border_station_name')}}</label>
					</span> -->
          </div>
          <!--<div class="col-md-6">
					<span :class="['bmd-form-group mb-2 d-block form-label-group' ]">
						<input type="text" class="form-control" v-model="RWB.border_station_code" :placeholder="$t('message.contracts.rwb_border_station_code')" autocomplete="off" style="cursor: auto;" id="rwb_border_station_code" />
						<label for="rwb_border_station_code" class="form-label-group-label shorter">{{$t('message.contracts.rwb_border_station_code')}}</label>
					</span>
				</div>
				<div class="col-md-6">
					<span :class="['bmd-form-group mb-2 d-block form-label-group' ]">
						<input type="text" class="form-control" v-model="RWB.border_station_name" :placeholder="$t('message.contracts.rwb_border_station_name')" autocomplete="off" style="cursor: auto;" id="rwb_border_station_name" />
						<label for="rwb_border_station_name" class="form-label-group-label shorter">{{$t('message.contracts.rwb_border_station_name')}}</label>
					</span>
				</div> -->
        </div>

        <div class="row">
          <div class="col-md-4">
            <span :class="['bmd-form-group mb-2 d-block form-label-group']">
              <input
                type="text"
                class="form-control"
                v-model="RWB.border_rwcode"
                :placeholder="$t('message.contracts.rwb_border_rwcode')"
                autocomplete="off"
                style="cursor: auto"
                id="rwb_border_rwcode"
              />
              <label
                for="rwb_border_rwcode"
                class="form-label-group-label shorter"
                >{{ $t("message.contracts.rwb_border_rwcode") }}</label
              >
            </span>
          </div>
          <div class="col-md-4">
            <span :class="['bmd-form-group mb-2 d-block form-label-group']">
              <input
                type="text"
                class="form-control"
                v-model="RWB.border_rwname"
                :placeholder="$t('message.contracts.rwb_border_rwname')"
                autocomplete="off"
                style="cursor: auto"
                id="rwb_border_rwname"
              />
              <label
                for="rwb_border_rwname"
                class="form-label-group-label shorter"
                >{{ $t("message.contracts.rwb_border_rwname") }}</label
              >
            </span>
          </div>
          <div class="col-md-4">
            <span
              :class="[
                'bmd-form-group mb-2 d-block form-label-group shorter',
                border_country_focused ? 'focused' : '',
              ]"
            >
              <v-select
                id="rwb_border_country"
                :options="countries"
                label="display_text"
                :class="[
                  'form-control',
                  typeof RWB.border_country !== 'undefined' &&
                  RWB.border_country.value !== ''
                    ? 'vs--selected'
                    : '',
                ]"
                @search="fetchCountries"
                v-model="RWB.border_country"
                :placeholder="$t('message.contracts.rwb_border_country')"
                @focus="border_country_focused = true"
                @blur="border_country_focused = false"
              ></v-select>
              <label
                for="rwb_border_country"
                class="form-label-group-label shorter"
                >{{ $t("message.contracts.rwb_border_country") }}</label
              >
            </span>
          </div>
        </div>

        <div class="row">
          <div class="col-md-4">
            <span :class="['bmd-form-group mb-2 d-block form-label-group']">
              <input
                type="text"
                class="form-control"
                v-model="RWB.contract_name"
                :placeholder="$t('message.contracts.rwb_contract_name')"
                autocomplete="off"
                style="cursor: auto"
                id="rwb_contract_name"
              />
              <label
                for="rwb_contract_name"
                class="form-label-group-label shorter"
                >{{ $t("message.contracts.rwb_contract_name") }}</label
              >
            </span>
          </div>
          <div class="col-md-3">
            <span :class="['bmd-form-group mb-2 d-block form-label-group']">
              <input
                type="text"
                class="form-control"
                v-model="RWB.contract_number"
                :placeholder="$t('message.contracts.rwb_contract_number')"
                autocomplete="off"
                style="cursor: auto"
                id="rwb_contract_number"
              />
              <label
                for="rwb_contract_number"
                class="form-label-group-label shorter"
                >{{ $t("message.contracts.rwb_contract_number") }}</label
              >
            </span>
          </div>
          <div class="col-md-5">
            <span
              :class="['bmd-form-group mb-2 d-block form-label-group shorter']"
            >
              <!-- <b-form-datepicker :locale="locale" v-model="RWB.contract_date" :placeholder="$t('message.contracts.rwb_contract_date')" size="sm" no-flip :hide-header="true" :show-decade-nav="false" id="rwb_contract_date"></b-form-datepicker>
						<label v-if="RWB.contract_date!=''" for="rwb_contract_date" class="form-label-group-label shorter topped">{{$t('message.contracts.rwb_contract_date')}}</label> -->

              <datepicker
                value-type="YYYY-MM-DD"
                format="DD.MM.YYYY"
                @focus="RWB.contract_date = ' '"
                @blur="
                  RWB.contract_date == ' '
                    ? (RWB.contract_date = '')
                    : (RWB.contract_date = RWB.contract_date)
                "
                inputClass="form-control"
                v-model="RWB.contract_date"
                :placeholder="$t('message.contracts.rwb_contract_date')"
                :inputAttr="{ id: 'rwb_contract_date' }"
              />
              <label
                for="rwb_contract_date"
                class="form-label-group-label shorter"
                :class="
                  RWB.contract_date != '' && RWB.contract_date != null
                    ? 'topped'
                    : ''
                "
                >{{ $t("message.contracts.rwb_contract_date") }}</label
              >
            </span>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <span :class="['bmd-form-group mb-1 d-block form-label-group']">
              <label
                for="rwb_flat_pallet_quantity"
                :class="[
                  'form-label-group-label shorter',
                  RWB.flat_pallet_quantity != '' ? 'high' : '',
                ]"
                >{{ $t("message.contracts.rwb_flat_pallet_quantity") }}</label
              >
              <cleave
                id="rwb_flat_pallet_quantity"
                v-model="RWB.flat_pallet_quantity"
                :options="cleaveWeight"
                class="form-control"
                :placeholder="$t('message.contracts.rwb_flat_pallet_quantity')"
                autocomplete="off"
                style="cursor: auto"
              ></cleave>
            </span>
          </div>
          <div class="col-md-6">
            <span :class="['bmd-form-group mb-1 d-block form-label-group']">
              <label
                for="rwb_box_pallet_quantity"
                :class="[
                  'form-label-group-label shorter',
                  RWB.box_pallet_quantity != '' ? 'high' : '',
                ]"
                >{{ $t("message.contracts.rwb_box_pallet_quantity") }}</label
              >
              <cleave
                id="rwb_box_pallet_quantity"
                v-model="RWB.box_pallet_quantity"
                :options="cleaveWeight"
                class="form-control"
                :placeholder="$t('message.contracts.rwb_box_pallet_quantity')"
                autocomplete="off"
                style="cursor: auto"
              ></cleave>
            </span>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <span :class="['bmd-form-group mb-1 d-block form-label-group']">
              <input
                type="text"
                class="form-control"
                v-model="RWB.pallet_exchange_mode"
                :placeholder="$t('message.contracts.rwb_pallet_exchange_mode')"
                autocomplete="off"
                style="cursor: auto"
                id="rwb_pallet_exchange_mode"
              />
              <label
                for="rwb_pallet_exchange_mode"
                class="form-label-group-label shorter"
                >{{ $t("message.contracts.rwb_pallet_exchange_mode") }}</label
              >
            </span>
          </div>
        </div>

        <div class="row">
          <div class="col-md-3">
            <span :class="['bmd-form-group mb-2 d-block form-label-group']">
              <input
                type="text"
                class="form-control"
                v-model="RWB.work_tool_id"
                :placeholder="$t('message.contracts.rwb_work_tool_id')"
                autocomplete="off"
                style="cursor: auto"
                id="rwb_work_tool_id"
              />
              <label
                for="rwb_work_tool_id"
                class="form-label-group-label shorter"
                >{{ $t("message.contracts.rwb_work_tool_id") }}</label
              >
            </span>
          </div>
          <div class="col-md-6">
            <span :class="['bmd-form-group mb-2 d-block form-label-group']">
              <input
                type="text"
                class="form-control"
                v-model="RWB.work_tool_container_description"
                :placeholder="
                  $t('message.contracts.rwb_work_tool_container_description')
                "
                autocomplete="off"
                style="cursor: auto"
                id="rwb_work_tool_container_description"
              />
              <label
                for="rwb_work_tool_container_description"
                class="form-label-group-label shorter"
                >{{
                  $t("message.contracts.rwb_work_tool_container_description")
                }}</label
              >
            </span>
          </div>
          <div class="col-md-3">
            <span
              :class="['bmd-form-group mb-2 d-block form-label-group shorter']"
            >
              <input
                type="text"
                class="form-control"
                v-model="RWB.work_tool_railway_code"
                :placeholder="
                  $t('message.contracts.rwb_work_tool_railway_code')
                "
                autocomplete="off"
                style="cursor: auto"
                id="rwb_work_tool_railway_code"
              />
              <label
                for="rwb_work_tool_railway_code"
                class="form-label-group-label shorter"
                >{{ $t("message.contracts.rwb_work_tool_railway_code") }}</label
              >
            </span>
          </div>
        </div>

        <div class="row">
          <div class="col-md-3">
            <span :class="['bmd-form-group mb-2 d-block form-label-group']">
              <label
                for="rwb_mark_sing"
                :class="[
                  'form-label-group-label shorter',
                  RWB.mark_sing != '' ? 'high' : '',
                ]"
                >{{ $t("message.contracts.rwb_mark_sing") }}</label
              >
              <cleave
                id="rwb_mark_sing"
                v-model="RWB.mark_sing"
                :options="cleaveInt"
                class="form-control"
                :placeholder="$t('message.contracts.rwb_mark_sing')"
                autocomplete="off"
                style="cursor: auto"
              ></cleave>
            </span>
          </div>
          <div class="col-md-3">
            <span :class="['bmd-form-group mb-2 d-block form-label-group']">
              <input
                type="text"
                class="form-control"
                v-model="RWB.mark_kind"
                :placeholder="$t('message.contracts.rwb_mark_kind')"
                autocomplete="off"
                style="cursor: auto"
                id="rwb_mark_kind"
              />
              <label
                for="rwb_mark_kind"
                class="form-label-group-label shorter"
                >{{ $t("message.contracts.rwb_mark_kind") }}</label
              >
            </span>
          </div>
          <div class="col-md-6">
            <span
              :class="['bmd-form-group mb-2 d-block form-label-group shorter']"
            >
              <input
                type="text"
                class="form-control"
                v-model="RWB.mark_result_control"
                :placeholder="$t('message.contracts.rwb_mark_result_control')"
                autocomplete="off"
                style="cursor: auto"
                id="rwb_mark_result_control"
              />
              <label
                for="rwb_mark_result_control"
                class="form-label-group-label shorter"
                >{{ $t("message.contracts.rwb_mark_result_control") }}</label
              >
            </span>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <span :class="['bmd-form-group mb-2 d-block form-label-group']">
              <input
                type="text"
                class="form-control"
                v-model="RWB.contract_carrier_name"
                :placeholder="$t('message.contracts.rwb_contract_carrier_name')"
                autocomplete="off"
                style="cursor: auto"
                id="rwb_contract_carrier_name"
              />
              <label
                for="rwb_contract_carrier_name"
                class="form-label-group-label shorter"
                >{{ $t("message.contracts.rwb_contract_carrier_name") }}</label
              >
            </span>
          </div>
          <div class="col-md-6">
            <span :class="['bmd-form-group mb-2 d-block form-label-group']">
              <b-form-timepicker
                v-model="RWB.contract_carrier_time"
                :locale="locale"
                :placeholder="$t('message.contracts.rwb_contract_carrier_time')"
                size="sm"
                no-flip
                :hide-header="true"
                :show-decade-nav="false"
                no-close-button
                id="rwb_contract_carrier_time"
              ></b-form-timepicker>

              <label
                v-if="RWB.contract_carrier_time != ''"
                for="rwb_contract_carrier_time"
                class="form-label-group-label shorter topped"
                >{{ $t("message.contracts.rwb_contract_carrier_time") }}</label
              >
            </span>
          </div>
          <div class="col-md-6">
            <span
              :class="['bmd-form-group mb-2 d-block form-label-group shorter']"
            >
              <!-- <b-form-datepicker :locale="locale" v-model="RWB.contract_carrier_date" :placeholder="$t('message.contracts.rwb_contract_carrier_date')" size="sm" no-flip :hide-header="true" :show-decade-nav="false" id="rwb_contract_carrier_date"></b-form-datepicker> -->
              <datepicker
                value-type="YYYY-MM-DD"
                format="DD.MM.YYYY"
                @focus="RWB.contract_carrier_date = ' '"
                @blur="
                  RWB.contract_carrier_date == ' '
                    ? (RWB.contract_carrier_date = '')
                    : (RWB.contract_carrier_date = RWB.contract_carrier_date)
                "
                inputClass="form-control"
                v-model="RWB.contract_carrier_date"
                :placeholder="$t('message.contracts.rwb_contract_carrier_date')"
                :inputAttr="{ id: 'rwb_contract_carrier_date' }"
              />
              <label
                for="rwb_contract_carrier_date"
                class="form-label-group-label shorter"
                :class="
                  RWB.contract_carrier_date != '' &&
                  RWB.contract_carrier_date != null
                    ? 'topped'
                    : ''
                "
                >{{ $t("message.contracts.rwb_contract_carrier_date") }}</label
              >

              <!-- <label  v-if="RWB.contract_carrier_date!=''" for="rwb_contract_carrier_date" class="form-label-group-label shorter topped">{{$t('message.contracts.rwb_contract_carrier_date')}}</label> -->
            </span>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <span :class="['bmd-form-group mb-2 d-block form-label-group']">
              <!-- <b-form-datepicker :locale="locale" v-model="contract_carrier_date_time_moscow_date" :placeholder="$t('message.contracts.rwb_contract_carrier_date_time_moscow_date')" size="sm" no-flip :hide-header="true" :show-decade-nav="false" id="rwb_contract_carrier_date_time_moscow_date"></b-form-datepicker>
						<label v-if="contract_carrier_date_time_moscow_date!=''" for="rwb_contract_carrier_date_time_moscow_date" class="form-label-group-label shorter topped">{{$t('message.contracts.rwb_contract_carrier_date_time_moscow_date')}}</label> -->

              <datepicker
                value-type="YYYY-MM-DDThh:mm:ss"
                type="datetime"
                format="DD.MM.YYYY hh:mm:ss"
                @focus="RWB.contract_carrier_date_time_moscow = ' '"
                @blur="
                  RWB.contract_carrier_date_time_moscow == ' '
                    ? (RWB.contract_carrier_date_time_moscow = '')
                    : (RWB.contract_carrier_date_time_moscow =
                        RWB.contract_carrier_date_time_moscow)
                "
                inputClass="form-control"
                v-model="RWB.contract_carrier_date_time_moscow"
                :placeholder="
                  $t('message.contracts.rwb_contract_carrier_date_time_moscow')
                "
                :inputAttr="{
                  id: 'rwb_contract_carrier_date_time_moscow_date',
                }"
              />
              <label
                for="rwb_contract_carrier_date_time_moscow_date"
                class="form-label-group-label shorter"
                :class="
                  RWB.contract_carrier_date_time_moscow != '' &&
                  RWB.contract_carrier_date_time_moscow != null
                    ? 'topped'
                    : ''
                "
                >{{
                  $t("message.contracts.rwb_contract_carrier_date_time_moscow")
                }}</label
              >
            </span>
          </div>
          <!-- <div class="col-md-6">
					<span :class="['bmd-form-group mb-2 d-block form-label-group' ]">
						<b-form-timepicker no-close-button v-model="contract_carrier_date_time_moscow_time" :locale="locale" :placeholder="$t('message.contracts.rwb_contract_carrier_date_time_moscow_time')" size="sm" no-flip :hide-header="true" :show-decade-nav="false" id="rwb_contract_carrier_date_time_moscow_time"></b-form-timepicker>
						<label v-if="contract_carrier_date_time_moscow_time!=''" for="rwb_contract_carrier_date_time_moscow_time" class="form-label-group-label shorter topped">{{$t('message.contracts.rwb_contract_carrier_date_time_moscow_time')}}</label>


						
					</span>
				</div> -->
        </div>

        <div class="row">
          <div class="col-md-12">
            <code-value
              :label="$t('message.contracts.rwb_contract_carrier_station_name')"
              :value_placeholder="
                $t('message.contracts.rwb_contract_carrier_station_name')
              "
              :code_placeholder="
                $t('message.contracts.rwb_contract_carrier_station_code')
              "
              type="rw_station"
              code_class="col-6"
              message_class="col-6"
              v-model="RWB.contract_carrier_station"
            ></code-value>
            <!--<span :class="['bmd-form-group mb-2 d-block form-label-group shorter',  contract_carrier_station_focused?'focused':'']">
						<v-select id="rwb_contract_carrier_station" :options="rw_stations" label="display_text" :class="['form-control', typeof RWB.contract_carrier_station !== 'undefined' && RWB.contract_carrier_station.value!==''?'vs--selected':'']" @search="fetchStations"  v-model="RWB.contract_carrier_station" :placeholder="$t('message.contracts.rwb_contract_carrier_station_name')" @focus="contract_carrier_station_focused=true" @blur="contract_carrier_station_focused=false"></v-select>	
						<label for="rwb_contract_carrier_station" class="form-label-group-label shorter">{{$t('message.contracts.rwb_contract_carrier_station_name')}}</label>
					</span>-->
          </div>
          <!--<div class="col-md-6">
					<span :class="['bmd-form-group mb-2 d-block form-label-group' ]">
						<input type="text" class="form-control" v-model="RWB.contract_carrier_station_code" :placeholder="$t('message.contracts.rwb_contract_carrier_station_code')" autocomplete="off" style="cursor: auto;" id="rwb_contract_carrier_station_code" />
						<label for="rwb_contract_carrier_station_code" class="form-label-group-label shorter">{{$t('message.contracts.rwb_contract_carrier_station_code')}}</label>
					</span>
				</div>
				<div class="col-md-6">
					<span :class="['bmd-form-group mb-2 d-block form-label-group' ]">
						<input type="text" class="form-control" v-model="RWB.contract_carrier_station_name" :placeholder="$t('message.contracts.rwb_contract_carrier_station_name')" autocomplete="off" style="cursor: auto;" id="rwb_contract_carrier_station_name" />
						<label for="rwb_contract_carrier_station_name" class="form-label-group-label shorter">{{$t('message.contracts.rwb_contract_carrier_station_name')}}</label>
					</span>
				</div> -->
        </div>

        <div class="row">
          <div class="col-md-6">
            <span :class="['bmd-form-group mb-2 d-block form-label-group']">
              <input
                type="text"
                class="form-control"
                v-model="RWB.contract_carrier_rw_name"
                :placeholder="
                  $t('message.contracts.rwb_contract_carrier_rw_name')
                "
                autocomplete="off"
                style="cursor: auto"
                id="rwb_contract_carrier_rw_name"
              />
              <label
                for="rwb_contract_carrier_rw_name"
                class="form-label-group-label shorter"
                >{{
                  $t("message.contracts.rwb_contract_carrier_rw_name")
                }}</label
              >
            </span>
          </div>
          <div class="col-md-6">
            <span
              :class="[
                'bmd-form-group mb-2 d-block form-label-group shorter',
                contract_carrier_country_focused ? 'focused' : '',
              ]"
            >
              <v-select
                id="rwb_contract_carrier_country"
                :options="countries"
                label="display_text"
                :class="[
                  'form-control',
                  typeof RWB.contract_carrier_country !== 'undefined' &&
                  RWB.contract_carrier_country.value !== ''
                    ? 'vs--selected'
                    : '',
                ]"
                @search="fetchCountries"
                v-model="RWB.contract_carrier_country"
                :placeholder="
                  $t('message.contracts.rwb_contract_carrier_country')
                "
                @focus="contract_carrier_country_focused = true"
                @blur="contract_carrier_country_focused = false"
              ></v-select>
              <label
                for="rwb_contract_carrier_country"
                class="form-label-group-label shorter"
                >{{
                  $t("message.contracts.rwb_contract_carrier_country")
                }}</label
              >
            </span>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <span :class="['bmd-form-group mb-2 d-block form-label-group']">
              <input
                type="text"
                class="form-control"
                v-model="RWB.arrival_carrier_name"
                :placeholder="$t('message.contracts.rwb_arrival_carrier_name')"
                autocomplete="off"
                style="cursor: auto"
                id="rwb_arrival_carrier_name"
              />
              <label
                for="rwb_arrival_carrier_name"
                class="form-label-group-label shorter"
                >{{ $t("message.contracts.rwb_arrival_carrier_name") }}</label
              >
            </span>
          </div>
          <div class="col-md-6">
            <span :class="['bmd-form-group mb-2 d-block form-label-group']">
              <b-form-timepicker
                no-close-button
                v-model="RWB.arrival_time"
                :locale="locale"
                :placeholder="$t('message.contracts.rwb_arrival_time')"
                size="sm"
                no-flip
                :hide-header="true"
                :show-decade-nav="false"
                id="rwb_arrival_time"
              ></b-form-timepicker>
              <label
                v-if="RWB.arrival_time != ''"
                for="rwb_arrival_time"
                class="form-label-group-label shorter topped"
                >{{ $t("message.contracts.rwb_arrival_time") }}</label
              >
            </span>
          </div>
          <div class="col-md-6">
            <span
              :class="['bmd-form-group mb-2 d-block form-label-group shorter']"
            >
              <!-- <b-form-datepicker :locale="locale" v-model="RWB.arrival_date" :placeholder="$t('message.contracts.rwb_arrival_date')" size="sm" no-flip :hide-header="true" :show-decade-nav="false" id="rwb_arrival_date"></b-form-datepicker>
						<label v-if="RWB.arrival_date!=''" for="rwb_arrival_date" class="form-label-group-label shorter topped">{{$t('message.contracts.rwb_arrival_date')}}</label> -->
              <datepicker
                value-type="YYYY-MM-DD"
                format="DD.MM.YYYY"
                @focus="RWB.arrival_date = ' '"
                @blur="
                  RWB.arrival_date == ' '
                    ? (RWB.arrival_date = '')
                    : (RWB.arrival_date = RWB.arrival_date)
                "
                inputClass="form-control"
                v-model="RWB.arrival_date"
                :placeholder="$t('message.contracts.rwb_arrival_date')"
                :inputAttr="{ id: 'rwb_arrival_date' }"
              />
              <label
                for="rwb_arrival_date"
                class="form-label-group-label shorter"
                :class="
                  RWB.arrival_date != '' && RWB.arrival_date != null
                    ? 'topped'
                    : ''
                "
                >{{ $t("message.contracts.rwb_arrival_date") }}</label
              >
            </span>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <span :class="['bmd-form-group mb-2 d-block form-label-group']">
              <!-- <b-form-datepicker :locale="locale" v-model="arrival_date_time_moscow_date" :placeholder="$t('message.contracts.rwb_arrival_date_time_moscow_date')" size="sm" no-flip :hide-header="true" :show-decade-nav="false" id="rwb_arrival_date_time_moscow_date"></b-form-datepicker>
						<label v-if="arrival_date_time_moscow_date!=''" for="rwb_arrival_date_time_moscow_date" class="form-label-group-label shorter topped">{{$t('message.contracts.rwb_arrival_date_time_moscow_date')}}</label> -->
              <datepicker
                value-type="YYYY-MM-DDThh:mm:ss"
                type="datetime"
                format="DD.MM.YYYY hh:mm:ss"
                @focus="RWB.arrival_date_time_moscow = ' '"
                @blur="
                  RWB.arrival_date_time_moscow == ' '
                    ? (RWB.arrival_date_time_moscow = '')
                    : (RWB.arrival_date_time_moscow =
                        RWB.arrival_date_time_moscow)
                "
                inputClass="form-control"
                v-model="RWB.arrival_date_time_moscow"
                :placeholder="
                  $t('message.contracts.rwb_arrival_date_time_moscow')
                "
                :inputAttr="{ id: 'rwb_arrival_date_time_moscow_date' }"
              />
              <label
                for="rwb_arrival_date_time_moscow_date"
                class="form-label-group-label shorter"
                :class="
                  RWB.arrival_date_time_moscow != '' &&
                  RWB.arrival_date_time_moscow != null
                    ? 'topped'
                    : ''
                "
                >{{
                  $t("message.contracts.rwb_arrival_date_time_moscow")
                }}</label
              >
            </span>
          </div>
          <!-- <div class="col-md-6">
					<span :class="['bmd-form-group mb-2 d-block form-label-group' ]">
						<b-form-timepicker no-close-button v-model="arrival_date_time_moscow_time" :locale="locale" :placeholder="$t('message.contracts.rwb_arrival_date_time_moscow_time')" size="sm" no-flip :hide-header="true" :show-decade-nav="false" id="rwb_arrival_date_time_moscow_time"></b-form-timepicker>
						<label v-if="arrival_date_time_moscow_time!=''" for="rwb_arrival_date_time_moscow_time" class="form-label-group-label shorter topped">{{$t('message.contracts.rwb_arrival_date_time_moscow_time')}}</label>

						
					</span>
				</div> -->
        </div>

        <div class="row">
          <div class="col-md-12">
            <code-value
              :label="$t('message.contracts.rwb_arrival_station_name')"
              :value_placeholder="
                $t('message.contracts.rwb_arrival_station_name')
              "
              :code_placeholder="
                $t('message.contracts.rwb_arrival_station_code')
              "
              type="rw_station"
              code_class="col-6"
              message_class="col-6"
              v-model="RWB.arrival_station"
            ></code-value>
            <!--<span :class="['bmd-form-group mb-2 d-block form-label-group shorter',  arrival_station_focused?'focused':'']">
						<v-select id="rwb_arrival_station" :options="rw_stations" label="display_text" :class="['form-control', typeof RWB.arrival_station !== 'undefined' && RWB.arrival_station.value!==''?'vs--selected':'']" @search="fetchStations"  v-model="RWB.arrival_station" :placeholder="$t('message.contracts.rwb_departure_country')" @focus="arrival_station_focused=true" @blur="arrival_station_focused=false"></v-select>	
						<label for="rwb_arrival_station" class="form-label-group-label shorter">{{$t('message.contracts.rwb_arrival_station_code')}}</label>
					</span>-->
          </div>
          <!--<div class="col-md-6">
					<span :class="['bmd-form-group mb-2 d-block form-label-group' ]">
						<input type="text" class="form-control" v-model="RWB.arrival_station_code" :placeholder="$t('message.contracts.rwb_arrival_station_code')" autocomplete="off" style="cursor: auto;" id="rwb_arrival_station_code" />
						<label for="rwb_arrival_station_code" class="form-label-group-label shorter">{{$t('message.contracts.rwb_arrival_station_code')}}</label>
					</span>
				</div>
				<div class="col-md-6">
					<span :class="['bmd-form-group mb-2 d-block form-label-group' ]">
						<input type="text" class="form-control" v-model="RWB.arrival_station_name" :placeholder="$t('message.contracts.rwb_arrival_station_name')" autocomplete="off" style="cursor: auto;" id="rwb_arrival_station_name" />
						<label for="rwb_arrival_station_name" class="form-label-group-label shorter">{{$t('message.contracts.rwb_arrival_station_name')}}</label>
					</span>
				</div> -->
        </div>

        <div class="row">
          <div class="col-md-4">
            <span :class="['bmd-form-group mb-2 d-block form-label-group']">
              <input
                type="text"
                class="form-control"
                v-model="RWB.arrival_rw_name"
                :placeholder="$t('message.contracts.rwb_arrival_rw_name')"
                autocomplete="off"
                style="cursor: auto"
                id="rwb_arrival_rw_name"
              />
              <label
                for="rwb_arrival_rw_name"
                class="form-label-group-label shorter"
                >{{ $t("message.contracts.rwb_arrival_rw_name") }}</label
              >
            </span>
          </div>
          <div class="col-md-4">
            <span :class="['bmd-form-group mb-2 d-block form-label-group']">
              <input
                type="text"
                class="form-control"
                v-model="RWB.arrival_rw_code"
                :placeholder="$t('message.contracts.rwb_arrival_rw_code')"
                autocomplete="off"
                style="cursor: auto"
                id="rwb_arrival_rw_code"
              />
              <label
                for="rwb_arrival_rw_code"
                class="form-label-group-label shorter"
                >{{ $t("message.contracts.rwb_arrival_rw_code") }}</label
              >
            </span>
          </div>
          <div class="col-md-4">
            <span
              :class="[
                'bmd-form-group mb-2 d-block form-label-group shorter',
                arrival_country_focused ? 'focused' : '',
              ]"
            >
              <v-select
                id="rwb_arrival_country"
                :options="countries"
                label="display_text"
                :class="[
                  'form-control',
                  typeof RWB.arrival_country !== 'undefined' &&
                  RWB.arrival_country.value !== ''
                    ? 'vs--selected'
                    : '',
                ]"
                @search="fetchCountries"
                v-model="RWB.arrival_country"
                :placeholder="$t('message.contracts.rwb_arrival_country')"
                @focus="arrival_country_focused = true"
                @blur="arrival_country_focused = false"
              ></v-select>
              <label
                for="rwb_arrival_country"
                class="form-label-group-label shorter"
                >{{ $t("message.contracts.rwb_arrival_country") }}</label
              >
            </span>
          </div>
        </div>
      </b-tab>
      <b-tab :title="$t('message.contracts.rwb_tab_goods')">
        <div class="table-responsive">
          <b-table
            :items="RWB.goods"
            :fields="rwb_good_fields"
            responsive
            striped
            hover
          >
            <template v-slot:cell(currency)="data">
              {{ data.value.display_text }}
            </template>
            <template v-slot:cell(actions)="data">
              <button
                class="btn btn-sm btn-link text-info"
                @click="edit_rwb_goods(data.item, data.index)"
              >
                <i class="fa fa-edit"></i>
              </button>
              <button
                class="btn btn-link btn-sm text-danger"
                @click="remove_rwb_good(data.index)"
              >
                <i class="fa fa-trash"></i>
              </button>
            </template>
          </b-table>
        </div>
        <button
          id="add-rwb-goods-modal-open-button"
          class="btn btn-sm btn-round btn-pills btn-success"
          v-b-modal.modal-add-rwb-good
        >
          {{ $t("message.add") }}
        </button>
      </b-tab>
      <b-tab :title="$t('message.contracts.rwb_tab_carrier')">
        <h5>{{ $t("message.contracts.rwb_tab_carrier") }}</h5>
        <div class="table-responsive">
          <b-table
            :items="RWB.carrier"
            :fields="rwb_carrier_fields"
            responsive
            striped
            hover
          >
            <template v-slot:cell(from_country)="data">
              {{ data.value.display_text }}
            </template>
            <template v-slot:cell(to_country)="data">
              {{ data.value.display_text }}
            </template>
            <template v-slot:cell(actions)="data">
              <button
                class="btn btn-sm btn-link text-info"
                @click="edit_rwb_carrier(data.item, data.index)"
              >
                <i class="fa fa-edit"></i>
              </button>
              <button
                class="btn btn-link btn-sm text-danger"
                @click="remove_rwb_carrier(data.index)"
              >
                <i class="fa fa-trash"></i>
              </button>
            </template>
          </b-table>
        </div>
        <button
          id="rwb-add-carrier-open-modal-button"
          class="btn btn-sm btn-round btn-pills btn-outline-success"
          v-b-modal.modal-add-rwb-carrier
        >
          {{ $t("message.add") }}
        </button>
        <br /><br />
        <h5>{{ $t("message.contracts.rwb_tab_carrier_charge") }}</h5>
        <div class="table-responsive">
          <b-table
            :items="RWB.carrier_charge"
            :fields="rwb_carrier_charge_fields"
            responsive
            striped
            hover
          >
            <template v-slot:cell(to_country)="data">
              {{ data.value.display_text }}
            </template>
            <template v-slot:cell(from_country)="data">
              {{ data.value.display_text }}
            </template>
            <template v-slot:cell(snd_tarif_currency_code)="data">
              {{ data.value.display_text }}
            </template>
            <template v-slot:cell(snd_payment_currency)="data">
              {{ data.value.display_text }}
            </template>
            <template v-slot:cell(rcv_tarif_currency_code)="data">
              {{ data.value.display_text }}
            </template>
            <template v-slot:cell(rcv_payment_currency)="data">
              {{ data.value.display_text }}
            </template>
            <template v-slot:cell(actions)="data">
              <button
                class="btn btn-sm btn-link text-info"
                @click="edit_rwb_carrier_charge(data.item, data.index)"
              >
                <i class="fa fa-edit"></i>
              </button>
              <button
                class="btn btn-link btn-sm text-danger"
                @click="remove_rwb_carrier_charge(data.index)"
              >
                <i class="fa fa-trash"></i>
              </button>
            </template>
          </b-table>
        </div>
        <button
          id="rwb-add-carrier-fees-open-modal-button"
          class="btn btn-sm btn-round btn-pills btn-outline-success"
          v-b-modal.modal-add-rwb-carrier-charge
        >
          {{ $t("message.add") }}
        </button>
      </b-tab>
      <b-tab :title="$t('message.contracts.rwb_tab_transport')">
        <h5>{{ $t("message.contracts.rwb_tab_container") }}</h5>
        <div class="table-responsive">
          <b-table
            :items="RWB.container"
            :fields="rwb_container_fields"
            responsive
            striped
            hover
          >
            <template v-slot:cell(container_capacity_unit_code)="data">
              {{ data.value.display_text }}
            </template>
            <template v-slot:cell(actions)="data">
              <button
                class="btn btn-sm btn-link text-info"
                @click="edit_rwb_container(data.item, data.index)"
              >
                <i class="fa fa-edit"></i>
              </button>
              <button
                class="btn btn-link btn-sm text-danger"
                @click="remove_rwb_container(data.index)"
              >
                <i class="fa fa-trash"></i>
              </button>
            </template>
          </b-table>
        </div>
        <button
          id="rwb-transport-add-container-modal-button"
          class="btn btn-sm btn-round btn-pills btn-outline-success"
          v-b-modal.modal-add-rwb-container
        >
          {{ $t("message.add") }}
        </button>
        <br /><br />
        <h5>{{ $t("message.contracts.rwb_tab_auto") }}</h5>
        <div class="table-responsive">
          <b-table
            :items="RWB.auto"
            :fields="rwb_auto_fields"
            responsive
            striped
            hover
          >
            <template v-slot:cell(transport_nationality)="data">
              {{ data.value.display_text }}
            </template>
            <template v-slot:cell(actions)="data">
              <button
                class="btn btn-sm btn-link text-info"
                @click="edit_rwb_auto(data.item, data.index)"
              >
                <i class="fa fa-edit"></i>
              </button>
              <button
                class="btn btn-link btn-sm text-danger"
                @click="remove_rwb_auto(data.index)"
              >
                <i class="fa fa-trash"></i>
              </button>
            </template>
          </b-table>
        </div>
        <button
          id="rwb-transport-add-auto-modal-button"
          class="btn btn-sm btn-round btn-pills btn-outline-success"
          v-b-modal.modal-add-rwb-auto
        >
          {{ $t("message.add") }}
        </button>
        <br /><br />
        <h5>{{ $t("message.contracts.rwb_tab_carriage") }}</h5>
        <div class="table-responsive">
          <b-table
            :items="RWB.carriage"
            :fields="rwb_carriage_fields"
            responsive
            striped
            hover
          >
            <template v-slot:cell(actions)="data">
              <button
                class="btn btn-sm btn-link text-info"
                @click="edit_rwb_carriage(data.item, data.index)"
              >
                <i class="fa fa-edit"></i>
              </button>
              <button
                class="btn btn-link btn-sm text-danger"
                @click="remove_rwb_carriage(data.index)"
              >
                <i class="fa fa-trash"></i>
              </button>
            </template>
          </b-table>
        </div>
        <button
          id="rwb-transport-add-carriage-modal-button"
          class="btn btn-sm btn-round btn-pills btn-outline-success"
          v-b-modal.modal-add-rwb-carriage
        >
          {{ $t("message.add") }}
        </button>
      </b-tab>
      <b-tab :title="$t('message.contracts.rwb_tab_seal_stamp')">
        <h5>{{ $t("message.contracts.rwb_tab_seal") }}</h5>
        <div class="table-responsive">
          <b-table
            :items="RWB.seal"
            :fields="rwb_seal_fields"
            responsive
            striped
            hover
          >
            <template v-slot:cell(actions)="data">
              <button
                class="btn btn-sm btn-link text-info"
                @click="edit_rwb_seal(data.item, data.index)"
              >
                <i class="fa fa-edit"></i>
              </button>
              <button
                class="btn btn-link btn-sm text-danger"
                @click="remove_rwb_seal(data.index)"
              >
                <i class="fa fa-trash"></i>
              </button>
            </template>
          </b-table>
        </div>
        <button
          id="rwb-add-seal-modal-button"
          class="btn btn-sm btn-round btn-pills btn-outline-success"
          v-b-modal.modal-add-rwb-seal
        >
          {{ $t("message.add") }}
        </button>
        <br /><br />
        <h5>{{ $t("message.contracts.rwb_tab_stamps") }} 33</h5>
        <div class="table-responsive">
          <b-table
            :items="RWB.stamp33"
            :fields="rwb_stamp_fields"
            responsive
            striped
            hover
          >
            <template v-slot:cell(country)="data">
              {{ data.value.display_text }}
            </template>
            <template v-slot:cell(actions)="data">
              <button
                class="btn btn-sm btn-link text-info"
                @click="edit_rwb_stamp(data.item, data.index, 33)"
              >
                <i class="fa fa-edit"></i>
              </button>
              <button
                class="btn btn-link btn-sm text-danger"
                @click="remove_rwb_stamp(data.index, 33)"
              >
                <i class="fa fa-trash"></i>
              </button>
            </template>
          </b-table>
        </div>
        <button
          id="rwb-seals33-add-modal-button"
          class="btn btn-sm btn-round btn-pills btn-outline-success"
          v-b-modal.modal-add-rwb-stamp
          @click="current_stamp = 33"
        >
          {{ $t("message.add") }}
        </button>
        <br /><br />
        <h5>{{ $t("message.contracts.rwb_tab_stamps") }} 34</h5>
        <div class="table-responsive">
          <b-table
            :items="RWB.stamp34"
            :fields="rwb_stamp_fields"
            responsive
            striped
            hover
          >
            <template v-slot:cell(country)="data">
              {{ data.value.display_text }}
            </template>
            <template v-slot:cell(actions)="data">
              <button
                class="btn btn-sm btn-link text-info"
                @click="edit_rwb_stamp(data.item, data.index, 34)"
              >
                <i class="fa fa-edit"></i>
              </button>
              <button
                class="btn btn-link btn-sm text-danger"
                @click="remove_rwb_stamp(data.index, 34)"
              >
                <i class="fa fa-trash"></i>
              </button>
            </template>
          </b-table>
        </div>
        <button
          id="rwb-seals34-add-modal-button"
          class="btn btn-sm btn-round btn-pills btn-outline-success"
          v-b-modal.modal-add-rwb-stamp
          @click="current_stamp = 34"
        >
          {{ $t("message.add") }}
        </button>
        <br /><br />
        <h5>{{ $t("message.contracts.rwb_tab_stamps") }} 35</h5>
        <div class="table-responsive">
          <b-table
            :items="RWB.stamp35"
            :fields="rwb_stamp_fields"
            responsive
            striped
            hover
          >
            <template v-slot:cell(country)="data">
              {{ data.value.display_text }}
            </template>
            <template v-slot:cell(actions)="data">
              <button
                class="btn btn-sm btn-link text-info"
                @click="edit_rwb_stamp(data.item, data.index, 35)"
              >
                <i class="fa fa-edit"></i>
              </button>
              <button
                class="btn btn-link btn-sm text-danger"
                @click="remove_rwb_stamp(data.index, 35)"
              >
                <i class="fa fa-trash"></i>
              </button>
            </template>
          </b-table>
        </div>
        <button
          id="rwb-seals35-add-modal-button"
          class="btn btn-sm btn-round btn-pills btn-outline-success"
          v-b-modal.modal-add-rwb-stamp
          @click="current_stamp = 35"
        >
          {{ $t("message.add") }}
        </button>
      </b-tab>

      <b-tab :title="$t('message.contracts.rwb_tab_consignor_doc')">
        <h5>{{ $t("message.contracts.rwb_tab_paid_rw_code") }}</h5>
        <div class="table-responsive">
          <b-table
            :items="RWB.paid_rw_code"
            :fields="rwb_paid_rw_code_fields"
            responsive
            striped
            hover
          >
            <template v-slot:cell(from_country)="data">
              {{ data.value.display_text }}
            </template>
            <template v-slot:cell(actions)="data">
              <button
                class="btn btn-sm btn-link text-info"
                @click="edit_rwb_paid_rw_code(data.item, data.index)"
              >
                <i class="fa fa-edit"></i>
              </button>
              <button
                class="btn btn-link btn-sm text-danger"
                @click="remove_rwb_paid_rw_code(data.index)"
              >
                <i class="fa fa-trash"></i>
              </button>
            </template>
          </b-table>
        </div>
        <button
          id="rwb-rw-payments-modal-button"
          class="btn btn-sm btn-round btn-pills btn-outline-success"
          v-b-modal.modal-add-rwb-paid_rw_code
        >
          {{ $t("message.add") }}
        </button>
        <br /><br />
        <h5>{{ $t("message.contracts.rwb_tab_consignor_doc") }}</h5>
        <div class="table-responsive">
          <b-table
            :items="RWB.consignor_doc"
            :fields="rwb_consignor_doc_fields"
            responsive
            striped
            hover
          >
            <template v-slot:cell(actions)="data">
              <button
                class="btn btn-sm btn-link text-info"
                @click="edit_rwb_consignor_doc(data.item, data.index)"
              >
                <i class="fa fa-edit"></i>
              </button>
              <button
                class="btn btn-link btn-sm text-danger"
                @click="remove_rwb_consignor_doc(data.index)"
              >
                <i class="fa fa-trash"></i>
              </button>
            </template>
          </b-table>
        </div>
        <button
          id="rwb-rw-documents-modal-button"
          class="btn btn-sm btn-round btn-pills btn-outline-success"
          v-b-modal.modal-add-rwb-consignor_doc
        >
          {{ $t("message.add") }}
        </button>
      </b-tab>
    </b-tabs>
    <div
      class="buttons"
      style="position: absolute; bottom: 16px; right: 20%; left: 20px"
    >
      <button
        class="btn btn-outline-success btn-sm dropdown-toggle"
        type="button"
        id="dropdownMenuButton"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
        :disabled="buttons_loading"
      >
        {{
          $t(
            is_new
              ? "message.contracts.document_create"
              : "message.contracts.document_save",
          )
        }}&nbsp;&nbsp;
        <div
          class="loading loading-button"
          v-if="loading"
          style="
            border-top-width: 2px;
            border-top-color: #4caf50;
            top: 30px;
            right: -93px;
          "
        ></div>
      </button>
      <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
        <a
          id="create-rwb-button"
          class="dropdown-item"
          style="color: #4caf50"
          @click="saveDocument()"
          :disabled="buttons_loading"
          >{{
            $t(
              is_new
                ? "message.contracts.document_create"
                : "message.contracts.document_save",
            )
          }}</a
        >
      </div>
      <!--<button class="btn btn-success float-left" @click="saveDocument()" :disabled=buttons_loading>{{$t(is_new?'message.contracts.document_create':'message.contracts.document_save')}}</button>-->
      <!-- <button v-if="!is_new" class="btn btn-success float-left" @click="submit_and_sign_dialog()" :disabled=buttons_loading>{{$t('message.contracts.submit_and_sign_button')}}</button> -->
      <!-- <button class="btn btn-info float-right" @click="exportEfreight()">e-Freight</button> -->
    </div>
    <b-modal
      id="modal-select-ecp-type-invoice"
      :hide-footer="true"
      size="sm"
      :title="$t('message.contracts.select_ecp_type')"
    >
      <div class="text-center" v-if="!show_code_sign_type">
        <button
          class="btn btn-outline-success btn-round"
          @click="signDocument()"
        >
          {{ $t("message.contracts.sign_with_ecp") }}
        </button>
        <div>
          <small>
            <i>
              {{ $t("message.contracts.only_for_kz") }}
            </i>
          </small>
        </div>
        <hr />
        <button
          class="btn btn-outline-success btn-round"
          @click="sign_with_code()"
        >
          {{ $t("message.contracts.sign_with_code") }}
        </button>
      </div>
      <div class="text-center" v-if="show_code_sign_type">
        <div class="form-group">
          <label for="input-code">
            {{ $t("message.contracts.input_signature_code") }}
          </label>
          <input
            type="text"
            class="form-control"
            id="input-code"
            v-model="sign_with_code_code"
          />
        </div>
        <button
          class="btn btn-success btn-round"
          @click="sign_with_code_phase2()"
        >
          {{ $t("message.contracts.sign_with_code") }}
        </button>
        <hr />
        <button
          class="btn btn-default btn-round btn-sm"
          @click="show_code_sign_type = false"
        >
          {{ $t("message.cancel") }}
        </button>
      </div>
    </b-modal>

    <b-modal
      id="modal-add-rwb-good"
      :hide-footer="true"
      size="md"
      :title="$t('message.add')"
    >
      <div class="row">
        <div class="col-md-6">
          <span :class="['bmd-form-group mb-1 d-block form-label-group']">
            <label
              for="rwb_good_container_indicator"
              :class="[
                'form-label-group-label shorter',
                rwb_good.container_indicator != '' ? 'high' : '',
              ]"
              >{{ $t("message.contracts.rwb_good_container_indicator") }}</label
            >
            <cleave
              id="rwb_good_container_indicator"
              v-model="rwb_good.container_indicator"
              :options="cleaveInt"
              class="form-control"
              :placeholder="
                $t('message.contracts.rwb_good_container_indicator')
              "
              autocomplete="off"
              style="cursor: auto"
            ></cleave>
          </span>
        </div>
        <div class="col-md-6">
          <span :class="['bmd-form-group mb-2 d-block form-label-group']">
            <input
              type="text"
              class="form-control"
              v-model="rwb_good.work_tool_description"
              :placeholder="
                $t('message.contracts.rwb_good_work_tool_description')
              "
              autocomplete="off"
              style="cursor: auto"
              id="rwb_good_work_tool_description"
            />
            <label
              for="rwb_good_work_tool_description"
              class="form-label-group-label shorter"
              >{{
                $t("message.contracts.rwb_good_work_tool_description")
              }}</label
            >
          </span>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <span :class="['bmd-form-group mb-2 d-block form-label-group']">
            <input
              type="text"
              class="form-control"
              v-model="rwb_good.conductor_description"
              :placeholder="
                $t('message.contracts.rwb_good_conductor_description')
              "
              autocomplete="off"
              style="cursor: auto"
              id="rwb_good_conductor_description"
            />
            <label
              for="rwb_good_conductor_description"
              class="form-label-group-label shorter"
              >{{
                $t("message.contracts.rwb_good_conductor_description")
              }}</label
            >
          </span>
        </div>
        <div class="col-md-6">
          <span :class="['bmd-form-group mb-1 d-block form-label-group']">
            <label
              for="rwb_good_place_goods_quantity"
              :class="[
                'form-label-group-label shorter',
                rwb_good.place_goods_quantity != '' ? 'high' : '',
              ]"
              >{{
                $t("message.contracts.rwb_good_place_goods_quantity")
              }}</label
            >
            <cleave
              id="rwb_good_place_goods_quantity"
              v-model="rwb_good.place_goods_quantity"
              :options="cleaveWeight"
              class="form-control"
              :placeholder="
                $t('message.contracts.rwb_good_place_goods_quantity')
              "
              autocomplete="off"
              style="cursor: auto"
            ></cleave>
          </span>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <span :class="['bmd-form-group mb-1 d-block form-label-group']">
            <label
              for="rwb_good_places_quantity"
              :class="[
                'form-label-group-label shorter',
                rwb_good.places_quantity != '' ? 'high' : '',
              ]"
              >{{ $t("message.contracts.rwb_good_places_quantity") }}</label
            >
            <cleave
              id="rwb_good_places_quantity"
              v-model="rwb_good.places_quantity"
              :options="cleaveWeight"
              class="form-control"
              :placeholder="$t('message.contracts.rwb_good_places_quantity')"
              autocomplete="off"
              style="cursor: auto"
            ></cleave>
          </span>
        </div>
        <div class="col-md-6">
          <span :class="['bmd-form-group mb-1 d-block form-label-group']">
            <label
              for="rwb_good_gross_weight_quantity"
              :class="[
                'form-label-group-label shorter',
                rwb_good.gross_weight_quantity != '' ? 'high' : '',
              ]"
              >{{
                $t("message.contracts.rwb_good_gross_weight_quantity")
              }}</label
            >
            <cleave
              id="rwb_good_gross_weight_quantity"
              v-model="rwb_good.gross_weight_quantity"
              :options="cleaveWeight"
              class="form-control"
              :placeholder="
                $t('message.contracts.rwb_good_gross_weight_quantity')
              "
              autocomplete="off"
              style="cursor: auto"
            ></cleave>
          </span>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <span :class="['bmd-form-group mb-2 d-block form-label-group']">
            <input
              type="text"
              class="form-control"
              v-model="rwb_good.places_description"
              :placeholder="$t('message.contracts.rwb_good_places_description')"
              autocomplete="off"
              style="cursor: auto"
              id="rwb_good_places_description"
            />
            <label
              for="rwb_good_places_description"
              class="form-label-group-label shorter"
              >{{ $t("message.contracts.rwb_good_places_description") }}</label
            >
          </span>
        </div>
        <div class="col-md-6">
          <span :class="['bmd-form-group mb-1 d-block form-label-group']">
            <label
              for="rwb_good_harmonized_range_goods"
              :class="[
                'form-label-group-label shorter',
                rwb_good.harmonized_range_goods != '' ? 'high' : '',
              ]"
              >{{
                $t("message.contracts.rwb_good_harmonized_range_goods")
              }}</label
            >
            <cleave
              id="rwb_good_harmonized_range_goods"
              v-model="rwb_good.harmonized_range_goods"
              :options="cleaveWeight"
              class="form-control"
              :placeholder="
                $t('message.contracts.rwb_good_harmonized_range_goods')
              "
              autocomplete="off"
              style="cursor: auto"
            ></cleave>
          </span>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <span :class="['bmd-form-group mb-2 d-block form-label-group']">
            <input
              type="text"
              class="form-control"
              v-model="rwb_good.packing"
              :placeholder="$t('message.contracts.rwb_good_packing')"
              autocomplete="off"
              style="cursor: auto"
              id="rwb_good_packing"
            />
            <label
              for="rwb_good_packing"
              class="form-label-group-label shorter"
              >{{ $t("message.contracts.rwb_good_packing") }}</label
            >
          </span>
        </div>
        <div class="col-md-6">
          <span :class="['bmd-form-group mb-2 d-block form-label-group']">
            <input
              type="text"
              class="form-control"
              v-model="rwb_good.marking"
              :placeholder="$t('message.contracts.rwb_good_marking')"
              autocomplete="off"
              style="cursor: auto"
              id="rwb_good_marking"
            />
            <label
              for="rwb_good_marking"
              class="form-label-group-label shorter"
              >{{ $t("message.contracts.rwb_good_marking") }}</label
            >
          </span>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <span :class="['bmd-form-group mb-2 d-block form-label-group']">
            <input
              type="text"
              class="form-control"
              v-model="rwb_good.carriage_number"
              :placeholder="$t('message.contracts.rwb_good_carriage_number')"
              autocomplete="off"
              style="cursor: auto"
              id="rwb_good_carriage_number"
            />
            <label
              for="rwb_good_carriage_number"
              class="form-label-group-label shorter"
              >{{ $t("message.contracts.rwb_good_carriage_number") }}</label
            >
          </span>
        </div>
        <div class="col-md-6">
          <span :class="['bmd-form-group mb-2 d-block form-label-group']">
            <input
              type="text"
              class="form-control"
              v-model="rwb_good.container_number"
              :placeholder="$t('message.contracts.rwb_good_container_number')"
              autocomplete="off"
              style="cursor: auto"
              id="rwb_good_container_number"
            />
            <label
              for="rwb_good_container_number"
              class="form-label-group-label shorter"
              >{{ $t("message.contracts.rwb_good_container_number") }}</label
            >
          </span>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <span :class="['bmd-form-group mb-1 d-block form-label-group']">
            <label
              for="rwb_good_goods_numeric"
              :class="[
                'form-label-group-label shorter',
                rwb_good.goods_numeric != '' ? 'high' : '',
              ]"
              >{{ $t("message.contracts.rwb_good_goods_numeric") }}</label
            >
            <cleave
              id="rwb_good_goods_numeric"
              v-model="rwb_good.goods_numeric"
              :options="cleaveInt"
              class="form-control"
              :placeholder="$t('message.contracts.rwb_good_goods_numeric')"
              autocomplete="off"
              style="cursor: auto"
            ></cleave>
          </span>
        </div>
        <div class="col-md-6">
          <span :class="['bmd-form-group mb-2 d-block form-label-group']">
            <input
              type="text"
              class="form-control"
              v-model="rwb_good.customs_code"
              :placeholder="$t('message.contracts.rwb_good_customs_code')"
              autocomplete="off"
              style="cursor: auto"
              id="rwb_good_customs_code"
            />
            <label
              for="rwb_good_customs_code"
              class="form-label-group-label shorter"
              >{{ $t("message.contracts.rwb_good_customs_code") }}</label
            >
          </span>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <span :class="['bmd-form-group mb-1 d-block form-label-group']">
            <label
              for="rwb_good_gtd_number"
              :class="[
                'form-label-group-label shorter',
                rwb_good.gtd_number != '' ? 'high' : '',
              ]"
              >{{ $t("message.contracts.rwb_good_gtd_number") }}</label
            >
            <cleave
              id="rwb_good_gtd_number"
              v-model="rwb_good.gtd_number"
              :options="cleaveInt"
              class="form-control"
              :placeholder="$t('message.contracts.rwb_good_gtd_number')"
              autocomplete="off"
              style="cursor: auto"
            ></cleave>
          </span>
        </div>
        <div class="col-md-6">
          <span :class="['bmd-form-group mb-1 d-block form-label-group']">
            <label
              for="rwb_good_gcost"
              :class="[
                'form-label-group-label shorter',
                rwb_good.gcost != '' ? 'high' : '',
              ]"
              >{{ $t("message.contracts.rwb_good_gcost") }}</label
            >
            <cleave
              id="rwb_good_gcost"
              v-model="rwb_good.gcost"
              :options="cleaveWeight"
              class="form-control"
              :placeholder="$t('message.contracts.rwb_good_gcost')"
              autocomplete="off"
              style="cursor: auto"
            ></cleave>
          </span>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <span
            :class="[
              'bmd-form-group mb-2 d-block form-label-group',
              rwb_good_currency_focused ? 'focused' : '',
            ]"
          >
            <v-select
              id="rwb_good_currency"
              :options="currencies"
              label="display_text"
              :class="[
                'form-control ',
                typeof rwb_good.currency !== 'undefined' &&
                rwb_good.currency.value !== ''
                  ? 'vs--selected'
                  : '',
              ]"
              v-model="rwb_good.currency"
              :placeholder="$t('message.contracts.rwb_good_currency')"
              @focus="rwb_good_currency_focused = true"
              @blur="rwb_good_currency_focused = false"
            ></v-select>
            <label
              for="rwb_good_currency"
              class="form-label-group-label shorter"
              >{{ $t("message.contracts.rwb_good_currency") }}</label
            >
          </span>
        </div>
        <div class="col-md-6">
          <span :class="['bmd-form-group mb-2 d-block form-label-group']">
            <input
              type="text"
              class="form-control"
              v-model="rwb_good.mrn"
              :placeholder="$t('message.contracts.rwb_good_mrn')"
              autocomplete="off"
              style="cursor: auto"
              id="rwb_good_mrn"
            />
            <label for="rwb_good_mrn" class="form-label-group-label shorter">{{
              $t("message.contracts.rwb_good_mrn")
            }}</label>
          </span>
        </div>
      </div>
      <button v-if="is_good_edit" @click="save_good()" class="btn btn-success">
        {{ $t("message.add") }}
      </button>
      <button
        id="add-rwb-good-button"
        v-else
        @click="add_good()"
        class="btn btn-success"
      >
        {{ $t("message.add") }}
      </button>
    </b-modal>

    <b-modal
      id="modal-add-rwb-carrier"
      :hide-footer="true"
      size="md"
      :title="$t('message.add')"
    >
      <div class="row">
        <div class="col-md-2">
          <span :class="['bmd-form-group mb-1 d-block form-label-group']">
            <input
              type="text"
              class="form-control"
              v-model="rwb_carrier.id"
              :placeholder="$t('message.contracts.rwb_carrier_id')"
              autocomplete="off"
              style="cursor: auto"
              id="rwb_carrier_id"
            />
            <label
              for="rwb_carrier_id"
              class="form-label-group-label shorter"
              >{{ $t("message.contracts.rwb_carrier_id") }}</label
            >
          </span>
        </div>
        <div class="col-md-5">
          <span :class="['bmd-form-group mb-2 d-block form-label-group']">
            <input
              type="text"
              class="form-control"
              v-model="rwb_carrier.carrier_name"
              :placeholder="$t('message.contracts.rwb_carrier_carrier_name')"
              autocomplete="off"
              style="cursor: auto"
              id="rwb_carrier_carrier_name"
            />
            <label
              for="rwb_carrier_carrier_name"
              class="form-label-group-label shorter"
              >{{ $t("message.contracts.rwb_carrier_carrier_name") }}</label
            >
          </span>
        </div>
        <div class="col-md-5">
          <span :class="['bmd-form-group mb-2 d-block form-label-group']">
            <input
              type="text"
              class="form-control"
              v-model="rwb_carrier.carrier_code"
              :placeholder="$t('message.contracts.rwb_carrier_carrier_code')"
              autocomplete="off"
              style="cursor: auto"
              id="rwb_carrier_carrier_code"
            />
            <label
              for="rwb_carrier_carrier_code"
              class="form-label-group-label shorter"
              >{{ $t("message.contracts.rwb_carrier_carrier_code") }}</label
            >
          </span>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <span :class="['bmd-form-group mb-2 d-block form-label-group']">
            <input
              type="text"
              class="form-control"
              v-model="rwb_carrier.from_station_code"
              :placeholder="
                $t('message.contracts.rwb_carrier_from_station_code')
              "
              autocomplete="off"
              style="cursor: auto"
              id="rwb_carrier_from_station_code"
            />
            <label
              for="rwb_carrier_from_station_code"
              class="form-label-group-label shorter"
              >{{
                $t("message.contracts.rwb_carrier_from_station_code")
              }}</label
            >
          </span>
        </div>
        <div class="col-md-6">
          <span :class="['bmd-form-group mb-1 d-block form-label-group']">
            <input
              type="text"
              class="form-control"
              v-model="rwb_carrier.from_station_name"
              :placeholder="
                $t('message.contracts.rwb_carrier_from_station_name')
              "
              autocomplete="off"
              style="cursor: auto"
              id="rwb_carrier_from_station_name"
            />
            <label
              for="rwb_carrier_from_station_name"
              class="form-label-group-label shorter"
              >{{
                $t("message.contracts.rwb_carrier_from_station_name")
              }}</label
            >
          </span>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <span :class="['bmd-form-group mb-2 d-block form-label-group']">
            <input
              type="text"
              class="form-control"
              v-model="rwb_carrier.from_rw_name"
              :placeholder="$t('message.contracts.rwb_carrier_from_rw_name')"
              autocomplete="off"
              style="cursor: auto"
              id="rwb_carrier_from_rw_name"
            />
            <label
              for="rwb_carrier_from_rw_name"
              class="form-label-group-label shorter"
              >{{ $t("message.contracts.rwb_carrier_from_rw_name") }}</label
            >
          </span>
        </div>
        <div class="col-md-6">
          <span
            :class="[
              'bmd-form-group mb-2 d-block form-label-group shorter',
              carrier_from_country_focused ? 'focused' : '',
            ]"
          >
            <v-select
              id="rwb_carrier_from_country"
              :options="countries"
              label="display_text"
              :class="[
                'form-control',
                typeof rwb_carrier.from_country !== 'undefined' &&
                rwb_carrier.from_country.value !== ''
                  ? 'vs--selected'
                  : '',
              ]"
              @search="fetchCountries"
              v-model="rwb_carrier.from_country"
              :placeholder="$t('message.contracts.rwb_carrier_from_country')"
              @focus="carrier_from_country_focused = true"
              @blur="carrier_from_country_focused = false"
            ></v-select>
            <label
              for="rwb_carrier_from_country"
              class="form-label-group-label shorter"
              >{{ $t("message.contracts.rwb_carrier_from_country") }}</label
            >
          </span>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <span :class="['bmd-form-group mb-2 d-block form-label-group']">
            <input
              type="text"
              class="form-control"
              v-model="rwb_carrier.to_station_code"
              :placeholder="$t('message.contracts.rwb_carrier_to_station_code')"
              autocomplete="off"
              style="cursor: auto"
              id="rwb_carrier_to_station_code"
            />
            <label
              for="rwb_carrier_to_station_code"
              class="form-label-group-label shorter"
              >{{ $t("message.contracts.rwb_carrier_to_station_code") }}</label
            >
          </span>
        </div>
        <div class="col-md-6">
          <span :class="['bmd-form-group mb-1 d-block form-label-group']">
            <input
              type="text"
              class="form-control"
              v-model="rwb_carrier.to_station_name"
              :placeholder="$t('message.contracts.rwb_carrier_to_station_name')"
              autocomplete="off"
              style="cursor: auto"
              id="rwb_carrier_to_station_name"
            />
            <label
              for="rwb_carrier_to_station_name"
              class="form-label-group-label shorter"
              >{{ $t("message.contracts.rwb_carrier_to_station_name") }}</label
            >
          </span>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <span :class="['bmd-form-group mb-2 d-block form-label-group']">
            <input
              type="text"
              class="form-control"
              v-model="rwb_carrier.to_rw_name"
              :placeholder="$t('message.contracts.rwb_carrier_to_rw_name')"
              autocomplete="off"
              style="cursor: auto"
              id="rwb_carrier_to_rw_name"
            />
            <label
              for="rwb_carrier_to_rw_name"
              class="form-label-group-label shorter"
              >{{ $t("message.contracts.rwb_carrier_to_rw_name") }}</label
            >
          </span>
        </div>
        <div class="col-md-6">
          <span
            :class="[
              'bmd-form-group mb-2 d-block form-label-group shorter',
              carrier_to_country_focused ? 'focused' : '',
            ]"
          >
            <v-select
              id="rwb_carrier_to_country"
              :options="countries"
              label="display_text"
              :class="[
                'form-control',
                typeof rwb_carrier.to_country !== 'undefined' &&
                rwb_carrier.to_country.value !== ''
                  ? 'vs--selected'
                  : '',
              ]"
              @search="fetchCountries"
              v-model="rwb_carrier.to_country"
              :placeholder="$t('message.contracts.rwb_carrier_to_country')"
              @focus="carrier_to_country_focused = true"
              @blur="carrier_to_country_focused = false"
            ></v-select>
            <label
              for="rwb_carrier_to_country"
              class="form-label-group-label shorter"
              >{{ $t("message.contracts.rwb_carrier_to_country") }}</label
            >
          </span>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <h5>{{ $t("message.contracts.rwb_carrier_tech_station") }}</h5>
          <div class="table-responsive">
            <b-table
              :items="rwb_carrier.tech_station"
              :fields="rwb_carrier_tech_station_fields"
            >
              <template v-slot:cell(country)="data">
                {{ data.value.display_text }}
              </template>
              <template v-slot:cell(actions)="data">
                <button
                  class="btn btn-sm btn-link text-info"
                  @click="edit_rwb_carrier_tech_station(data.item, data.index)"
                >
                  <i class="fa fa-edit"></i>
                </button>
                <button
                  class="btn btn-link btn-sm text-danger"
                  @click="remove_rwb_carrier_tech_station(data.index)"
                >
                  <i class="fa fa-trash"></i>
                </button>
              </template>
            </b-table>
          </div>

          <button
            id="rwb-technical-station-open-modal-button"
            class="btn btn-sm btn-round btn-pills btn-outline-success"
            v-b-modal.modal-add-rwb-carrier-tech-station
          >
            {{ $t("message.add") }}
          </button>
        </div>
      </div>
      <br /><br />
      <button
        v-if="is_carrier_edit"
        @click="save_carrier()"
        class="btn btn-success"
      >
        {{ $t("message.add") }}
      </button>
      <button
        id="rwb-carrier-add-button"
        v-else
        @click="add_carrier()"
        class="btn btn-success"
      >
        {{ $t("message.add") }}
      </button>
    </b-modal>

    <b-modal
      id="modal-add-rwb-carrier-tech-station"
      :hide-footer="true"
      size="md"
      :title="$t('message.add')"
    >
      <div class="row">
        <div class="col-md-6">
          <span :class="['bmd-form-group mb-1 d-block form-label-group']">
            <label
              for="rwb_carrier_tech_station_order_number"
              :class="[
                'form-label-group-label shorter',
                rwb_carrier_tech_station.order_number != '' ? 'high' : '',
              ]"
              >{{
                $t("message.contracts.rwb_carrier_tech_station_order_number")
              }}</label
            >
            <cleave
              id="rwb_carrier_tech_station_order_number"
              v-model="rwb_carrier_tech_station.order_number"
              :options="cleaveInt"
              class="form-control"
              :placeholder="
                $t('message.contracts.rwb_carrier_tech_station_order_number')
              "
              autocomplete="off"
              style="cursor: auto"
            ></cleave>
          </span>
        </div>
        <div class="col-md-6">
          <span :class="['bmd-form-group mb-1 d-block form-label-group']">
            <input
              type="text"
              class="form-control"
              v-model="rwb_carrier_tech_station.tech_signs"
              :placeholder="
                $t('message.contracts.rwb_carrier_tech_station_tech_signs')
              "
              autocomplete="off"
              style="cursor: auto"
              id="rwb_carrier_tech_station_tech_signs"
            />
            <label
              for="rwb_carrier_tech_station_tech_signs"
              class="form-label-group-label shorter"
              >{{
                $t("message.contracts.rwb_carrier_tech_station_tech_signs")
              }}</label
            >
          </span>
        </div>
        <!--<div class="col-md-6">
					<span :class="['bmd-form-group mb-1 d-block form-label-group']">
						<input type="text" class="form-control" v-model="rwb_carrier_tech_station.station_code" :placeholder="$t('message.contracts.rwb_carrier_tech_station_station_code')" autocomplete="off" style="cursor: auto;" id="rwb_carrier_tech_station_station_code">
						<label for="rwb_carrier_tech_station_station_code" class="form-label-group-label shorter">{{$t('message.contracts.rwb_carrier_tech_station_station_code')}}</label>
					</span>	
				</div>
				<div class="col-md-6">
					<span :class="['bmd-form-group mb-1 d-block form-label-group']">
						<input type="text" class="form-control" v-model="rwb_carrier_tech_station.station_name" :placeholder="$t('message.contracts.rwb_carrier_tech_station_station_name')" autocomplete="off" style="cursor: auto;" id="rwb_carrier_tech_station_station_name">
						<label for="rwb_carrier_tech_station_station_name" class="form-label-group-label shorter">{{$t('message.contracts.rwb_carrier_tech_station_station_name')}}</label>
					</span>	
				</div> -->
        <div class="col-md-12">
          <code-value
            :label="
              $t('message.contracts.rwb_carrier_tech_station_station_name')
            "
            :value_placeholder="
              $t('message.contracts.rwb_carrier_tech_station_station_name')
            "
            :code_placeholder="
              $t('message.contracts.rwb_carrier_tech_station_station_code')
            "
            type="rw_station"
            code_class="col-6"
            message_class="col-6"
            v-model="rwb_carrier_tech_station.station"
          ></code-value>
          <!--
					<span :class="['bmd-form-group mb-2 d-block form-label-group shorter',  rwb_carrier_tech_station_focused?'focused':'']">
						<v-select id="rwb_carrier_tech_station" :options="rw_stations" label="display_text" :class="['form-control', typeof rwb_carrier_tech_station.station !== 'undefined' && rwb_carrier_tech_station.station.value!==''?'vs--selected':'']" @search="fetchStations"  v-model="rwb_carrier_tech_station.station" :placeholder="$t('message.contracts.rwb_carrier_tech_station_station_name')" @focus="rwb_carrier_tech_station_focused=true" @blur="rwb_carrier_tech_station_focused=false"></v-select>	
						<label for="rwb_carrier_tech_station" class="form-label-group-label shorter">{{$t('message.contracts.rwb_carrier_tech_station_station_name')}}</label>
					</span> -->
        </div>
        <div class="col-md-6">
          <span :class="['bmd-form-group mb-1 d-block form-label-group']">
            <input
              type="text"
              class="form-control"
              v-model="rwb_carrier_tech_station.rw_name"
              :placeholder="
                $t('message.contracts.rwb_carrier_tech_station_rw_name')
              "
              autocomplete="off"
              style="cursor: auto"
              id="rwb_carrier_tech_station_rw_name"
            />
            <label
              for="rwb_carrier_tech_station_rw_name"
              class="form-label-group-label shorter"
              >{{
                $t("message.contracts.rwb_carrier_tech_station_rw_name")
              }}</label
            >
          </span>
        </div>
        <div class="col-md-6">
          <span
            :class="[
              'bmd-form-group mb-2 d-block form-label-group shorter',
              carrier_tech_station_country_focused ? 'focused' : '',
            ]"
          >
            <v-select
              id="rwb_carrier_tech_station_country"
              :options="countries"
              label="display_text"
              :class="[
                'form-control',
                typeof rwb_carrier_tech_station.country !== 'undefined' &&
                rwb_carrier_tech_station.country.value !== ''
                  ? 'vs--selected'
                  : '',
              ]"
              @search="fetchCountries"
              v-model="rwb_carrier_tech_station.country"
              :placeholder="
                $t('message.contracts.rwb_carrier_tech_station_country')
              "
              @focus="carrier_tech_station_country_focused = true"
              @blur="carrier_tech_station_country_focused = false"
            ></v-select>
            <label
              for="rwb_carrier_tech_station_country"
              class="form-label-group-label shorter"
              >{{
                $t("message.contracts.rwb_carrier_tech_station_country")
              }}</label
            >
          </span>
        </div>
      </div>
      <button
        v-if="is_carrier_station_edit"
        @click="save_carrier_station()"
        class="btn btn-success"
      >
        {{ $t("message.add") }}
      </button>
      <button
        id="rwb-add-tech-station-button"
        v-else
        @click="add_carrier_tech_station()"
        class="btn btn-success"
      >
        {{ $t("message.add") }}
      </button>
    </b-modal>

    <b-modal
      id="modal-add-rwb-container"
      :hide-footer="true"
      size="md"
      :title="$t('message.add')"
    >
      <div class="row">
        <div class="col-md-6">
          <span :class="['bmd-form-group mb-1 d-block form-label-group']">
            <input
              type="text"
              class="form-control"
              v-model="rwb_container.container_id"
              :placeholder="$t('message.contracts.rwb_container_container_id')"
              autocomplete="off"
              style="cursor: auto"
              id="rwb_container_container_id"
            />
            <label
              for="rwb_container_container_id"
              class="form-label-group-label shorter"
              >{{ $t("message.contracts.rwb_container_container_id") }}</label
            >
          </span>
        </div>
        <div class="col-md-6">
          <span :class="['bmd-form-group mb-2 d-block form-label-group']">
            <input
              type="text"
              class="form-control"
              v-model="rwb_container.rw_code"
              :placeholder="$t('message.contracts.rwb_container_rw_code')"
              autocomplete="off"
              style="cursor: auto"
              id="rwb_container_rw_code"
            />
            <label
              for="rwb_container_rw_code"
              class="form-label-group-label shorter"
              >{{ $t("message.contracts.rwb_container_rw_code") }}</label
            >
          </span>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <span :class="['bmd-form-group mb-1 d-block form-label-group']">
            <input
              type="text"
              class="form-control"
              v-model="rwb_container.container_kind"
              :placeholder="
                $t('message.contracts.rwb_container_container_kind')
              "
              autocomplete="off"
              style="cursor: auto"
              id="rwb_container_container_kind"
            />
            <label
              for="rwb_container_container_kind"
              class="form-label-group-label shorter"
              >{{ $t("message.contracts.rwb_container_container_kind") }}</label
            >
          </span>
        </div>
        <div class="col-md-6">
          <span :class="['bmd-form-group mb-2 d-block form-label-group']">
            <input
              type="text"
              class="form-control"
              v-model="rwb_container.container_mode_desc"
              :placeholder="
                $t('message.contracts.rwb_container_container_mode_desc')
              "
              autocomplete="off"
              style="cursor: auto"
              id="rwb_container_container_mode_desc"
            />
            <label
              for="rwb_container_container_mode_desc"
              class="form-label-group-label shorter"
              >{{
                $t("message.contracts.rwb_container_container_mode_desc")
              }}</label
            >
          </span>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <span :class="['bmd-form-group mb-1 d-block form-label-group']">
            <label
              for="rwb_container_container_capacity"
              :class="[
                'form-label-group-label shorter',
                rwb_container.container_capacity != '' ? 'high' : '',
              ]"
              >{{
                $t("message.contracts.rwb_container_container_capacity")
              }}</label
            >
            <cleave
              id="rwb_container_container_capacity"
              v-model="rwb_container.container_capacity"
              :options="cleaveWeight"
              class="form-control"
              :placeholder="
                $t('message.contracts.rwb_container_container_capacity')
              "
              autocomplete="off"
              style="cursor: auto"
            ></cleave>
          </span>
        </div>
        <div class="col-md-6">
          <span
            :class="[
              'bmd-form-group mb-2 d-block form-label-group',
              rwb_container_container_capacity_unit_code_focused
                ? 'focused'
                : '',
            ]"
          >
            <v-select
              id="rwb_container_currency"
              :options="measures"
              label="display_text"
              :class="[
                'form-control ',
                typeof rwb_container.container_capacity_unit_code !==
                  'undefined' &&
                rwb_container.container_capacity_unit_code.value !== ''
                  ? 'vs--selected'
                  : '',
              ]"
              v-model="rwb_container.container_capacity_unit_code"
              :placeholder="
                $t(
                  'message.contracts.rwb_container_container_capacity_unit_code',
                )
              "
              @focus="rwb_container_container_capacity_unit_code_focused = true"
              @blur="rwb_container_container_capacity_unit_code_focused = false"
            ></v-select>
            <label
              for="rwb_container_container_capacity_unit_code"
              class="form-label-group-label shorter"
              >{{
                $t(
                  "message.contracts.rwb_container_container_capacity_unit_code",
                )
              }}</label
            >
          </span>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <span :class="['bmd-form-group mb-1 d-block form-label-group']">
            <label
              for="rwb_container_tare"
              :class="[
                'form-label-group-label shorter',
                rwb_container.tare != '' ? 'high' : '',
              ]"
              >{{ $t("message.contracts.rwb_container_tare") }}</label
            >
            <cleave
              id="rwb_container_tare"
              v-model="rwb_container.tare"
              :options="cleaveWeight"
              class="form-control"
              :placeholder="$t('message.contracts.rwb_container_tare')"
              autocomplete="off"
              style="cursor: auto"
            ></cleave>
          </span>
        </div>
        <div class="col-md-6">
          <span :class="['bmd-form-group mb-1 d-block form-label-group']">
            <label
              for="rwb_container_goods_weight"
              :class="[
                'form-label-group-label shorter',
                rwb_container.goods_weight != '' ? 'high' : '',
              ]"
              >{{ $t("message.contracts.rwb_container_goods_weight") }}</label
            >
            <cleave
              id="rwb_container_goods_weight"
              v-model="rwb_container.goods_weight"
              :options="cleaveWeight"
              class="form-control"
              :placeholder="$t('message.contracts.rwb_container_goods_weight')"
              autocomplete="off"
              style="cursor: auto"
            ></cleave>
          </span>
        </div>
      </div>

      <div class="row">
        <div class="col-md-4">
          <span :class="['bmd-form-group mb-1 d-block form-label-group']">
            <label
              for="rwb_container_places_quentity"
              :class="[
                'form-label-group-label shorter',
                rwb_container.places_quentity != '' ? 'high' : '',
              ]"
              >{{
                $t("message.contracts.rwb_container_places_quentity")
              }}</label
            >
            <cleave
              id="rwb_container_places_quentity"
              v-model="rwb_container.places_quentity"
              :options="cleaveWeight"
              class="form-control"
              :placeholder="
                $t('message.contracts.rwb_container_places_quentity')
              "
              autocomplete="off"
              style="cursor: auto"
            ></cleave>
          </span>
        </div>
        <div class="col-md-4">
          <span :class="['bmd-form-group mb-1 d-block form-label-group']">
            <label
              for="rwb_container_pocket_quentity"
              :class="[
                'form-label-group-label shorter',
                rwb_container.pocket_quentity != '' ? 'high' : '',
              ]"
              >{{
                $t("message.contracts.rwb_container_pocket_quentity")
              }}</label
            >
            <cleave
              id="rwb_container_pocket_quentity"
              v-model="rwb_container.pocket_quentity"
              :options="cleaveWeight"
              class="form-control"
              :placeholder="
                $t('message.contracts.rwb_container_pocket_quentity')
              "
              autocomplete="off"
              style="cursor: auto"
            ></cleave>
          </span>
        </div>
        <div class="col-md-4">
          <span :class="['bmd-form-group mb-1 d-block form-label-group']">
            <label
              for="rwb_container_container_length"
              :class="[
                'form-label-group-label shorter',
                rwb_container.container_length != '' ? 'high' : '',
              ]"
              >{{
                $t("message.contracts.rwb_container_container_length")
              }}</label
            >
            <cleave
              id="rwb_container_container_length"
              v-model="rwb_container.container_length"
              :options="cleaveWeight"
              class="form-control"
              :placeholder="
                $t('message.contracts.rwb_container_container_length')
              "
              autocomplete="off"
              style="cursor: auto"
            ></cleave>
          </span>
        </div>
      </div>

      <button
        v-if="is_rwb_container_edit"
        @click="save_container()"
        class="btn btn-success"
      >
        {{ $t("message.add") }}
      </button>
      <button
        id="rwb-add-container-button"
        v-else
        @click="add_container()"
        class="btn btn-success"
      >
        {{ $t("message.add") }}
      </button>
    </b-modal>

    <b-modal
      id="modal-add-rwb-auto"
      :hide-footer="true"
      size="md"
      :title="$t('message.add')"
    >
      <div class="row">
        <div class="col-md-6">
          <span :class="['bmd-form-group mb-1 d-block form-label-group']">
            <input
              type="text"
              class="form-control"
              v-model="rwb_auto.vin"
              :placeholder="$t('message.contracts.rwb_auto_vin')"
              autocomplete="off"
              style="cursor: auto"
              id="rwb_auto_vin"
            />
            <label for="rwb_auto_vin" class="form-label-group-label shorter">{{
              $t("message.contracts.rwb_auto_vin")
            }}</label>
          </span>
        </div>
        <div class="col-md-6">
          <span :class="['bmd-form-group mb-2 d-block form-label-group']">
            <input
              type="text"
              class="form-control"
              v-model="rwb_auto.transport_kind"
              :placeholder="$t('message.contracts.rwb_auto_transport_kind')"
              autocomplete="off"
              style="cursor: auto"
              id="rwb_auto_transport_kind"
            />
            <label
              for="rwb_auto_transport_kind"
              class="form-label-group-label shorter"
              >{{ $t("message.contracts.rwb_auto_transport_kind") }}</label
            >
          </span>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <span :class="['bmd-form-group mb-1 d-block form-label-group']">
            <input
              type="text"
              class="form-control"
              v-model="rwb_auto.transport_mark"
              :placeholder="$t('message.contracts.rwb_auto_transport_mark')"
              autocomplete="off"
              style="cursor: auto"
              id="rwb_auto_transport_mark"
            />
            <label
              for="rwb_auto_transport_mark"
              class="form-label-group-label shorter"
              >{{ $t("message.contracts.rwb_auto_transport_mark") }}</label
            >
          </span>
        </div>
        <div class="col-md-6">
          <span :class="['bmd-form-group mb-2 d-block form-label-group']">
            <input
              type="text"
              class="form-control"
              v-model="rwb_auto.transport_identifier"
              :placeholder="
                $t('message.contracts.rwb_auto_transport_identifier')
              "
              autocomplete="off"
              style="cursor: auto"
              id="rwb_auto_transport_identifier"
            />
            <label
              for="rwb_auto_transport_identifier"
              class="form-label-group-label shorter"
              >{{
                $t("message.contracts.rwb_auto_transport_identifier")
              }}</label
            >
          </span>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <span
            :class="[
              'bmd-form-group mb-2 d-block form-label-group shorter',
              transport_nationality_focused ? 'focused' : '',
            ]"
          >
            <v-select
              id="rwb_auto_transport_nationality"
              :options="countries"
              label="display_text"
              :class="[
                'form-control',
                typeof rwb_auto.transport_nationality !== 'undefined' &&
                rwb_auto.transport_nationality.value !== ''
                  ? 'vs--selected'
                  : '',
              ]"
              @search="fetchCountries"
              v-model="rwb_auto.transport_nationality"
              :placeholder="
                $t('message.contracts.rwb_auto_transport_nationality')
              "
              @focus="transport_nationality_focused = true"
              @blur="transport_nationality_focused = false"
            ></v-select>
            <label
              for="rwb_auto_transport_nationality"
              class="form-label-group-label shorter"
              >{{
                $t("message.contracts.rwb_auto_transport_nationality")
              }}</label
            >
          </span>
        </div>
        <div class="col-md-6">
          <span :class="['bmd-form-group mb-2 d-block form-label-group']">
            <input
              type="text"
              class="form-control"
              v-model="rwb_auto.active_transport_identifier"
              :placeholder="
                $t('message.contracts.rwb_auto_active_transport_identifier')
              "
              autocomplete="off"
              style="cursor: auto"
              id="rwb_auto_active_transport_identifier"
            />
            <label
              for="rwb_auto_active_transport_identifier"
              class="form-label-group-label shorter"
              >{{
                $t("message.contracts.rwb_auto_active_transport_identifier")
              }}</label
            >
          </span>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <span :class="['bmd-form-group mb-1 d-block form-label-group']">
            <input
              type="text"
              class="form-control"
              v-model="rwb_auto.transport_regnumber"
              :placeholder="
                $t('message.contracts.rwb_auto_transport_regnumber')
              "
              autocomplete="off"
              style="cursor: auto"
              id="rwb_auto_transport_regnumber"
            />
            <label
              for="rwb_auto_transport_regnumber"
              class="form-label-group-label shorter"
              >{{ $t("message.contracts.rwb_auto_transport_regnumber") }}</label
            >
          </span>
        </div>
        <div class="col-md-6">
          <span :class="['bmd-form-group mb-2 d-block form-label-group']">
            <label
              for="rwb_auto_wagon_number"
              :class="[
                'form-label-group-label shorter',
                rwb_auto.wagon_number != '' ? 'high' : '',
              ]"
              >{{ $t("message.contracts.rwb_auto_wagon_number") }}</label
            >
            <cleave
              id="rwb_auto_wagon_number"
              v-model="rwb_auto.wagon_number"
              :options="cleaveInt"
              class="form-control"
              :placeholder="$t('message.contracts.rwb_auto_wagon_number')"
              autocomplete="off"
              style="cursor: auto"
            ></cleave>
          </span>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <span :class="['bmd-form-group mb-1 d-block form-label-group']">
            <label
              for="rwb_auto_tare"
              :class="[
                'form-label-group-label shorter',
                rwb_auto.tare != '' ? 'high' : '',
              ]"
              >{{ $t("message.contracts.rwb_auto_tare") }}</label
            >
            <cleave
              id="rwb_auto_tare"
              v-model="rwb_auto.tare"
              :options="cleaveWeight"
              class="form-control"
              :placeholder="$t('message.contracts.rwb_auto_tare')"
              autocomplete="off"
              style="cursor: auto"
            ></cleave>
          </span>
        </div>
        <div class="col-md-6">
          <span :class="['bmd-form-group mb-2 d-block form-label-group']">
            <label
              for="rwb_auto_goods_weight"
              :class="[
                'form-label-group-label shorter',
                rwb_auto.goods_weight != '' ? 'high' : '',
              ]"
              >{{ $t("message.contracts.rwb_auto_goods_weight") }}</label
            >
            <cleave
              id="rwb_auto_goods_weight"
              v-model="rwb_auto.goods_weight"
              :options="cleaveWeight"
              class="form-control"
              :placeholder="$t('message.contracts.rwb_auto_goods_weight')"
              autocomplete="off"
              style="cursor: auto"
            ></cleave>
          </span>
        </div>
      </div>

      <div class="row">
        <div class="col-md-4">
          <span :class="['bmd-form-group mb-1 d-block form-label-group']">
            <label
              for="rwb_auto_places_quentity"
              :class="[
                'form-label-group-label shorter',
                rwb_auto.places_quentity != '' ? 'high' : '',
              ]"
              >{{ $t("message.contracts.rwb_auto_places_quentity") }}</label
            >
            <cleave
              id="rwb_auto_places_quentity"
              v-model="rwb_auto.places_quentity"
              :options="cleaveWeight"
              class="form-control"
              :placeholder="$t('message.contracts.rwb_auto_places_quentity')"
              autocomplete="off"
              style="cursor: auto"
            ></cleave>
          </span>
        </div>
        <div class="col-md-4">
          <span :class="['bmd-form-group mb-2 d-block form-label-group']">
            <label
              for="rwb_auto_pocket_quentity"
              :class="[
                'form-label-group-label shorter',
                rwb_auto.pocket_quentity != '' ? 'high' : '',
              ]"
              >{{ $t("message.contracts.rwb_auto_pocket_quentity") }}</label
            >
            <cleave
              id="rwb_auto_pocket_quentity"
              v-model="rwb_auto.pocket_quentity"
              :options="cleaveWeight"
              class="form-control"
              :placeholder="$t('message.contracts.rwb_auto_pocket_quentity')"
              autocomplete="off"
              style="cursor: auto"
            ></cleave>
          </span>
        </div>
        <div class="col-md-4">
          <span :class="['bmd-form-group mb-2 d-block form-label-group']">
            <label
              for="rwb_auto_container_length"
              :class="[
                'form-label-group-label shorter',
                rwb_auto.container_length != '' ? 'high' : '',
              ]"
              >{{ $t("message.contracts.rwb_auto_container_length") }}</label
            >
            <cleave
              id="rwb_auto_container_length"
              v-model="rwb_auto.container_length"
              :options="cleaveWeight"
              class="form-control"
              :placeholder="$t('message.contracts.rwb_auto_container_length')"
              autocomplete="off"
              style="cursor: auto"
            ></cleave>
          </span>
        </div>
      </div>

      <button
        v-if="is_rwb_auto_edit"
        @click="save_auto()"
        class="btn btn-success"
      >
        {{ $t("message.add") }}
      </button>
      <button
        id="rwb-add-auto-button"
        v-else
        @click="add_auto()"
        class="btn btn-success"
      >
        {{ $t("message.add") }}
      </button>
    </b-modal>

    <b-modal
      id="modal-add-rwb-carriage"
      :hide-footer="true"
      size="md"
      :title="$t('message.add')"
    >
      <div class="row">
        <div class="col-md-6">
          <span :class="['bmd-form-group mb-1 d-block form-label-group']">
            <input
              type="text"
              class="form-control"
              v-model="rwb_carriage.carriage_id"
              :placeholder="$t('message.contracts.rwb_carriage_carriage_id')"
              autocomplete="off"
              style="cursor: auto"
              id="rwb_carriage_carriage_id"
            />
            <label
              for="rwb_carriage_carriage_id"
              class="form-label-group-label shorter"
              >{{ $t("message.contracts.rwb_carriage_carriage_id") }}</label
            >
          </span>
        </div>
        <div class="col-md-6">
          <span :class="['bmd-form-group mb-2 d-block form-label-group']">
            <input
              type="text"
              class="form-control"
              v-model="rwb_carriage.rw_name"
              :placeholder="$t('message.contracts.rwb_carriage_rw_name')"
              autocomplete="off"
              style="cursor: auto"
              id="rwb_carriage_rw_name"
            />
            <label
              for="rwb_carriage_rw_name"
              class="form-label-group-label shorter"
              >{{ $t("message.contracts.rwb_carriage_rw_name") }}</label
            >
          </span>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <span :class="['bmd-form-group mb-1 d-block form-label-group']">
            <input
              type="text"
              class="form-control"
              v-model="rwb_carriage.owner_name"
              :placeholder="$t('message.contracts.rwb_carriage_owner_name')"
              autocomplete="off"
              style="cursor: auto"
              id="rwb_carriage_owner_name"
            />
            <label
              for="rwb_carriage_owner_name"
              class="form-label-group-label shorter"
              >{{ $t("message.contracts.rwb_carriage_owner_name") }}</label
            >
          </span>
        </div>
        <div class="col-md-6">
          <span :class="['bmd-form-group mb-2 d-block form-label-group']">
            <input
              type="text"
              class="form-control"
              v-model="rwb_carriage.owner_type"
              :placeholder="$t('message.contracts.rwb_carriage_owner_type')"
              autocomplete="off"
              style="cursor: auto"
              id="rwb_carriage_owner_type"
            />
            <label
              for="rwb_carriage_owner_type"
              class="form-label-group-label shorter"
              >{{ $t("message.contracts.rwb_carriage_owner_type") }}</label
            >
          </span>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <span :class="['bmd-form-group mb-1 d-block form-label-group']">
            <label
              for="rwb_carriage_rw_power"
              :class="[
                'form-label-group-label shorter',
                rwb_carriage.rw_power != '' ? 'high' : '',
              ]"
              >{{ $t("message.contracts.rwb_carriage_rw_power") }}</label
            >
            <cleave
              id="rwb_carriage_rw_power"
              v-model="rwb_carriage.rw_power"
              :options="cleaveWeight"
              class="form-control"
              :placeholder="$t('message.contracts.rwb_carriage_rw_power')"
              autocomplete="off"
              style="cursor: auto"
            ></cleave>
          </span>
        </div>
        <div class="col-md-6">
          <span :class="['bmd-form-group mb-2 d-block form-label-group']">
            <label
              for="rwb_carriage_axis_quentity"
              :class="[
                'form-label-group-label shorter',
                rwb_carriage.axis_quentity != '' ? 'high' : '',
              ]"
              >{{ $t("message.contracts.rwb_carriage_axis_quentity") }}</label
            >
            <cleave
              id="rwb_carriage_axis_quentity"
              v-model="rwb_carriage.axis_quentity"
              :options="cleaveWeight"
              class="form-control"
              :placeholder="$t('message.contracts.rwb_carriage_axis_quentity')"
              autocomplete="off"
              style="cursor: auto"
            ></cleave>
          </span>
        </div>
      </div>

      <div class="row">
        <div class="col-md-4">
          <span :class="['bmd-form-group mb-1 d-block form-label-group']">
            <label
              for="rwb_carriage_tare"
              :class="[
                'form-label-group-label shorter',
                rwb_carriage.tare != '' ? 'high' : '',
              ]"
              >{{ $t("message.contracts.rwb_carriage_tare") }}</label
            >
            <cleave
              id="rwb_carriage_tare"
              v-model="rwb_carriage.tare"
              :options="cleaveWeight"
              class="form-control"
              :placeholder="$t('message.contracts.rwb_carriage_tare')"
              autocomplete="off"
              style="cursor: auto"
            ></cleave>
          </span>
        </div>
        <div class="col-md-4">
          <span :class="['bmd-form-group mb-2 d-block form-label-group']">
            <label
              for="rwb_carriage_goods_weight"
              :class="[
                'form-label-group-label shorter',
                rwb_carriage.goods_weight != '' ? 'high' : '',
              ]"
              >{{ $t("message.contracts.rwb_carriage_goods_weight") }}</label
            >
            <cleave
              id="rwb_carriage_goods_weight"
              v-model="rwb_carriage.goods_weight"
              :options="cleaveWeight"
              class="form-control"
              :placeholder="$t('message.contracts.rwb_carriage_goods_weight')"
              autocomplete="off"
              style="cursor: auto"
            ></cleave>
          </span>
        </div>
        <div class="col-md-4">
          <span :class="['bmd-form-group mb-1 d-block form-label-group']">
            <input
              type="text"
              class="form-control"
              v-model="rwb_carriage.caliber"
              :placeholder="$t('message.contracts.rwb_carriage_caliber')"
              autocomplete="off"
              style="cursor: auto"
              id="rwb_carriage_caliber"
            />
            <label
              for="rwb_carriage_caliber"
              class="form-label-group-label shorter"
              >{{ $t("message.contracts.rwb_carriage_caliber") }}</label
            >
          </span>
        </div>
      </div>

      <button
        v-if="is_rwb_carriage_edit"
        @click="save_carriage()"
        class="btn btn-success"
      >
        {{ $t("message.add") }}
      </button>
      <button
        id="rwb-add-carriage-button"
        v-else
        @click="add_carriage()"
        class="btn btn-success"
      >
        {{ $t("message.add") }}
      </button>
    </b-modal>

    <b-modal
      id="modal-add-rwb-seal"
      :hide-footer="true"
      size="sm"
      :title="$t('message.add')"
    >
      <div class="row">
        <div class="col-md-12">
          <span :class="['bmd-form-group mb-1 d-block form-label-group']">
            <input
              type="text"
              class="form-control"
              v-model="rwb_seal.seal_id"
              :placeholder="$t('message.contracts.rwb_seal_seal_id')"
              autocomplete="off"
              style="cursor: auto"
              id="rwb_seal_seal_id"
            />
            <label
              for="rwb_seal_seal_id"
              class="form-label-group-label shorter"
              >{{ $t("message.contracts.rwb_seal_seal_id") }}</label
            >
          </span>
        </div>
        <div class="col-md-12">
          <span :class="['bmd-form-group mb-2 d-block form-label-group']">
            <label
              for="rwb_seal_seal_quentity"
              :class="[
                'form-label-group-label shorter',
                rwb_seal.seal_quentity != '' ? 'high' : '',
              ]"
              >{{ $t("message.contracts.rwb_seal_seal_quentity") }}</label
            >
            <cleave
              id="rwb_seal_seal_quentity"
              v-model="rwb_seal.seal_quentity"
              :options="cleaveWeight"
              class="form-control"
              :placeholder="$t('message.contracts.rwb_seal_seal_quentity')"
              autocomplete="off"
              style="cursor: auto"
            ></cleave>
          </span>
        </div>
        <div class="col-md-12">
          <span :class="['bmd-form-group mb-2 d-block form-label-group']">
            <label
              for="rwb_seal_ident_kind"
              :class="[
                'form-label-group-label shorter',
                rwb_seal.ident_kind != '' ? 'high' : '',
              ]"
              >{{ $t("message.contracts.rwb_seal_ident_kind") }}</label
            >
            <cleave
              id="rwb_seal_ident_kind"
              v-model="rwb_seal.ident_kind"
              :options="cleaveWeight"
              class="form-control"
              :placeholder="$t('message.contracts.rwb_seal_ident_kind')"
              autocomplete="off"
              style="cursor: auto"
            ></cleave>
          </span>
        </div>
        <div class="col-md-12">
          <span :class="['bmd-form-group mb-1 d-block form-label-group']">
            <input
              type="text"
              class="form-control"
              v-model="rwb_seal.ident_desc"
              :placeholder="$t('message.contracts.rwb_seal_ident_desc')"
              autocomplete="off"
              style="cursor: auto"
              id="rwb_seal_ident_desc"
            />
            <label
              for="rwb_seal_ident_desc"
              class="form-label-group-label shorter"
              >{{ $t("message.contracts.rwb_seal_ident_desc") }}</label
            >
          </span>
        </div>
      </div>

      <button
        v-if="is_rwb_seal_edit"
        @click="save_seal()"
        class="btn btn-success"
      >
        {{ $t("message.add") }}
      </button>
      <button
        id="rwb-add-seal-button"
        v-else
        @click="add_seal()"
        class="btn btn-success"
      >
        {{ $t("message.add") }}
      </button>
    </b-modal>

    <b-modal
      id="modal-add-rwb-stamp"
      :hide-footer="true"
      size="md"
      :title="$t('message.add')"
    >
      <div class="row">
        <div class="col-md-12">
          <span :class="['bmd-form-group mb-1 d-block form-label-group']">
            <input
              type="text"
              class="form-control"
              v-model="rwb_stamp.carrier_name"
              :placeholder="$t('message.contracts.rwb_stamp_carrier_name')"
              autocomplete="off"
              style="cursor: auto"
              id="rwb_stamp_carrier_name"
            />
            <label
              for="rwb_stamp_carrier_name"
              class="form-label-group-label shorter"
              >{{ $t("message.contracts.rwb_stamp_carrier_name") }}</label
            >
          </span>
        </div>
        <div class="col-md-6">
          <span
            :class="['bmd-form-group mb-2 d-block form-label-group shorter']"
          >
            <!-- <b-form-datepicker :locale="locale" v-model="rwb_stamp.contract_date" :placeholder="$t('message.contracts.rwb_stamp_date')" size="sm" no-flip :hide-header="true" :show-decade-nav="false" id="rwb_stamp_date"></b-form-datepicker>
						<label v-if="rwb_stamp.contract_date!=''" for="rwb_stamp_date" class="form-label-group-label shorter topped">{{$t('message.contracts.rwb_stamp_date')}}</label> -->

            <datepicker
              value-type="YYYY-MM-DD"
              format="DD.MM.YYYY"
              @focus="rwb_stamp.contract_date = ' '"
              @blur="
                rwb_stamp.contract_date == ' '
                  ? (rwb_stamp.contract_date = '')
                  : (rwb_stamp.contract_date = rwb_stamp.contract_date)
              "
              inputClass="form-control"
              v-model="rwb_stamp.contract_date"
              :placeholder="$t('message.contracts.rwb_stamp_date')"
              :inputAttr="{ id: 'rwb_stamp_date' }"
            />
            <label
              for="rwb_stamp_date"
              class="form-label-group-label shorter"
              :class="
                rwb_stamp.contract_date != '' && rwb_stamp.contract_date != null
                  ? 'topped'
                  : ''
              "
              >{{ $t("message.contracts.rwb_stamp_date") }}</label
            >
          </span>
        </div>
        <div class="col-md-6">
          <span
            :class="['bmd-form-group mb-2 d-block form-label-group shorter']"
          >
            <b-form-timepicker
              v-model="rwb_stamp.time"
              :locale="locale"
              :placeholder="$t('message.contracts.rwb_stamp_time')"
              size="sm"
              no-flip
              :hide-header="true"
              :show-decade-nav="false"
              no-close-button
              id="rwb_stamp_time"
            ></b-form-timepicker>
            <label
              v-if="rwb_stamp.time != ''"
              for="rwb_stamp_time"
              class="form-label-group-label shorter topped"
              >{{ $t("message.contracts.rwb_stamp_time") }}</label
            >
          </span>
        </div>
        <div class="col-md-12">
          <span
            :class="['bmd-form-group mb-2 d-block form-label-group shorter']"
          >
            <!-- <b-form-datepicker :locale="locale" v-model="rwb_stamp_date_time_moscow_date" :placeholder="$t('message.contracts.rwb_stamp_date_time_moscow_date')" size="sm" no-flip :hide-header="true" :show-decade-nav="false" id="rwb_stamp_date_time_moscow_date"></b-form-datepicker>
						<label v-if="rwb_stamp_date_time_moscow_date!=''" for="rwb_stamp_date_time_moscow_date" class="form-label-group-label shorter topped">{{$t('message.contracts.rwb_stamp_date_time_moscow_date')}}</label> -->
            <datepicker
              value-type="YYYY-MM-DDThh:mm:ss"
              type="datetime"
              format="DD.MM.YYYY hh:mm:ss"
              @focus="rwb_stamp.date_time_moscow = ' '"
              @blur="
                rwb_stamp.date_time_moscow == ' '
                  ? (rwb_stamp.date_time_moscow = '')
                  : (rwb_stamp.date_time_moscow = rwb_stamp.date_time_moscow)
              "
              inputClass="form-control"
              v-model="rwb_stamp.date_time_moscow"
              :placeholder="$t('message.contracts.rwb_stamp_date_time_moscow')"
              :inputAttr="{ id: 'rwb_stamp_date_time_moscow_date' }"
            />
            <label
              for="rwb_stamp_date_time_moscow_date"
              class="form-label-group-label shorter"
              :class="
                rwb_stamp.date_time_moscow != '' &&
                rwb_stamp.date_time_moscow != null
                  ? 'topped'
                  : ''
              "
              >{{ $t("message.contracts.rwb_stamp_date_time_moscow") }}</label
            >
          </span>
        </div>
        <!-- <div class="col-md-6">
					<span :class="['bmd-form-group mb-2 d-block form-label-group shorter']">
						<b-form-timepicker v-model="rwb_stamp_date_time_moscow_time" :locale="locale" :placeholder="$t('message.contracts.rwb_stamp_date_time_moscow_time')" size="sm" no-flip :hide-header="true" :show-decade-nav="false" no-close-button id="rwb_stamp_date_time_moscow_time"></b-form-timepicker>
						<label  v-if="rwb_stamp_date_time_moscow_time!=''" for="rwb_stamp_date_time_moscow_time" class="form-label-group-label shorter topped">{{$t('message.contracts.rwb_stamp_date_time_moscow_time')}}</label>
					</span>
				</div> -->
        <!--<div class="col-md-6">
					<span :class="['bmd-form-group mb-1 d-block form-label-group']">
						<input type="text" class="form-control" v-model="rwb_stamp.station_code" :placeholder="$t('message.contracts.rwb_stamp_station_code')" autocomplete="off" style="cursor: auto;" id="rwb_stamp_station_code">
						<label for="rwb_stamp_station_code" class="form-label-group-label shorter">{{$t('message.contracts.rwb_stamp_station_code')}}</label>
					</span>	
				</div>
				<div class="col-md-6">
					<span :class="['bmd-form-group mb-1 d-block form-label-group']">
						<input type="text" class="form-control" v-model="rwb_stamp.station_name" :placeholder="$t('message.contracts.rwb_stamp_station_name')" autocomplete="off" style="cursor: auto;" id="rwb_stamp_station_name">
						<label for="rwb_stamp_station_name" class="form-label-group-label shorter">{{$t('message.contracts.rwb_stamp_station_name')}}</label>
					</span>	
				</div> -->

        <div class="col-md-12">
          <code-value
            :label="$t('message.contracts.rwb_stamp_station_name')"
            :value_placeholder="$t('message.contracts.rwb_stamp_station_name')"
            :code_placeholder="$t('message.contracts.rwb_stamp_station_code')"
            type="rw_station"
            code_class="col-6"
            message_class="col-6"
            v-model="rwb_stamp.station"
          ></code-value>
          <!--<span :class="['bmd-form-group mb-2 d-block form-label-group shorter',  rwb_stamp_station_focused?'focused':'']">
						<v-select id="rwb_stamp_station" :options="rw_stations" label="display_text" :class="['form-control', typeof rwb_stamp.station !== 'undefined' && rwb_stamp.station.value!==''?'vs--selected':'']" @search="fetchStations"  v-model="rwb_stamp.station" :placeholder="$t('message.contracts.rwb_stamp_station_name')" @focus="rwb_stamp_station_focused=true" @blur="rwb_stamp_station_focused=false"></v-select>	
						<label for="rwb_stamp_station" class="form-label-group-label shorter">{{$t('message.contracts.rwb_stamp_station_name')}}</label>
					</span> -->
        </div>
        <div class="col-md-4">
          <span :class="['bmd-form-group mb-1 d-block form-label-group']">
            <input
              type="text"
              class="form-control"
              v-model="rwb_stamp.rw_name"
              :placeholder="$t('message.contracts.rwb_stamp_rw_name')"
              autocomplete="off"
              style="cursor: auto"
              id="rwb_stamp_rw_name"
            />
            <label
              for="rwb_stamp_rw_name"
              class="form-label-group-label shorter"
              >{{ $t("message.contracts.rwb_stamp_rw_name") }}</label
            >
          </span>
        </div>
        <div class="col-md-4">
          <span :class="['bmd-form-group mb-1 d-block form-label-group']">
            <input
              type="text"
              class="form-control"
              v-model="rwb_stamp.rw_code"
              :placeholder="$t('message.contracts.rwb_stamp_rw_code')"
              autocomplete="off"
              style="cursor: auto"
              id="rwb_stamp_rw_code"
            />
            <label
              for="rwb_stamp_rw_code"
              class="form-label-group-label shorter"
              >{{ $t("message.contracts.rwb_stamp_rw_code") }}</label
            >
          </span>
        </div>
        <div class="col-md-4">
          <span
            :class="[
              'bmd-form-group mb-2 d-block form-label-group shorter',
              rwb_stamp_country_focused ? 'focused' : '',
            ]"
          >
            <v-select
              id="rwb_stamp_country"
              :options="countries"
              label="display_text"
              :class="[
                'form-control',
                typeof rwb_stamp.country !== 'undefined' &&
                rwb_stamp.country.value !== ''
                  ? 'vs--selected'
                  : '',
              ]"
              @search="fetchCountries"
              v-model="rwb_stamp.country"
              :placeholder="$t('message.contracts.rwb_stamp_country')"
              @focus="rwb_stamp_country_focused = true"
              @blur="rwb_stamp_country_focused = false"
            ></v-select>
            <label
              for="rwb_stamp_country"
              class="form-label-group-label shorter"
              >{{ $t("message.contracts.rwb_stamp_country") }}</label
            >
          </span>
        </div>
      </div>

      <button
        v-if="is_rwb_stamp_edit"
        @click="save_stamp()"
        class="btn btn-success"
      >
        {{ $t("message.add") }}
      </button>
      <button
        id="rwb-add-stamp-button"
        v-else
        @click="add_stamp()"
        class="btn btn-success"
      >
        {{ $t("message.add") }}
      </button>
    </b-modal>

    <b-modal
      id="modal-add-rwb-carrier-charge"
      :hide-footer="true"
      size="md"
      :title="$t('message.add')"
    >
      <div class="row">
        <div class="col-md-6">
          <span :class="['bmd-form-group mb-1 d-block form-label-group']">
            <label
              for="rwb_carrier_charge_order_no"
              :class="[
                'form-label-group-label shorter',
                rwb_carrier_charge.order_no != '' ? 'high' : '',
              ]"
              >{{ $t("message.contracts.rwb_carrier_charge_order_no") }}</label
            >
            <cleave
              id="rwb_carrier_charge_order_no"
              v-model="rwb_carrier_charge.order_no"
              :options="cleaveWeight"
              class="form-control"
              :placeholder="$t('message.contracts.rwb_carrier_charge_order_no')"
              autocomplete="off"
              style="cursor: auto"
            ></cleave>
          </span>
        </div>
        <div class="col-md-6">
          <span :class="['bmd-form-group mb-1 d-block form-label-group']">
            <input
              type="text"
              class="form-control"
              v-model="rwb_carrier_charge.carrier_code"
              :placeholder="
                $t('message.contracts.rwb_carrier_charge_carrier_code')
              "
              autocomplete="off"
              style="cursor: auto"
              id="rwb_carrier_charge_carrier_code"
            />
            <label
              for="rwb_carrier_charge_carrier_code"
              class="form-label-group-label shorter"
              >{{
                $t("message.contracts.rwb_carrier_charge_carrier_code")
              }}</label
            >
          </span>
        </div>
        <!--<div class="col-md-6">
					<span :class="['bmd-form-group mb-1 d-block form-label-group']">
						<input type="text" class="form-control" v-model="rwb_carrier_charge.from_station_code" :placeholder="$t('message.contracts.rwb_carrier_charge_from_station_code')" autocomplete="off" style="cursor: auto;" id="rwb_carrier_charge_from_station_code">
						<label for="rwb_carrier_charge_from_station_code" class="form-label-group-label shorter">{{$t('message.contracts.rwb_carrier_charge_from_station_code')}}</label>
					</span>	
				</div> -->

        <div class="col-md-12">
          <code-value
            :label="
              $t('message.contracts.rwb_carrier_charge_from_station_name')
            "
            :value_placeholder="
              $t('message.contracts.rwb_carrier_charge_from_station_name')
            "
            :code_placeholder="
              $t('message.contracts.rwb_carrier_charge_from_station_code')
            "
            type="rw_station"
            code_class="col-6"
            message_class="col-6"
            v-model="rwb_carrier_charge.from_station"
          ></code-value>
          <!--<span :class="['bmd-form-group mb-2 d-block form-label-group shorter',  rwb_carrier_charge_from_station_focused?'focused':'']">
						<v-select id="rwb_carrier_charge_from_station_focused" :options="rw_stations" label="display_text" :class="['form-control', typeof rwb_carrier_charge.from_station !== 'undefined' && rwb_carrier_charge.from_station.value!==''?'vs--selected':'']" @search="fetchStations"  v-model="rwb_carrier_charge.from_station" :placeholder="$t('message.contracts.rwb_carrier_charge_from_station_name')" @focus="rwb_carrier_charge_from_station_focused=true" @blur="rwb_carrier_charge_from_station_focused=false"></v-select>	
						<label for="rwb_carrier_charge_from_station_focused" class="form-label-group-label shorter">{{$t('message.contracts.rwb_carrier_charge_from_station_name')}}</label>
					</span>-->
        </div>
        <!--	<div class="col-md-6">
					<span :class="['bmd-form-group mb-1 d-block form-label-group']">
						<input type="text" class="form-control" v-model="rwb_carrier_charge.from_station_name" :placeholder="$t('message.contracts.rwb_carrier_charge_from_station_name')" autocomplete="off" style="cursor: auto;" id="rwb_carrier_charge_from_station_name">
						<label for="rwb_carrier_charge_from_station_name" class="form-label-group-label shorter">{{$t('message.contracts.rwb_carrier_charge_from_station_name')}}</label>
					</span>	
				</div> -->
        <div class="col-md-6">
          <span :class="['bmd-form-group mb-1 d-block form-label-group']">
            <input
              type="text"
              class="form-control"
              v-model="rwb_carrier_charge.from_rw_name"
              :placeholder="
                $t('message.contracts.rwb_carrier_charge_from_rw_name')
              "
              autocomplete="off"
              style="cursor: auto"
              id="rwb_carrier_charge_from_rw_name"
            />
            <label
              for="rwb_carrier_charge_from_rw_name"
              class="form-label-group-label shorter"
              >{{
                $t("message.contracts.rwb_carrier_charge_from_rw_name")
              }}</label
            >
          </span>
        </div>
        <div class="col-md-6">
          <span
            :class="[
              'bmd-form-group mb-2 d-block form-label-group shorter',
              rwb_carrier_charge_from_country_focused ? 'focused' : '',
            ]"
          >
            <v-select
              id="rwb_carrier_charge_from_country"
              :options="countries"
              label="display_text"
              :class="[
                'form-control',
                typeof rwb_carrier_charge.from_country !== 'undefined' &&
                rwb_carrier_charge.from_country.value !== ''
                  ? 'vs--selected'
                  : '',
              ]"
              @search="fetchCountries"
              v-model="rwb_carrier_charge.from_country"
              :placeholder="
                $t('message.contracts.rwb_carrier_charge_from_country')
              "
              @focus="rwb_carrier_charge_from_country_focused = true"
              @blur="rwb_carrier_charge_from_country_focused = false"
            ></v-select>
            <label
              for="rwb_carrier_charge_from_country"
              class="form-label-group-label shorter"
              >{{
                $t("message.contracts.rwb_carrier_charge_from_country")
              }}</label
            >
          </span>
        </div>

        <div class="col-md-12">
          <code-value
            :label="$t('message.contracts.rwb_carrier_charge_to_station_name')"
            :value_placeholder="
              $t('message.contracts.rwb_carrier_charge_to_station_name')
            "
            :code_placeholder="
              $t('message.contracts.rwb_carrier_charge_to_station_code')
            "
            type="rw_station"
            code_class="col-6"
            message_class="col-6"
            v-model="rwb_carrier_charge.to_station"
          ></code-value>
          <!--<span :class="['bmd-form-group mb-2 d-block form-label-group shorter',  rwb_carrier_charge_to_station_focused?'focused':'']">
						<v-select id="rwb_carrier_charge_to_station_focused" :options="rw_stations" label="display_text" :class="['form-control', typeof rwb_carrier_charge.to_station !== 'undefined' && rwb_carrier_charge.to_station.value!==''?'vs--selected':'']" @search="fetchStations"  v-model="rwb_carrier_charge.to_station" :placeholder="$t('message.contracts.rwb_carrier_charge_from_station_name')" @focus="rwb_carrier_charge_to_station_focused=true" @blur="rwb_carrier_charge_to_station_focused=false"></v-select>	
						<label for="rwb_carrier_charge_to_station_focused" class="form-label-group-label shorter">{{$t('message.contracts.rwb_carrier_charge_to_station_name')}}</label>
					</span>-->
        </div>
        <!--<div class="col-md-6">
					<span :class="['bmd-form-group mb-1 d-block form-label-group']">
						<input type="text" class="form-control" v-model="rwb_carrier_charge.to_station_code" :placeholder="$t('message.contracts.rwb_carrier_charge_to_station_code')" autocomplete="off" style="cursor: auto;" id="rwb_carrier_charge_to_station_code">
						<label for="rwb_carrier_charge_to_station_code" class="form-label-group-label shorter">{{$t('message.contracts.rwb_carrier_charge_to_station_code')}}</label>
					</span>	
				</div>
				<div class="col-md-6">
					<span :class="['bmd-form-group mb-1 d-block form-label-group']">
						<input type="text" class="form-control" v-model="rwb_carrier_charge.to_station_name" :placeholder="$t('message.contracts.rwb_carrier_charge_to_station_name')" autocomplete="off" style="cursor: auto;" id="rwb_carrier_charge_to_station_name">
						<label for="rwb_carrier_charge_to_station_name" class="form-label-group-label shorter">{{$t('message.contracts.rwb_carrier_charge_to_station_name')}}</label>
					</span>	
				</div> -->
        <div class="col-md-6">
          <span :class="['bmd-form-group mb-1 d-block form-label-group']">
            <input
              type="text"
              class="form-control"
              v-model="rwb_carrier_charge.to_rw_name"
              :placeholder="
                $t('message.contracts.rwb_carrier_charge_to_rw_name')
              "
              autocomplete="off"
              style="cursor: auto"
              id="rwb_carrier_charge_to_rw_name"
            />
            <label
              for="rwb_carrier_charge_to_rw_name"
              class="form-label-group-label shorter"
              >{{
                $t("message.contracts.rwb_carrier_charge_to_rw_name")
              }}</label
            >
          </span>
        </div>
        <div class="col-md-6">
          <span
            :class="[
              'bmd-form-group mb-2 d-block form-label-group shorter',
              rwb_carrier_charge_to_country_focused ? 'focused' : '',
            ]"
          >
            <v-select
              id="rwb_carrier_charge_to_country"
              :options="countries"
              label="display_text"
              :class="[
                'form-control',
                typeof rwb_carrier_charge.to_country !== 'undefined' &&
                rwb_carrier_charge.to_country.value !== ''
                  ? 'vs--selected'
                  : '',
              ]"
              @search="fetchCountries"
              v-model="rwb_carrier_charge.to_country"
              :placeholder="
                $t('message.contracts.rwb_carrier_charge_to_country')
              "
              @focus="rwb_carrier_charge_to_country_focused = true"
              @blur="rwb_carrier_charge_to_country_focused = false"
            ></v-select>
            <label
              for="rwb_carrier_charge_to_country"
              class="form-label-group-label shorter"
              >{{
                $t("message.contracts.rwb_carrier_charge_to_country")
              }}</label
            >
          </span>
        </div>
        <div class="col-md-6">
          <span :class="['bmd-form-group mb-1 d-block form-label-group']">
            <label
              for="rwb_carrier_charge_distance"
              :class="[
                'form-label-group-label shorter',
                rwb_carrier_charge.distance != '' ? 'high' : '',
              ]"
              >{{ $t("message.contracts.rwb_carrier_charge_distance") }}</label
            >
            <cleave
              id="rwb_carrier_charge_distance"
              v-model="rwb_carrier_charge.distance"
              :options="cleaveWeight"
              class="form-control"
              :placeholder="$t('message.contracts.rwb_carrier_charge_distance')"
              autocomplete="off"
              style="cursor: auto"
            ></cleave>
          </span>
        </div>
        <div class="col-md-6">
          <span :class="['bmd-form-group mb-1 d-block form-label-group']">
            <label
              for="rwb_carrier_charge_calc_weight"
              :class="[
                'form-label-group-label shorter',
                rwb_carrier_charge.calc_weight != '' ? 'high' : '',
              ]"
              >{{
                $t("message.contracts.rwb_carrier_charge_calc_weight")
              }}</label
            >
            <cleave
              id="rwb_carrier_charge_calc_weight"
              v-model="rwb_carrier_charge.calc_weight"
              :options="cleaveWeight"
              class="form-control"
              :placeholder="
                $t('message.contracts.rwb_carrier_charge_calc_weight')
              "
              autocomplete="off"
              style="cursor: auto"
            ></cleave>
          </span>
        </div>

        <div class="col-md-6">
          <span :class="['bmd-form-group mb-1 d-block form-label-group']">
            <input
              type="text"
              class="form-control"
              v-model="rwb_carrier_charge.extra_charge_code"
              :placeholder="
                $t('message.contracts.rwb_carrier_charge_extra_charge_code')
              "
              autocomplete="off"
              style="cursor: auto"
              id="rwb_carrier_charge_extra_charge_code"
            />
            <label
              for="rwb_carrier_charge_extra_charge_code"
              class="form-label-group-label shorter"
              >{{
                $t("message.contracts.rwb_carrier_charge_extra_charge_code")
              }}</label
            >
          </span>
        </div>

        <div class="col-md-6">
          <span :class="['bmd-form-group mb-1 d-block form-label-group']">
            <input
              type="text"
              class="form-control"
              v-model="rwb_carrier_charge.extra_charge_name"
              :placeholder="
                $t('message.contracts.rwb_carrier_charge_extra_charge_name')
              "
              autocomplete="off"
              style="cursor: auto"
              id="rwb_carrier_charge_extra_charge_name"
            />
            <label
              for="rwb_carrier_charge_extra_charge_name"
              class="form-label-group-label shorter"
              >{{
                $t("message.contracts.rwb_carrier_charge_extra_charge_name")
              }}</label
            >
          </span>
        </div>

        <div class="col-md-6">
          <span :class="['bmd-form-group mb-1 d-block form-label-group']">
            <label
              for="rwb_carrier_charge_extra_charge_amount"
              :class="[
                'form-label-group-label shorter',
                rwb_carrier_charge.extra_charge_amount != '' ? 'high' : '',
              ]"
              >{{
                $t("message.contracts.rwb_carrier_charge_extra_charge_amount")
              }}</label
            >
            <cleave
              id="rwb_carrier_charge_extra_charge_amount"
              v-model="rwb_carrier_charge.extra_charge_amount"
              :options="cleaveWeight"
              class="form-control"
              :placeholder="
                $t('message.contracts.rwb_carrier_charge_extra_charge_amount')
              "
              autocomplete="off"
              style="cursor: auto"
            ></cleave>
          </span>
        </div>

        <div class="col-md-6">
          <span :class="['bmd-form-group mb-1 d-block form-label-group']">
            <input
              type="text"
              class="form-control"
              v-model="rwb_carrier_charge.tarif_code"
              :placeholder="
                $t('message.contracts.rwb_carrier_charge_tarif_code')
              "
              autocomplete="off"
              style="cursor: auto"
              id="rwb_carrier_charge_tarif_code"
            />
            <label
              for="rwb_carrier_charge_tarif_code"
              class="form-label-group-label shorter"
              >{{
                $t("message.contracts.rwb_carrier_charge_tarif_code")
              }}</label
            >
          </span>
        </div>

        <div class="col-md-6">
          <span :class="['bmd-form-group mb-1 d-block form-label-group']">
            <input
              type="text"
              class="form-control"
              v-model="rwb_carrier_charge.calc_cargo_code"
              :placeholder="
                $t('message.contracts.rwb_carrier_charge_calc_cargo_code')
              "
              autocomplete="off"
              style="cursor: auto"
              id="rwb_carrier_charge_calc_cargo_code"
            />
            <label
              for="rwb_carrier_charge_calc_cargo_code"
              class="form-label-group-label shorter"
              >{{
                $t("message.contracts.rwb_carrier_charge_calc_cargo_code")
              }}</label
            >
          </span>
        </div>

        <div class="col-md-6">
          <span :class="['bmd-form-group mb-1 d-block form-label-group']">
            <label
              for="rwb_carrier_charge_currency_rate"
              :class="[
                'form-label-group-label shorter',
                rwb_carrier_charge.currency_rate != '' ? 'high' : '',
              ]"
              >{{
                $t("message.contracts.rwb_carrier_charge_currency_rate")
              }}</label
            >
            <cleave
              id="rwb_carrier_charge_currency_rate"
              v-model="rwb_carrier_charge.currency_rate"
              :options="cleaveWeight"
              class="form-control"
              :placeholder="
                $t('message.contracts.rwb_carrier_charge_currency_rate')
              "
              autocomplete="off"
              style="cursor: auto"
            ></cleave>
          </span>
        </div>

        <div class="col-md-6">
          <span
            :class="[
              'bmd-form-group mb-2 d-block form-label-group shorter',
              snd_tarif_currency_code_focused ? 'focused' : '',
            ]"
          >
            <v-select
              id="rwb_carrier_charge_snd_tarif_currency_code"
              :options="currencies"
              label="display_text"
              :class="[
                'form-control',
                typeof rwb_carrier_charge.snd_tarif_currency_code !==
                  'undefined' &&
                rwb_carrier_charge.snd_tarif_currency_code.value !== ''
                  ? 'vs--selected'
                  : '',
              ]"
              @search="fetchCountries"
              v-model="rwb_carrier_charge.snd_tarif_currency_code"
              :placeholder="
                $t(
                  'message.contracts.rwb_carrier_charge_snd_tarif_currency_code',
                )
              "
              @focus="snd_tarif_currency_code_focused = true"
              @blur="snd_tarif_currency_code_focused = false"
            ></v-select>
            <label
              for="rwb_carrier_charge_snd_tarif_currency_code"
              class="form-label-group-label shorter"
              >{{
                $t(
                  "message.contracts.rwb_carrier_charge_snd_tarif_currency_code",
                )
              }}</label
            >
          </span>
        </div>

        <div class="col-md-6">
          <span
            :class="[
              'bmd-form-group mb-2 d-block form-label-group shorter',
              snd_payment_currency_focused ? 'focused' : '',
            ]"
          >
            <v-select
              id="rwb_carrier_charge_snd_payment_currency"
              :options="currencies"
              label="display_text"
              :class="[
                'form-control',
                typeof rwb_carrier_charge.snd_payment_currency !==
                  'undefined' &&
                rwb_carrier_charge.snd_payment_currency.value !== ''
                  ? 'vs--selected'
                  : '',
              ]"
              @search="fetchCountries"
              v-model="rwb_carrier_charge.snd_payment_currency"
              :placeholder="
                $t('message.contracts.rwb_carrier_charge_snd_payment_currency')
              "
              @focus="snd_payment_currency_focused = true"
              @blur="snd_payment_currency_focused = false"
            ></v-select>
            <label
              for="rwb_carrier_charge_snd_payment_currency"
              class="form-label-group-label shorter"
              >{{
                $t("message.contracts.rwb_carrier_charge_snd_payment_currency")
              }}</label
            >
          </span>
        </div>

        <div class="col-md-6">
          <span
            :class="[
              'bmd-form-group mb-2 d-block form-label-group shorter',
              rcv_tarif_currency_code_focused ? 'focused' : '',
            ]"
          >
            <v-select
              id="rwb_carrier_charge_rcv_tarif_currency_code"
              :options="currencies"
              label="display_text"
              :class="[
                'form-control',
                typeof rwb_carrier_charge.rcv_tarif_currency_code !==
                  'undefined' &&
                rwb_carrier_charge.rcv_tarif_currency_code.value !== ''
                  ? 'vs--selected'
                  : '',
              ]"
              @search="fetchCountries"
              v-model="rwb_carrier_charge.rcv_tarif_currency_code"
              :placeholder="
                $t(
                  'message.contracts.rwb_carrier_charge_rcv_tarif_currency_code',
                )
              "
              @focus="rcv_tarif_currency_code_focused = true"
              @blur="rcv_tarif_currency_code_focused = false"
            ></v-select>
            <label
              for="rwb_carrier_charge_rcv_tarif_currency_code"
              class="form-label-group-label shorter"
              >{{
                $t(
                  "message.contracts.rwb_carrier_charge_rcv_tarif_currency_code",
                )
              }}</label
            >
          </span>
        </div>

        <div class="col-md-6">
          <span
            :class="[
              'bmd-form-group mb-2 d-block form-label-group shorter',
              rcv_payment_currency_focused ? 'focused' : '',
            ]"
          >
            <v-select
              id="rwb_carrier_charge_rcv_payment_currency"
              :options="currencies"
              label="display_text"
              :class="[
                'form-control',
                typeof rwb_carrier_charge.rcv_payment_currency !==
                  'undefined' &&
                rwb_carrier_charge.rcv_payment_currency.value !== ''
                  ? 'vs--selected'
                  : '',
              ]"
              @search="fetchCountries"
              v-model="rwb_carrier_charge.rcv_payment_currency"
              :placeholder="
                $t('message.contracts.rwb_carrier_charge_rcv_payment_currency')
              "
              @focus="rcv_payment_currency_focused = true"
              @blur="rcv_payment_currency_focused = false"
            ></v-select>
            <label
              for="rwb_carrier_charge_rcv_payment_currency"
              class="form-label-group-label shorter"
              >{{
                $t("message.contracts.rwb_carrier_charge_rcv_payment_currency")
              }}</label
            >
          </span>
        </div>
        <div class="col-md-4">
          <span :class="['bmd-form-group mb-1 d-block form-label-group']">
            <label
              for="rwb_carrier_charge_amount48"
              :class="[
                'form-label-group-label shorter',
                rwb_carrier_charge.amount48 != '' ? 'high' : '',
              ]"
              >{{ $t("message.contracts.rwb_carrier_charge_amount48") }}</label
            >
            <cleave
              id="rwb_carrier_charge_amount48"
              v-model="rwb_carrier_charge.amount48"
              :options="cleaveWeight"
              class="form-control"
              :placeholder="$t('message.contracts.rwb_carrier_charge_amount48')"
              autocomplete="off"
              style="cursor: auto"
            ></cleave>
          </span>
        </div>
        <div class="col-md-4">
          <span :class="['bmd-form-group mb-1 d-block form-label-group']">
            <label
              for="rwb_carrier_charge_amount49"
              :class="[
                'form-label-group-label shorter',
                rwb_carrier_charge.amount49 != '' ? 'high' : '',
              ]"
              >{{ $t("message.contracts.rwb_carrier_charge_amount49") }}</label
            >
            <cleave
              id="rwb_carrier_charge_amount49"
              v-model="rwb_carrier_charge.amount49"
              :options="cleaveWeight"
              class="form-control"
              :placeholder="$t('message.contracts.rwb_carrier_charge_amount49')"
              autocomplete="off"
              style="cursor: auto"
            ></cleave>
          </span>
        </div>
        <div class="col-md-4">
          <span :class="['bmd-form-group mb-1 d-block form-label-group']">
            <label
              for="rwb_carrier_charge_amount50"
              :class="[
                'form-label-group-label shorter',
                rwb_carrier_charge.amount50 != '' ? 'high' : '',
              ]"
              >{{ $t("message.contracts.rwb_carrier_charge_amount50") }}</label
            >
            <cleave
              id="rwb_carrier_charge_amount50"
              v-model="rwb_carrier_charge.amount50"
              :options="cleaveWeight"
              class="form-control"
              :placeholder="$t('message.contracts.rwb_carrier_charge_amount50')"
              autocomplete="off"
              style="cursor: auto"
            ></cleave>
          </span>
        </div>
        <div class="col-md-4">
          <span :class="['bmd-form-group mb-1 d-block form-label-group']">
            <label
              for="rwb_carrier_charge_amount51"
              :class="[
                'form-label-group-label shorter',
                rwb_carrier_charge.amount51 != '' ? 'high' : '',
              ]"
              >{{ $t("message.contracts.rwb_carrier_charge_amount51") }}</label
            >
            <cleave
              id="rwb_carrier_charge_amount51"
              v-model="rwb_carrier_charge.amount51"
              :options="cleaveWeight"
              class="form-control"
              :placeholder="$t('message.contracts.rwb_carrier_charge_amount51')"
              autocomplete="off"
              style="cursor: auto"
            ></cleave>
          </span>
        </div>
        <div class="col-md-4">
          <span :class="['bmd-form-group mb-1 d-block form-label-group']">
            <label
              for="rwb_carrier_charge_amount52"
              :class="[
                'form-label-group-label shorter',
                rwb_carrier_charge.amount52 != '' ? 'high' : '',
              ]"
              >{{ $t("message.contracts.rwb_carrier_charge_amount52") }}</label
            >
            <cleave
              id="rwb_carrier_charge_amount52"
              v-model="rwb_carrier_charge.amount52"
              :options="cleaveWeight"
              class="form-control"
              :placeholder="$t('message.contracts.rwb_carrier_charge_amount52')"
              autocomplete="off"
              style="cursor: auto"
            ></cleave>
          </span>
        </div>
        <div class="col-md-4">
          <span :class="['bmd-form-group mb-1 d-block form-label-group']">
            <label
              for="rwb_carrier_charge_amount53"
              :class="[
                'form-label-group-label shorter',
                rwb_carrier_charge.amount53 != '' ? 'high' : '',
              ]"
              >{{ $t("message.contracts.rwb_carrier_charge_amount53") }}</label
            >
            <cleave
              id="rwb_carrier_charge_amount53"
              v-model="rwb_carrier_charge.amount53"
              :options="cleaveWeight"
              class="form-control"
              :placeholder="$t('message.contracts.rwb_carrier_charge_amount53')"
              autocomplete="off"
              style="cursor: auto"
            ></cleave>
          </span>
        </div>
        <div class="col-md-4">
          <span :class="['bmd-form-group mb-1 d-block form-label-group']">
            <label
              for="rwb_carrier_charge_amount54"
              :class="[
                'form-label-group-label shorter',
                rwb_carrier_charge.amount54 != '' ? 'high' : '',
              ]"
              >{{ $t("message.contracts.rwb_carrier_charge_amount54") }}</label
            >
            <cleave
              id="rwb_carrier_charge_amount54"
              v-model="rwb_carrier_charge.amount54"
              :options="cleaveWeight"
              class="form-control"
              :placeholder="$t('message.contracts.rwb_carrier_charge_amount54')"
              autocomplete="off"
              style="cursor: auto"
            ></cleave>
          </span>
        </div>
        <div class="col-md-4">
          <span :class="['bmd-form-group mb-1 d-block form-label-group']">
            <label
              for="rwb_carrier_charge_amount55"
              :class="[
                'form-label-group-label shorter',
                rwb_carrier_charge.amount55 != '' ? 'high' : '',
              ]"
              >{{ $t("message.contracts.rwb_carrier_charge_amount55") }}</label
            >
            <cleave
              id="rwb_carrier_charge_amount55"
              v-model="rwb_carrier_charge.amount55"
              :options="cleaveWeight"
              class="form-control"
              :placeholder="$t('message.contracts.rwb_carrier_charge_amount55')"
              autocomplete="off"
              style="cursor: auto"
            ></cleave>
          </span>
        </div>
        <div class="col-md-4">
          <span :class="['bmd-form-group mb-1 d-block form-label-group']">
            <label
              for="rwb_carrier_charge_amount56"
              :class="[
                'form-label-group-label shorter',
                rwb_carrier_charge.amount56 != '' ? 'high' : '',
              ]"
              >{{ $t("message.contracts.rwb_carrier_charge_amount56") }}</label
            >
            <cleave
              id="rwb_carrier_charge_amount56"
              v-model="rwb_carrier_charge.amount56"
              :options="cleaveWeight"
              class="form-control"
              :placeholder="$t('message.contracts.rwb_carrier_charge_amount56')"
              autocomplete="off"
              style="cursor: auto"
            ></cleave>
          </span>
        </div>
        <div class="col-md-4">
          <span :class="['bmd-form-group mb-1 d-block form-label-group']">
            <label
              for="rwb_carrier_charge_amount57"
              :class="[
                'form-label-group-label shorter',
                rwb_carrier_charge.amount57 != '' ? 'high' : '',
              ]"
              >{{ $t("message.contracts.rwb_carrier_charge_amount57") }}</label
            >
            <cleave
              id="rwb_carrier_charge_amount57"
              v-model="rwb_carrier_charge.amount57"
              :options="cleaveWeight"
              class="form-control"
              :placeholder="$t('message.contracts.rwb_carrier_charge_amount57')"
              autocomplete="off"
              style="cursor: auto"
            ></cleave>
          </span>
        </div>
        <div class="col-md-4">
          <span :class="['bmd-form-group mb-1 d-block form-label-group']">
            <label
              for="rwb_carrier_charge_amount58"
              :class="[
                'form-label-group-label shorter',
                rwb_carrier_charge.amount58 != '' ? 'high' : '',
              ]"
              >{{ $t("message.contracts.rwb_carrier_charge_amount58") }}</label
            >
            <cleave
              id="rwb_carrier_charge_amount58"
              v-model="rwb_carrier_charge.amount58"
              :options="cleaveWeight"
              class="form-control"
              :placeholder="$t('message.contracts.rwb_carrier_charge_amount58')"
              autocomplete="off"
              style="cursor: auto"
            ></cleave>
          </span>
        </div>
        <div class="col-md-4">
          <span :class="['bmd-form-group mb-1 d-block form-label-group']">
            <label
              for="rwb_carrier_charge_amount59"
              :class="[
                'form-label-group-label shorter',
                rwb_carrier_charge.amount59 != '' ? 'high' : '',
              ]"
              >{{ $t("message.contracts.rwb_carrier_charge_amount59") }}</label
            >
            <cleave
              id="rwb_carrier_charge_amount59"
              v-model="rwb_carrier_charge.amount59"
              :options="cleaveWeight"
              class="form-control"
              :placeholder="$t('message.contracts.rwb_carrier_charge_amount59')"
              autocomplete="off"
              style="cursor: auto"
            ></cleave>
          </span>
        </div>
      </div>

      <button
        v-if="is_carrier_charge_edit"
        @click="save_carrier_charge()"
        class="btn btn-success"
      >
        {{ $t("message.add") }}
      </button>
      <button
        id="rwb-add-carrier-charge-button"
        v-else
        @click="add_carrier_charge()"
        class="btn btn-success"
      >
        {{ $t("message.add") }}
      </button>
    </b-modal>

    <b-modal
      id="modal-add-rwb-paid_rw_code"
      :hide-footer="true"
      size="sm"
      :title="$t('message.add')"
    >
      <div class="row">
        <div class="col-md-12">
          <span :class="['bmd-form-group mb-1 d-block form-label-group']">
            <input
              type="text"
              class="form-control"
              v-model="rwb_paid_rw_code.paid_rw_name"
              :placeholder="
                $t('message.contracts.rwb_paid_rw_code_paid_rw_name')
              "
              autocomplete="off"
              style="cursor: auto"
              id="rwb_paid_rw_code_paid_rw_name"
            />
            <label
              for="rwb_paid_rw_code_paid_rw_name"
              class="form-label-group-label shorter"
              >{{
                $t("message.contracts.rwb_paid_rw_code_paid_rw_name")
              }}</label
            >
          </span>
        </div>
        <div class="col-md-12">
          <span :class="['bmd-form-group mb-1 d-block form-label-group']">
            <input
              type="text"
              class="form-control"
              v-model="rwb_paid_rw_code.paid_rw_code"
              :placeholder="
                $t('message.contracts.rwb_paid_rw_code_paid_rw_code')
              "
              autocomplete="off"
              style="cursor: auto"
              id="rwb_paid_rw_code_paid_rw_code"
            />
            <label
              for="rwb_paid_rw_code_paid_rw_code"
              class="form-label-group-label shorter"
              >{{
                $t("message.contracts.rwb_paid_rw_code_paid_rw_code")
              }}</label
            >
          </span>
        </div>
        <div class="col-md-12">
          <span :class="['bmd-form-group mb-1 d-block form-label-group']">
            <input
              type="text"
              class="form-control"
              v-model="rwb_paid_rw_code.paid_rw_short"
              :placeholder="
                $t('message.contracts.rwb_paid_rw_code_paid_rw_short')
              "
              autocomplete="off"
              style="cursor: auto"
              id="rwb_paid_rw_code_paid_rw_short"
            />
            <label
              for="rwb_paid_rw_code_paid_rw_short"
              class="form-label-group-label shorter"
              >{{
                $t("message.contracts.rwb_paid_rw_code_paid_rw_short")
              }}</label
            >
          </span>
        </div>
        <div class="col-md-12">
          <span :class="['bmd-form-group mb-1 d-block form-label-group']">
            <input
              type="text"
              class="form-control"
              v-model="rwb_paid_rw_code.payer_code"
              :placeholder="$t('message.contracts.rwb_paid_rw_code_payer_code')"
              autocomplete="off"
              style="cursor: auto"
              id="rwb_paid_rw_code_payer_code"
            />
            <label
              for="rwb_paid_rw_code_payer_code"
              class="form-label-group-label shorter"
              >{{ $t("message.contracts.rwb_paid_rw_code_payer_code") }}</label
            >
          </span>
        </div>
        <div class="col-md-12">
          <span :class="['bmd-form-group mb-1 d-block form-label-group']">
            <input
              type="text"
              class="form-control"
              v-model="rwb_paid_rw_code.payer_name"
              :placeholder="$t('message.contracts.rwb_paid_rw_code_payer_name')"
              autocomplete="off"
              style="cursor: auto"
              id="rwb_paid_rw_code_payer_name"
            />
            <label
              for="rwb_paid_rw_code_payer_name"
              class="form-label-group-label shorter"
              >{{ $t("message.contracts.rwb_paid_rw_code_payer_name") }}</label
            >
          </span>
        </div>
        <div class="col-md-12">
          <span :class="['bmd-form-group mb-1 d-block form-label-group']">
            <input
              type="text"
              class="form-control"
              v-model="rwb_paid_rw_code.from_rw_name"
              :placeholder="
                $t('message.contracts.rwb_paid_rw_code_from_rw_name')
              "
              autocomplete="off"
              style="cursor: auto"
              id="rwb_paid_rw_code_from_rw_name"
            />
            <label
              for="rwb_paid_rw_code_from_rw_name"
              class="form-label-group-label shorter"
              >{{
                $t("message.contracts.rwb_paid_rw_code_from_rw_name")
              }}</label
            >
          </span>
        </div>
        <div class="col-md-12">
          <span
            :class="[
              'bmd-form-group mb-2 d-block form-label-group shorter',
              rwb_paid_rw_code_from_country_focused ? 'focused' : '',
            ]"
          >
            <v-select
              id="rwb_paid_rw_code_from_country"
              :options="countries"
              label="display_text"
              :class="[
                'form-control',
                typeof rwb_paid_rw_code.from_country !== 'undefined' &&
                rwb_paid_rw_code.from_country.value !== ''
                  ? 'vs--selected'
                  : '',
              ]"
              @search="fetchCountries"
              v-model="rwb_paid_rw_code.from_country"
              :placeholder="
                $t('message.contracts.rwb_paid_rw_code_from_country')
              "
              @focus="rwb_paid_rw_code_from_country_focused = true"
              @blur="rwb_paid_rw_code_from_country_focused = false"
            ></v-select>
            <label
              for="rwb_paid_rw_code_from_country"
              class="form-label-group-label shorter"
              >{{
                $t("message.contracts.rwb_paid_rw_code_from_country")
              }}</label
            >
          </span>
        </div>
      </div>

      <button
        v-if="is_rwb_paid_rw_code_edit"
        @click="save_paid_rw_code()"
        class="btn btn-success"
      >
        {{ $t("message.add") }}
      </button>
      <button
        id="rwb-payments-add-button"
        v-else
        @click="add_paid_rw_code()"
        class="btn btn-success"
      >
        {{ $t("message.add") }}
      </button>
    </b-modal>

    <b-modal
      id="modal-add-rwb-consignor_doc"
      :hide-footer="true"
      size="sm"
      :title="$t('message.add')"
    >
      <div class="row">
        <div class="col-md-12">
          <span :class="['bmd-form-group mb-1 d-block form-label-group']">
            <input
              type="text"
              class="form-control"
              v-model="rwb_consignor_doc.doc_name"
              :placeholder="$t('message.contracts.rwb_consignor_doc_doc_name')"
              autocomplete="off"
              style="cursor: auto"
              id="rwb_consignor_doc_doc_name"
            />
            <label
              for="rwb_consignor_doc_doc_name"
              class="form-label-group-label shorter"
              >{{ $t("message.contracts.rwb_consignor_doc_doc_name") }}</label
            >
          </span>
        </div>
        <div class="col-md-12">
          <span :class="['bmd-form-group mb-1 d-block form-label-group']">
            <input
              type="text"
              class="form-control"
              v-model="rwb_consignor_doc.doc_number"
              :placeholder="
                $t('message.contracts.rwb_consignor_doc_doc_number')
              "
              autocomplete="off"
              style="cursor: auto"
              id="rwb_consignor_doc_doc_number"
            />
            <label
              for="rwb_consignor_doc_doc_number"
              class="form-label-group-label shorter"
              >{{ $t("message.contracts.rwb_consignor_doc_doc_number") }}</label
            >
          </span>
        </div>
        <div class="col-md-12">
          <span
            :class="['bmd-form-group mb-2 d-block form-label-group shorter']"
          >
            <!-- <b-form-datepicker :locale="locale" v-model="rwb_consignor_doc.doc_date" :placeholder="$t('message.contracts.rwb_consignor_doc_doc_date')" size="sm" no-flip :hide-header="true" :show-decade-nav="false" id="rwb_consignor_doc_doc_date"></b-form-datepicker>
						<label v-if="rwb_consignor_doc.doc_date!=''" for="rwb_consignor_doc_doc_date" class="form-label-group-label shorter topped">{{$t('message.contracts.rwb_consignor_doc_doc_date')}}</label> -->

            <datepicker
              value-type="YYYY-MM-DD"
              format="DD.MM.YYYY"
              @focus="rwb_consignor_doc.doc_date = ' '"
              @blur="
                rwb_consignor_doc.doc_date == ' '
                  ? (rwb_consignor_doc.doc_date = '')
                  : (rwb_consignor_doc.doc_date = rwb_consignor_doc.doc_date)
              "
              inputClass="form-control"
              v-model="rwb_consignor_doc.doc_date"
              :placeholder="$t('message.contracts.rwb_consignor_doc_doc_date')"
              :inputAttr="{ id: 'rwb_consignor_doc_doc_date' }"
            />
            <label
              for="rwb_consignor_doc_doc_date"
              class="form-label-group-label shorter"
              :class="
                rwb_consignor_doc.doc_date != '' &&
                rwb_consignor_doc.doc_date != null
                  ? 'topped'
                  : ''
              "
              >{{ $t("message.contracts.rwb_consignor_doc_doc_date") }}</label
            >
          </span>
        </div>
        <div class="col-md-12">
          <span :class="['bmd-form-group mb-1 d-block form-label-group']">
            <input
              type="text"
              class="form-control"
              v-model="rwb_consignor_doc.mode_code"
              :placeholder="$t('message.contracts.rwb_consignor_doc_mode_code')"
              autocomplete="off"
              style="cursor: auto"
              id="rwb_consignor_doc_mode_code"
            />
            <label
              for="rwb_consignor_doc_mode_code"
              class="form-label-group-label shorter"
              >{{ $t("message.contracts.rwb_consignor_doc_mode_code") }}</label
            >
          </span>
        </div>
        <div class="col-md-12">
          <span
            :class="['bmd-form-group mb-2 d-block form-label-group shorter']"
          >
            <!-- <b-form-datepicker :locale="locale" v-model="rwb_consignor_doc.expiration_date" :placeholder="$t('message.contracts.rwb_consignor_doc_expiration_date')" size="sm" no-flip :hide-header="true" :show-decade-nav="false" id="rwb_consignor_doc_expiration_date"></b-form-datepicker>
						<label v-if="rwb_consignor_doc.expiration_date!=''" for="rwb_consignor_doc_expiration_date" class="form-label-group-label shorter topped">{{$t('message.contracts.rwb_consignor_doc_expiration_date')}}</label> -->

            <datepicker
              value-type="YYYY-MM-DD"
              format="DD.MM.YYYY"
              @focus="rwb_consignor_doc.expiration_date = ' '"
              @blur="
                rwb_consignor_doc.expiration_date == ' '
                  ? (rwb_consignor_doc.expiration_date = '')
                  : (rwb_consignor_doc.expiration_date =
                      rwb_consignor_doc.expiration_date)
              "
              inputClass="form-control"
              v-model="rwb_consignor_doc.expiration_date"
              :placeholder="
                $t('message.contracts.rwb_consignor_doc_expiration_date')
              "
              :inputAttr="{ id: 'rwb_consignor_doc_expiration_date' }"
            />
            <label
              for="rwb_consignor_doc_expiration_date"
              class="form-label-group-label shorter"
              :class="
                rwb_consignor_doc.expiration_date != '' &&
                rwb_consignor_doc.expiration_date != null
                  ? 'topped'
                  : ''
              "
              >{{
                $t("message.contracts.rwb_consignor_doc_expiration_date")
              }}</label
            >
          </span>
        </div>
        <div class="col-md-12">
          <span :class="['bmd-form-group mb-1 d-block form-label-group']">
            <input
              type="text"
              class="form-control"
              v-model="rwb_consignor_doc.release_customs"
              :placeholder="
                $t('message.contracts.rwb_consignor_doc_release_customs')
              "
              autocomplete="off"
              style="cursor: auto"
              id="rwb_consignor_doc_release_customs"
            />
            <label
              for="rwb_consignor_doc_release_customs"
              class="form-label-group-label shorter"
              >{{
                $t("message.contracts.rwb_consignor_doc_release_customs")
              }}</label
            >
          </span>
        </div>
      </div>

      <button
        v-if="is_rwb_consignor_doc_edit"
        @click="save_consignor_doc()"
        class="btn btn-success"
      >
        {{ $t("message.add") }}
      </button>
      <button
        id="rwb-add-document-button"
        v-else
        @click="add_consignor_doc()"
        class="btn btn-success"
      >
        {{ $t("message.add") }}
      </button>
    </b-modal>
  </div>
</template>
<script>
var querystring = require("querystring");
import { required } from "vuelidate/lib/validators";
import moment from "moment";
export default {
  props: ["goods", "contract_details", "document_id", "is_new", "document"],
  name: "form-rwb",
  data() {
    return {
      is_rwb_consignor_doc_edit: false,
      rwb_consignor_doc_edit_index: -1,
      is_rwb_paid_rw_code_edit: false,
      rwb_paid_rw_code_edit_index: -1,
      is_rwb_stamp_edit: false,
      rwb_stamp_edit_index: -1,
      rwb_stamp_edit_number: -1,
      is_rwb_seal_edit: false,
      rwb_seal_edit_index: -1,
      is_rwb_carriage_edit: false,
      rwb_carriage_edit_index: -1,
      is_rwb_auto_edit: false,
      rwb_auto_edit_index: -1,
      is_rwb_container_edit: false,
      rwb_container_change_index: -1,
      is_carrier_charge_edit: false,
      carrier_charge_edit_index: -1,
      is_carrier_station_edit: false,
      carrier_station_edit_index: -1,
      is_carrier_edit: false,
      carrier_edit_index: -1,
      is_good_edit: false,
      edit_good_index: -1,
      show_code_sign_type: false,
      sign_with_code_code: "",

      buttons_loading: false,

      current_stamp: 33,

      companies: [],
      countries: [],
      rw_stations: [],
      currencies: [],
      packagings: [],
      measures: [],

      departure_station_focused: false,
      border_station_focused: false,
      contract_carrier_station_focused: false,
      rwb_carrier_tech_station_focused: false,
      rwb_stamp_station_focused: false,
      arrival_station_focused: false,
      destination_station_focused: false,
      consignor_focused: false,
      consignee_focused: false,
      departure_country_focused: false,
      border_country_focused: false,
      contract_carrier_country_focused: false,
      arrival_country_focused: false,
      rwb_good_currency_focused: false,
      carrier_from_country_focused: false,
      rwb_container_container_capacity_unit_code_focused: false,
      transport_nationality_focused: false,
      rwb_stamp_country_focused: false,
      rwb_carrier_charge_to_country_focused: false,
      rwb_carrier_charge_from_country_focused: false,
      rwb_carrier_charge_from_station_focused: false,
      rwb_carrier_charge_to_station_focused: false,
      rcv_payment_currency_focused: false,
      rcv_tarif_currency_code_focused: false,
      snd_payment_currency_focused: false,
      snd_tarif_currency_code_focused: false,
      carrier_to_country_focused: false,
      carrier_tech_station_country_focused: false,
      rwb_paid_rw_code_from_country_focused: false,

      contract_carrier_date_time_moscow_date: "",
      contract_carrier_date_time_moscow_time: "",
      arrival_date_time_moscow_date: "",
      arrival_date_time_moscow_time: "",
      rwb_stamp_date_time_moscow_time: "",
      rwb_stamp_date_time_moscow_date: "",

      rwb_good_fields: [
        {
          key: "container_indicator",
          label: this.$t("message.contracts.rwb_good_container_indicator"),
        },
        {
          key: "work_tool_description",
          label: this.$t("message.contracts.rwb_good_work_tool_description"),
        },
        {
          key: "conductor_description",
          label: this.$t("message.contracts.rwb_good_conductor_description"),
        },
        {
          key: "place_goods_quantity",
          label: this.$t("message.contracts.rwb_good_place_goods_quantity"),
        },
        {
          key: "places_quantity",
          label: this.$t("message.contracts.rwb_good_places_quantity"),
        },
        {
          key: "gross_weight_quantity",
          label: this.$t("message.contracts.rwb_good_gross_weight_quantity"),
        },
        {
          key: "places_description",
          label: this.$t("message.contracts.rwb_good_places_description"),
        },
        {
          key: "harmonized_range_goods",
          label: this.$t("message.contracts.rwb_good_harmonized_range_goods"),
        },
        {
          key: "packing",
          label: this.$t("message.contracts.rwb_good_packing"),
        },
        {
          key: "marking",
          label: this.$t("message.contracts.rwb_good_marking"),
        },
        {
          key: "carriage_number",
          label: this.$t("message.contracts.rwb_good_carriage_number"),
        },
        {
          key: "container_number",
          label: this.$t("message.contracts.rwb_good_container_number"),
        },
        {
          key: "goods_numeric",
          label: this.$t("message.contracts.rwb_good_goods_numeric"),
        },
        {
          key: "customs_code",
          label: this.$t("message.contracts.rwb_good_customs_code"),
        },
        {
          key: "gtd_number",
          label: this.$t("message.contracts.rwb_good_gtd_number"),
        },
        {
          key: "gcost",
          label: this.$t("message.contracts.rwb_good_gcost"),
        },
        {
          key: "currency",
          label: this.$t("message.contracts.rwb_good_currency"),
        },
        {
          key: "mrn",
          label: this.$t("message.contracts.rwb_good_mrn"),
        },
        {
          key: "actions",
          label: "",
        },
      ],

      rwb_carrier_fields: [
        {
          key: "id",
          label: this.$t("message.contracts.rwb_carrier_id"),
        },
        {
          key: "carrier_name",
          label: this.$t("message.contracts.rwb_carrier_carrier_name"),
        },
        {
          key: "carrier_code",
          label: this.$t("message.contracts.rwb_carrier_carrier_code"),
        },
        {
          key: "from_station_code",
          label: this.$t("message.contracts.rwb_carrier_from_station_code"),
        },
        {
          key: "from_station_name",
          label: this.$t("message.contracts.rwb_carrier_from_station_name"),
        },
        {
          key: "from_rw_name",
          label: this.$t("message.contracts.rwb_carrier_from_rw_name"),
        },
        {
          key: "from_country",
          label: this.$t("message.contracts.rwb_carrier_from_country"),
        },
        {
          key: "to_station_code",
          label: this.$t("message.contracts.rwb_carrier_to_station_code"),
        },
        {
          key: "to_station_name",
          label: this.$t("message.contracts.rwb_carrier_to_station_name"),
        },
        {
          key: "to_rw_name",
          label: this.$t("message.contracts.rwb_carrier_to_rw_name"),
        },
        {
          key: "to_country",
          label: this.$t("message.contracts.rwb_carrier_to_country"),
        },
        {
          key: "tech_stat",
          label: this.$t("message.contracts.rwb_carrier_tech_station"),
        },
        {
          key: "actions",
          label: "",
        },
      ],

      rwb_carrier_tech_station_fields: [
        {
          key: "order_number",
          label: this.$t(
            "message.contracts.rwb_carrier_tech_station_order_number",
          ),
        },
        {
          key: "tech_signs",
          label: this.$t(
            "message.contracts.rwb_carrier_tech_station_tech_signs",
          ),
        },
        {
          key: "station_code",
          label: this.$t(
            "message.contracts.rwb_carrier_tech_station_station_code",
          ),
        },
        {
          key: "station_name",
          label: this.$t(
            "message.contracts.rwb_carrier_tech_station_station_name",
          ),
        },
        {
          key: "rw_name",
          label: this.$t("message.contracts.rwb_carrier_tech_station_rw_name"),
        },
        {
          key: "country",
          label: this.$t("message.contracts.rwb_carrier_tech_station_country"),
        },
        {
          key: "actions",
          label: "",
        },
      ],

      rwb_container_fields: [
        {
          key: "container_id",
          label: this.$t("message.contracts.rwb_container_container_id"),
        },
        {
          key: "rw_code",
          label: this.$t("message.contracts.rwb_container_rw_code"),
        },
        {
          key: "container_kind",
          label: this.$t("message.contracts.rwb_container_container_kind"),
        },
        {
          key: "container_mode_desc",
          label: this.$t("message.contracts.rwb_container_container_mode_desc"),
        },
        {
          key: "container_capacity",
          label: this.$t("message.contracts.rwb_container_container_capacity"),
        },
        {
          key: "container_capacity_unit_code",
          label: this.$t(
            "message.contracts.rwb_container_container_capacity_unit_code",
          ),
        },
        {
          key: "tare",
          label: this.$t("message.contracts.rwb_container_tare"),
        },
        {
          key: "goods_weight",
          label: this.$t("message.contracts.rwb_container_goods_weight"),
        },
        {
          key: "places_quentity",
          label: this.$t("message.contracts.rwb_container_places_quentity"),
        },
        {
          key: "pocket_quentity",
          label: this.$t("message.contracts.rwb_container_pocket_quentity"),
        },
        {
          key: "container_length",
          label: this.$t("message.contracts.rwb_container_container_length"),
        },
        {
          key: "actions",
          label: "",
        },
      ],

      rwb_auto_fields: [
        {
          key: "vin",
          label: this.$t("message.contracts.rwb_auto_vin"),
        },
        {
          key: "transport_kind",
          label: this.$t("message.contracts.rwb_auto_transport_kind"),
        },
        {
          key: "transport_mark",
          label: this.$t("message.contracts.rwb_auto_transport_mark"),
        },
        {
          key: "transport_identifier",
          label: this.$t("message.contracts.rwb_auto_transport_identifier"),
        },
        {
          key: "transport_nationality",
          label: this.$t("message.contracts.rwb_auto_transport_nationality"),
        },
        {
          key: "active_transport_identifier",
          label: this.$t(
            "message.contracts.rwb_auto_active_transport_identifier",
          ),
        },
        {
          key: "transport_regnumber",
          label: this.$t("message.contracts.rwb_auto_transport_regnumber"),
        },
        {
          key: "wagon_number",
          label: this.$t("message.contracts.rwb_auto_wagon_number"),
        },
        {
          key: "tare",
          label: this.$t("message.contracts.rwb_auto_tare"),
        },
        {
          key: "goods_weight",
          label: this.$t("message.contracts.rwb_auto_goods_weight"),
        },
        {
          key: "places_quentity",
          label: this.$t("message.contracts.rwb_auto_places_quentity"),
        },
        {
          key: "pocket_quentity",
          label: this.$t("message.contracts.rwb_auto_pocket_quentity"),
        },
        {
          key: "container_length",
          label: this.$t("message.contracts.rwb_auto_container_length"),
        },
        {
          key: "actions",
          label: "",
        },
      ],

      rwb_carriage_fields: [
        {
          key: "carriage_id",
          label: this.$t("message.contracts.rwb_carriage_carriage_id"),
        },
        {
          key: "rw_name",
          label: this.$t("message.contracts.rwb_carriage_rw_name"),
        },
        {
          key: "owner_name",
          label: this.$t("message.contracts.rwb_carriage_owner_name"),
        },
        {
          key: "owner_type",
          label: this.$t("message.contracts.rwb_carriage_owner_type"),
        },
        {
          key: "rw_power",
          label: this.$t("message.contracts.rwb_carriage_rw_power"),
        },
        {
          key: "axis_quentity",
          label: this.$t("message.contracts.rwb_carriage_axis_quentity"),
        },
        {
          key: "tare",
          label: this.$t("message.contracts.rwb_carriage_tare"),
        },
        {
          key: "goods_weight",
          label: this.$t("message.contracts.rwb_carriage_goods_weight"),
        },
        {
          key: "caliber",
          label: this.$t("message.contracts.rwb_carriage_caliber"),
        },
        {
          key: "actions",
          label: "",
        },
      ],

      rwb_seal_fields: [
        {
          key: "seal_id",
          label: this.$t("message.contracts.rwb_seal_seal_id"),
        },
        {
          key: "seal_quentity",
          label: this.$t("message.contracts.rwb_seal_seal_quentity"),
        },
        {
          key: "ident_kind",
          label: this.$t("message.contracts.rwb_seal_ident_kind"),
        },
        {
          key: "ident_desc",
          label: this.$t("message.contracts.rwb_seal_ident_desc"),
        },
        {
          key: "actions",
          label: "",
        },
      ],

      rwb_stamp_fields: [
        {
          key: "carrier_name",
          label: this.$t("message.contracts.rwb_stamp_carrier_name"),
        },
        {
          key: "date",
          label: this.$t("message.contracts.rwb_stamp_date"),
        },
        {
          key: "time",
          label: this.$t("message.contracts.rwb_stamp_time"),
        },
        {
          key: "date_time_moscow",
          label: this.$t("message.contracts.rwb_stamp_date_time_moscow"),
        },
        {
          key: "station_code",
          label: this.$t("message.contracts.rwb_stamp_station_code"),
        },
        {
          key: "station_name",
          label: this.$t("message.contracts.rwb_stamp_station_name"),
        },
        {
          key: "rw_name",
          label: this.$t("message.contracts.rwb_stamp_rw_name"),
        },
        {
          key: "rw_code",
          label: this.$t("message.contracts.rwb_stamp_rw_code"),
        },
        {
          key: "country",
          label: this.$t("message.contracts.rwb_stamp_country"),
        },
        {
          key: "actions",
          label: "",
        },
      ],

      rwb_carrier_charge_fields: [
        {
          key: "order_no",
          label: this.$t("message.contracts.rwb_carrier_charge_order_no"),
        },
        {
          key: "carrier_code",
          label: this.$t("message.contracts.rwb_carrier_charge_carrier_code"),
        },
        {
          key: "from_station_code",
          label: this.$t(
            "message.contracts.rwb_carrier_charge_from_station_code",
          ),
        },
        {
          key: "from_station_name",
          label: this.$t(
            "message.contracts.rwb_carrier_charge_from_station_name",
          ),
        },
        {
          key: "from_rw_name",
          label: this.$t("message.contracts.rwb_carrier_charge_from_rw_name"),
        },
        {
          key: "from_country",
          label: this.$t("message.contracts.rwb_carrier_charge_from_country"),
        },
        {
          key: "to_station_code",
          label: this.$t(
            "message.contracts.rwb_carrier_charge_to_station_code",
          ),
        },
        {
          key: "to_station_name",
          label: this.$t(
            "message.contracts.rwb_carrier_charge_to_station_name",
          ),
        },
        {
          key: "to_rw_name",
          label: this.$t("message.contracts.rwb_carrier_charge_to_rw_name"),
        },
        {
          key: "to_country",
          label: this.$t("message.contracts.rwb_carrier_charge_to_country"),
        },
        {
          key: "distance",
          label: this.$t("message.contracts.rwb_carrier_charge_distance"),
        },
        {
          key: "calc_weight",
          label: this.$t("message.contracts.rwb_carrier_charge_calc_weight"),
        },
        {
          key: "extra_charge_code",
          label: this.$t(
            "message.contracts.rwb_carrier_charge_extra_charge_code",
          ),
        },
        {
          key: "extra_charge_name",
          label: this.$t(
            "message.contracts.rwb_carrier_charge_extra_charge_name",
          ),
        },
        {
          key: "extra_charge_amount",
          label: this.$t(
            "message.contracts.rwb_carrier_charge_extra_charge_amount",
          ),
        },
        {
          key: "tarif_code",
          label: this.$t("message.contracts.rwb_carrier_charge_tarif_code"),
        },
        {
          key: "calc_cargo_code",
          label: this.$t(
            "message.contracts.rwb_carrier_charge_calc_cargo_code",
          ),
        },
        {
          key: "currency_rate",
          label: this.$t("message.contracts.rwb_carrier_charge_currency_rate"),
        },
        {
          key: "snd_tarif_currency_code",
          label: this.$t(
            "message.contracts.rwb_carrier_charge_snd_tarif_currency_code",
          ),
        },
        {
          key: "snd_payment_currency",
          label: this.$t(
            "message.contracts.rwb_carrier_charge_snd_payment_currency",
          ),
        },
        {
          key: "rcv_tarif_currency_code",
          label: this.$t(
            "message.contracts.rwb_carrier_charge_rcv_tarif_currency_code",
          ),
        },
        {
          key: "rcv_payment_currency",
          label: this.$t(
            "message.contracts.rwb_carrier_charge_rcv_payment_currency",
          ),
        },
        {
          key: "amount48",
          label: this.$t("message.contracts.rwb_carrier_charge_amount48"),
        },
        {
          key: "amount49",
          label: this.$t("message.contracts.rwb_carrier_charge_amount49"),
        },
        {
          key: "amount50",
          label: this.$t("message.contracts.rwb_carrier_charge_amount50"),
        },
        {
          key: "amount51",
          label: this.$t("message.contracts.rwb_carrier_charge_amount51"),
        },
        {
          key: "amount52",
          label: this.$t("message.contracts.rwb_carrier_charge_amount52"),
        },
        {
          key: "amount53",
          label: this.$t("message.contracts.rwb_carrier_charge_amount53"),
        },
        {
          key: "amount54",
          label: this.$t("message.contracts.rwb_carrier_charge_amount54"),
        },
        {
          key: "amount55",
          label: this.$t("message.contracts.rwb_carrier_charge_amount55"),
        },
        {
          key: "amount56",
          label: this.$t("message.contracts.rwb_carrier_charge_amount56"),
        },
        {
          key: "amount57",
          label: this.$t("message.contracts.rwb_carrier_charge_amount57"),
        },
        {
          key: "amount58",
          label: this.$t("message.contracts.rwb_carrier_charge_amount58"),
        },
        {
          key: "amount59",
          label: this.$t("message.contracts.rwb_carrier_charge_amount59"),
        },
        {
          key: "actions",
          label: "",
        },
      ],

      rwb_paid_rw_code_fields: [
        {
          key: "paid_rw_name",
          label: this.$t("message.contracts.rwb_paid_rw_code_paid_rw_name"),
        },
        {
          key: "paid_rw_code",
          label: this.$t("message.contracts.rwb_paid_rw_code_paid_rw_code"),
        },
        {
          key: "paid_rw_short",
          label: this.$t("message.contracts.rwb_paid_rw_code_paid_rw_short"),
        },
        {
          key: "payer_code",
          label: this.$t("message.contracts.rwb_paid_rw_code_payer_code"),
        },
        {
          key: "payer_name",
          label: this.$t("message.contracts.rwb_paid_rw_code_payer_name"),
        },
        {
          key: "from_rw_name",
          label: this.$t("message.contracts.rwb_paid_rw_code_from_rw_name"),
        },
        {
          key: "from_country",
          label: this.$t("message.contracts.rwb_paid_rw_code_from_country"),
        },
        {
          key: "actions",
          label: "",
        },
      ],

      rwb_consignor_doc_fields: [
        {
          key: "doc_name",
          label: this.$t("message.contracts.rwb_consignor_doc_doc_name"),
        },
        {
          key: "doc_number",
          label: this.$t("message.contracts.rwb_consignor_doc_doc_number"),
        },
        {
          key: "doc_date",
          label: this.$t("message.contracts.rwb_consignor_doc_doc_date"),
        },
        {
          key: "mode_code",
          label: this.$t("message.contracts.rwb_consignor_doc_mode_code"),
        },
        {
          key: "expiration_date",
          label: this.$t("message.contracts.rwb_consignor_doc_expiration_date"),
        },
        {
          key: "release_customs",
          label: this.$t("message.contracts.rwb_consignor_doc_release_customs"),
        },
        {
          key: "actions",
          label: "",
        },
      ],

      rwb_good: {
        container_indicator: "",
        work_tool_description: "",
        conductor_description: "",
        place_goods_quantity: "",
        places_quantity: "",
        gross_weight_quantity: "",
        places_description: "",
        harmonized_range_goods: "",
        packing: "",
        marking: "",
        carriage_number: "",
        container_number: "",
        goods_numeric: "",
        customs_code: "",
        gtd_number: "",
        gcost: "",
        currency: { value: "" },
        mrn: "",
      },

      rwb_carrier: {
        id: "",
        carrier_name: "",
        carrier_code: "",
        from_station_code: "",
        from_station_name: "",
        from_rw_name: "",
        from_country: { value: "" },
        to_station_code: "",
        to_station_name: "",
        to_rw_name: "",
        to_country: { value: "" },
        tech_station: [],
      },

      rwb_carrier_tech_station: {
        order_number: "",
        tech_signs: "",
        station_code: "",
        station_name: "",
        station: { value: "", display_text: "" },
        rw_name: "",
        country: { value: "" },
      },

      rwb_container: {
        container_id: "",
        rw_code: "",
        container_kind: "",
        container_mode_desc: "",
        container_capacity: "",
        container_capacity_unit_code: { value: "" },
        tare: "",
        goods_weight: "",
        places_quentity: "",
        pocket_quentity: "",
        container_length: "",
      },

      rwb_auto: {
        vin: "",
        transport_kind: "",
        transport_mark: "",
        transport_identifier: "",
        transport_nationality: { value: "" },
        active_transport_identifier: "",
        transport_regnumber: "",
        wagon_number: "",
        tare: "",
        goods_weight: "",
        places_quentity: "",
        pocket_quentity: "",
        container_length: "",
      },

      rwb_carriage: {
        carriage_id: "",
        rw_name: "",
        owner_name: "",
        owner_type: "",
        rw_power: "",
        axis_quentity: "",
        tare: "",
        goods_weight: "",
        caliber: "",
      },

      rwb_seal: {
        seal_id: "",
        seal_quentity: "",
        ident_kind: "",
        ident_desc: "",
      },

      rwb_stamp: {
        carrier_name: "",
        date: "",
        time: "",
        date_time_moscow: "",
        station_code: "",
        station_name: "",
        station: { value: "", display_text: "" },
        rw_name: "",
        rw_code: "",
        country: { value: "" },
      },

      rwb_carrier_charge: {
        order_no: "",
        carrier_code: "",
        from_station_code: "",
        from_station_name: "",
        from_station: { value: "", display_text: "" },
        to_station: { value: "", display_text: "" },
        from_rw_name: "",
        from_country: { value: "" },
        to_station_code: "",
        to_station_name: "",
        to_rw_name: "",
        to_country: { value: "" },
        distance: "",
        calc_weight: "",
        extra_charge_code: "",
        extra_charge_name: "",
        extra_charge_amount: "",
        tarif_code: "",
        calc_cargo_code: "",
        currency_rate: "",
        snd_tarif_currency_code: { value: "" },
        snd_payment_currency: { value: "" },
        rcv_tarif_currency_code: { value: "" },
        rcv_payment_currency: { value: "" },
        amount48: "",
        amount49: "",
        amount50: "",
        amount51: "",
        amount52: "",
        amount53: "",
        amount54: "",
        amount55: "",
        amount56: "",
        amount57: "",
        amount58: "",
        amount59: "",
      },

      rwb_paid_rw_code: {
        paid_rw_name: "",
        paid_rw_code: "",
        paid_rw_short: "",
        payer_code: "",
        payer_name: "",
        from_rw_name: "",
        from_country: { value: "" },
      },

      rwb_consignor_doc: {
        doc_name: "",
        doc_number: "",
        doc_date: "",
        mode_code: "",
        expiration_date: "",
        release_customs: "",
      },

      RWB: {
        doc_id: "",
        refdocid: "",
        consignor_notice: "",
        places_quantity: "",
        gross_weight_quantity: "",
        departure_mode_description: "",
        loader_mode_description: "",
        additional_sheet_quantity: "",
        cargo_value: "",
        customs_notice: "",
        weight_definition_mode_description: "",
        carrier_notice: "",
        commerce_akt: "",
        prolongation: "",
        issue_marks: "",
        amount60: "",
        amount61: "",
        amount62: "",
        amount63: "",
        calculation_notice: "",
        addition_payment: "",

        consignor_option_notice: "",
        consignor: { value: "" },
        consignee: { value: "" },
        departure_station: { value: "", display_text: "" },
        departure_station_code: "",
        departure_station_name: "",
        departure_rwcode: "",
        departure_rwname: "",
        departure_country: { value: "" },
        destination_rwcode: "",
        destination_station_code: "",
        destination_rwand_station_name: "",
        border_station: { value: "", display_text: "" },
        border_station_code: "",
        border_station_name: "",
        border_rwcode: "",
        border_rwname: "",
        border_country: { value: "" },
        contract_name: "",
        contract_number: "",
        contract_date: "",
        flat_pallet_quantity: "",
        box_pallet_quantity: "",
        pallet_exchange_mode: "",
        work_tool_id: "",
        work_tool_container_description: "",
        work_tool_railway_code: "",
        mark_sing: "",
        mark_kind: "",
        mark_result_control: "",
        contract_carrier_name: "",
        contract_carrier_time: "",
        contract_carrier_date: "",
        contract_carrier_date_time_moscow: "",
        contract_carrier_station: { value: "", display_text: "" },
        contract_carrier_station_code: "",
        contract_carrier_station_name: "",
        contract_carrier_rw_name: "",
        contract_carrier_country: { value: "" },
        arrival_carrier_name: "",
        arrival_date: "",
        arrival_time: "",
        arrival_date_time_moscow: "",
        arrival_station_code: "",
        arrival_station: { value: "", display_text: "" },
        arrival_station_name: "",
        destination_station: { value: "", display_text: "" },
        arrival_rw_name: "",
        arrival_rw_code: "",
        arrival_country: { value: "" },
        goods: [],
        carrier: [],
        container: [],
        auto: [],
        carriage: [],
        seal: [],
        stamp33: [],
        stamp34: [],
        stamp35: [],
        carrier_charge: [],
        paid_rw_code: [],
        consignor_doc: [],
      },

      cleaveWeight: {
        numeral: true,
        numeralPositiveOnly: true,
        blocks: [24],
        numeralDecimalScale: 6,
      },

      cleaveInt: {
        numeral: true,
        numeralDecimalMark: "",
        delimiter: "",
      },
    };
  },
  methods: {
    edit_rwb_consignor_doc(doc, index) {
      this.rwb_consignor_doc = doc;
      this.rwb_consignor_doc_edit_index = index;
      this.is_rwb_consignor_doc_edit = true;
      this.$bvModal.show("modal-add-rwb-consignor_doc");
    },
    save_consignor_doc() {
      this.RWB.consignor_doc[this.rwb_consignor_doc_edit_index] = {
        ...this.rwb_consignor_doc,
      };
      this.rwb_consignor_doc_edit_index = -1;
      this.is_rwb_consignor_doc_edit = false;
      this.$bvModal.hide("modal-add-rwb-consignor_doc");
      this.rwb_consignor_doc = {
        doc_name: "",
        doc_number: "",
        doc_date: "",
        mode_code: "",
        expiration_date: "",
        release_customs: "",
      };
    },
    edit_rwb_paid_rw_code(code, index) {
      this.rwb_paid_rw_code = code;
      this.is_rwb_paid_rw_code_edit = true;
      this.rwb_paid_rw_code_edit_index = index;
      this.$bvModal.show("modal-add-rwb-paid_rw_code");
    },
    save_paid_rw_code() {
      this.RWB.paid_rw_code[this.rwb_paid_rw_code_edit_index] = {
        ...this.rwb_paid_rw_code,
      };
      this.$bvModal.hide("modal-add-rwb-paid_rw_code");
      this.is_rwb_paid_rw_code_edit = false;
      this.rwb_paid_rw_code_edit_index = -1;
      this.rwb_carrier_tech_station = {
        paid_rw_name: "",
        paid_rw_code: "",
        paid_rw_short: "",
        station: { value: "", display_text: "" },
        payer_code: "",
        payer_name: "",
        from_rw_name: "",
        from_country: { value: "" },
      };
    },
    edit_rwb_stamp(stamp, index, number) {
      this.current_stamp = number;
      this.rwb_stamp = stamp;
      this.is_rwb_stamp_edit = true;
      this.rwb_stamp_edit_index = index;
      this.$bvModal.show("modal-add-rwb-stamp");
    },
    save_stamp() {
      switch (this.current_stamp) {
        case 33:
          this.RWB.stamp33[this.rwb_stamp_edit_index] = { ...this.rwb_stamp };
          this.RWB.stamp33[this.rwb_stamp_edit_index].station_code =
            this.RWB.stamp33[this.rwb_stamp_edit_index].station.value;
          this.RWB.stamp33[this.rwb_stamp_edit_index].station_name =
            this.RWB.stamp33[this.rwb_stamp_edit_index].station.display_text;
          break;
        case 34:
          this.RWB.stamp34[this.rwb_stamp_edit_index] = { ...this.rwb_stamp };
          this.RWB.stamp34[this.rwb_stamp_edit_index].station_code =
            this.RWB.stamp34[this.rwb_stamp_edit_index].station.value;
          this.RWB.stamp34[this.rwb_stamp_edit_index].station_name =
            this.RWB.stamp34[this.rwb_stamp_edit_index].station.display_text;
          break;
        case 35:
          this.RWB.stamp35[this.rwb_stamp_edit_index] = { ...this.rwb_stamp };
          this.RWB.stamp35[this.rwb_stamp_edit_index].station_code =
            this.RWB.stamp35[this.rwb_stamp_edit_index].station.value;
          this.RWB.stamp35[this.rwb_stamp_edit_index].station_name =
            this.RWB.stamp35[this.rwb_stamp_edit_index].station.display_text;
          break;
      }
      this.$bvModal.hide("modal-add-rwb-stamp");
      this.is_rwb_stamp_edit = false;
      this.rwb_stamp_edit_index = -1;
      this.rwb_stamp = {
        carrier_name: "",
        date: "",
        time: "",
        date_time_moscow: "",
        station_code: "",
        station_name: "",
        station: { value: "", display_text: "" },
        rw_name: "",
        rw_code: "",
        country: { value: "" },
      };
    },
    edit_rwb_seal(seal, index) {
      this.rwb_seal = seal;
      this.rwb_seal_edit_index = index;
      this.is_rwb_seal_edit = true;
      this.$bvModal.show("modal-add-rwb-seal");
    },
    save_seal() {
      this.RWB.seal[this.rwb_seal_edit_index] = { ...this.rwb_seal };
      this.$bvModal.hide("modal-add-rwb-seal");
      this.rwb_seal_edit_index = -1;
      this.is_rwb_seal_edit = false;
      this.rwb_seal = {
        seal_id: "",
        seal_quentity: "",
        ident_kind: "",
        ident_desc: "",
      };
    },
    edit_rwb_carriage(carriage, index) {
      this.rwb_carriage = carriage;
      this.is_rwb_carriage_edit = true;
      this.rwb_carriage_edit_index = index;
      this.$bvModal.show("modal-add-rwb-carriage");
    },
    save_carriage() {
      this.RWB.carriage[this.rwb_carriage_edit_index] = {
        ...this.rwb_carriage,
      };
      this.is_rwb_carriage_edit = false;
      this.rwb_carriage_edit_index = -1;
      this.$bvModal.hide("modal-add-rwb-carriage");
      this.rwb_carriage = {
        carriage_id: "",
        rw_name: "",
        owner_name: "",
        owner_type: "",
        rw_power: "",
        axis_quentity: "",
        tare: "",
        goods_weight: "",
        caliber: "",
      };
    },
    edit_rwb_auto(auto, index) {
      this.rwb_auto = auto;
      this.is_rwb_auto_edit = true;
      this.rwb_auto_edit_index = index;
      this.$bvModal.show("modal-add-rwb-auto");
    },
    save_auto() {
      this.RWB.auto[this.rwb_auto_edit_index] = { ...this.rwb_auto };
      this.is_rwb_auto_edit = false;
      this.rwb_auto_edit_index = -1;
      this.$bvModal.hide("modal-add-rwb-auto");
      this.rwb_auto = {
        vin: "",
        transport_kind: "",
        transport_mark: "",
        transport_identifier: "",
        transport_nationality: "",
        active_transport_identifier: "",
        transport_regnumber: "",
        wagon_number: "",
        tare: "",
        goods_weight: "",
        places_quentity: "",
        pocket_quentity: "",
        container_length: "",
      };
    },
    edit_rwb_container(container, index) {
      this.rwb_container = container;
      this.is_rwb_container_edit = true;
      this.rwb_container_change_index = index;
      this.$bvModal.show("modal-add-rwb-container");
    },
    save_container() {
      this.RWB.container[this.rwb_container_change_index] = {
        ...this.rwb_container,
      };
      this.is_rwb_container_edit = false;
      this.rwb_container_change_index = -1;
      this.$bvModal.hide("modal-add-rwb-container");
      this.rwb_container = {
        container_id: "",
        rw_code: "",
        container_kind: "",
        container_mode_desc: "",
        container_capacity: "",
        container_capacity_unit_code: { value: "" },
        tare: "",
        goods_weight: "",
        places_quentity: "",
        pocket_quentity: "",
        container_length: "",
      };
    },
    edit_rwb_carrier_charge(charge, index) {
      this.rwb_carrier_charge = charge;
      this.is_carrier_charge_edit = true;
      this.carrier_charge_edit_index = index;
      this.$bvModal.show("modal-add-rwb-carrier-charge");
    },
    save_carrier_charge() {
      this.RWB.carrier_charge[this.carrier_charge_edit_index] = {
        ...this.rwb_carrier_charge,
      };
      this.RWB.carrier_charge[
        this.carrier_charge_edit_index
      ].from_station_code =
        this.RWB.carrier_charge[
          this.carrier_charge_edit_index
        ].from_station.value;
      this.RWB.carrier_charge[
        this.carrier_charge_edit_index
      ].from_station_name =
        this.RWB.carrier_charge[
          this.carrier_charge_edit_index
        ].from_station.display_text;

      this.RWB.carrier_charge[this.carrier_charge_edit_index].to_station_code =
        this.RWB.carrier_charge[
          this.carrier_charge_edit_index
        ].to_station.value;
      this.RWB.carrier_charge[this.carrier_charge_edit_index].to_station_name =
        this.RWB.carrier_charge[
          this.carrier_charge_edit_index
        ].to_station.display_text;
      this.$bvModal.hide("modal-add-rwb-carrier-charge");
      this.is_carrier_station_edit = false;
      this.carrier_station_edit_index = -1;
      this.rwb_carrier_charge = {
        order_no: "",
        carrier_code: "",
        from_station_code: "",
        from_station_name: "",
        from_station: { value: "", display_text: "" },
        to_station: { value: "", display_text: "" },
        from_rw_name: "",
        from_country: { value: "" },
        to_station_code: "",
        to_station_name: "",
        to_rw_name: "",
        to_country: { value: "" },
        distance: "",
        calc_weight: "",
        extra_charge_code: "",
        extra_charge_name: "",
        extra_charge_amount: "",
        tarif_code: "",
        calc_cargo_code: "",
        currency_rate: "",
        snd_tarif_currency_code: { value: "" },
        snd_payment_currency: { value: "" },
        rcv_tarif_currency_code: { value: "" },
        rcv_payment_currency: { value: "" },
        amount48: "",
        amount49: "",
        amount50: "",
        amount51: "",
        amount52: "",
        amount53: "",
        amount54: "",
        amount55: "",
        amount56: "",
        amount57: "",
        amount58: "",
        amount59: "",
      };
    },
    edit_rwb_carrier_tech_station(station, index) {
      this.rwb_carrier_tech_station = station;
      this.is_carrier_station_edit = true;
      this.carrier_station_edit_index = index;
      this.$bvModal.show("modal-add-rwb-carrier-tech-station");
    },
    save_carrier_station() {
      this.rwb_carrier_tech_station.station_name =
        this.rwb_carrier_tech_station.station.display_text;
      this.rwb_carrier_tech_station.station_code =
        this.rwb_carrier_tech_station.station.value;
      this.rwb_carrier.tech_station[this.carrier_station_edit_index] = {
        ...this.rwb_carrier_tech_station,
      };
      this.$bvModal.hide("modal-add-rwb-carrier-tech-station");
      this.is_carrier_station_edit = false;
      this.carrier_station_edit_index = -1;
      this.rwb_carrier_tech_station = {
        order_number: "",
        tech_signs: "",
        station_code: "",
        station_name: "",
        station: { value: "", display_text: "" },
        rw_name: "",
        country: { value: "" },
      };
    },
    edit_rwb_carrier(carrier, index) {
      this.rwb_carrier = carrier;
      this.is_carrier_edit = true;
      this.carrier_edit_index = index;
      this.$bvModal.show("modal-add-rwb-carrier");
    },
    save_carrier() {
      this.RWB.carrier[this.carrier_edit_index] = { ...this.rwb_carrier };
      this.$bvModal.hide("modal-add-rwb-carrier");
      this.is_carrier_edit = false;
      this.carrier_edit_index = -1;
      this.rwb_carrier = {
        id: "",
        carrier_name: "",
        carrier_code: "",
        from_station_code: "",
        from_station_name: "",
        from_rw_name: "",
        from_country: { value: "" },
        to_station_code: "",
        to_station_name: "",
        to_rw_name: "",
        to_country: { value: "" },
        tech_station: [],
      };
    },
    edit_rwb_goods(good, index) {
      this.rwb_good = good;
      this.is_good_edit = true;
      this.edit_good_index = index;
      this.$bvModal.show("modal-add-rwb-good");
    },
    save_good() {
      this.RWB.goods[this.edit_good_index] = { ...this.rwb_good };
      this.$bvModal.hide("modal-add-rwb-good");
      this.edit_good_index = -1;
      this.is_good_edit = false;
      this.rwb_good = {
        container_indicator: "",
        work_tool_description: "",
        conductor_description: "",
        place_goods_quantity: "",
        places_quantity: "",
        gross_weight_quantity: "",
        places_description: "",
        harmonized_range_goods: "",
        packing: "",
        marking: "",
        carriage_number: "",
        container_number: "",
        goods_numeric: "",
        customs_code: "",
        gtd_number: "",
        gcost: "",
        currency: { value: "" },
        mrn: "",
      };
    },
    /**
     * Adds consignor_doc to RWB list
     */
    add_consignor_doc() {
      this.RWB.consignor_doc.push({ ...this.rwb_consignor_doc });
      this.$bvModal.hide("modal-add-rwb-consignor_doc");
      this.rwb_consignor_doc = {
        doc_name: "",
        doc_number: "",
        doc_date: "",
        mode_code: "",
        expiration_date: "",
        release_customs: "",
      };
    },
    /**
     * Adds paid_rw_code to RWB list
     */
    add_paid_rw_code() {
      this.RWB.paid_rw_code.push({ ...this.rwb_paid_rw_code });
      this.$bvModal.hide("modal-add-rwb-paid_rw_code");
      this.rwb_carrier_tech_station = {
        paid_rw_name: "",
        paid_rw_code: "",
        paid_rw_short: "",
        station: { value: "", display_text: "" },
        payer_code: "",
        payer_name: "",
        from_rw_name: "",
        from_country: { value: "" },
      };
    },
    /**
     * Adds carrier tech_station to carrier
     */
    add_carrier_tech_station() {
      this.rwb_carrier_tech_station.station_name =
        this.rwb_carrier_tech_station.station.display_text;
      this.rwb_carrier_tech_station.station_code =
        this.rwb_carrier_tech_station.station.value;
      this.rwb_carrier.tech_station.push({ ...this.rwb_carrier_tech_station });
      this.$bvModal.hide("modal-add-rwb-carrier-tech-station");
      this.rwb_carrier_tech_station = {
        order_number: "",
        tech_signs: "",
        station_code: "",
        station_name: "",
        station: { value: "", display_text: "" },
        rw_name: "",
        country: { value: "" },
      };
    },
    /**
     * Adds carrier_charge to RWB list
     */
    add_carrier_charge() {
      this.rwb_carrier_charge.from_station_code =
        this.rwb_carrier_charge.from_station.value;
      this.rwb_carrier_charge.from_station_name =
        this.rwb_carrier_charge.from_station.display_text;

      this.rwb_carrier_charge.to_station_code =
        this.rwb_carrier_charge.to_station.value;
      this.rwb_carrier_charge.to_station_name =
        this.rwb_carrier_charge.to_station.display_text;
      this.RWB.carrier_charge.push({ ...this.rwb_carrier_charge });
      this.$bvModal.hide("modal-add-rwb-carrier-charge");
      this.rwb_carrier_charge = {
        order_no: "",
        carrier_code: "",
        from_station_code: "",
        from_station_name: "",
        from_station: { value: "", display_text: "" },
        to_station: { value: "", display_text: "" },
        from_rw_name: "",
        from_country: { value: "" },
        to_station_code: "",
        to_station_name: "",
        to_rw_name: "",
        to_country: { value: "" },
        distance: "",
        calc_weight: "",
        extra_charge_code: "",
        extra_charge_name: "",
        extra_charge_amount: "",
        tarif_code: "",
        calc_cargo_code: "",
        currency_rate: "",
        snd_tarif_currency_code: { value: "" },
        snd_payment_currency: { value: "" },
        rcv_tarif_currency_code: { value: "" },
        rcv_payment_currency: { value: "" },
        amount48: "",
        amount49: "",
        amount50: "",
        amount51: "",
        amount52: "",
        amount53: "",
        amount54: "",
        amount55: "",
        amount56: "",
        amount57: "",
        amount58: "",
        amount59: "",
      };
    },
    /**
     * Adds stamp to selected RWB list
     */
    add_stamp() {
      switch (this.current_stamp) {
        case 33:
          this.rwb_stamp.station_code = this.rwb_stamp.station.value;
          this.rwb_stamp.station_name = this.rwb_stamp.station.display_text;
          this.RWB.stamp33.push({ ...this.rwb_stamp });
          break;
        case 34:
          this.rwb_stamp.station_code = this.rwb_stamp.station.value;
          this.rwb_stamp.station_name = this.rwb_stamp.station.display_text;
          this.RWB.stamp34.push({ ...this.rwb_stamp });
          break;
        case 35:
          this.rwb_stamp.station_code = this.rwb_stamp.station.value;
          this.rwb_stamp.station_name = this.rwb_stamp.station.display_text;
          this.RWB.stamp35 = [{ ...this.rwb_stamp }];
          break;
      }
      this.$bvModal.hide("modal-add-rwb-stamp");
      this.rwb_stamp = {
        carrier_name: "",
        date: "",
        time: "",
        date_time_moscow: "",
        station_code: "",
        station_name: "",
        station: { value: "", display_text: "" },
        rw_name: "",
        rw_code: "",
        country: { value: "" },
      };
    },
    /**
     * Adds seal to RWB list
     */
    add_seal() {
      this.RWB.seal.push({ ...this.rwb_seal });
      this.$bvModal.hide("modal-add-rwb-seal");
      this.rwb_seal = {
        seal_id: "",
        seal_quentity: "",
        ident_kind: "",
        ident_desc: "",
      };
    },
    /**
     * Adds carriage to RWB list
     */
    add_carriage() {
      this.RWB.carriage.push({ ...this.rwb_carriage });
      this.$bvModal.hide("modal-add-rwb-carriage");
      this.rwb_carriage = {
        carriage_id: "",
        rw_name: "",
        owner_name: "",
        owner_type: "",
        rw_power: "",
        axis_quentity: "",
        tare: "",
        goods_weight: "",
        caliber: "",
      };
    },
    /**
     * Adds auto to RWB list
     */
    add_auto() {
      this.RWB.auto.push({ ...this.rwb_auto });
      this.$bvModal.hide("modal-add-rwb-auto");
      this.rwb_auto = {
        vin: "",
        transport_kind: "",
        transport_mark: "",
        transport_identifier: "",
        transport_nationality: "",
        active_transport_identifier: "",
        transport_regnumber: "",
        wagon_number: "",
        tare: "",
        goods_weight: "",
        places_quentity: "",
        pocket_quentity: "",
        container_length: "",
      };
    },
    /**
     * Adds container to RWB list
     */
    add_container() {
      this.RWB.container.push({ ...this.rwb_container });
      this.$bvModal.hide("modal-add-rwb-container");
      this.rwb_container = {
        container_id: "",
        rw_code: "",
        container_kind: "",
        container_mode_desc: "",
        container_capacity: "",
        container_capacity_unit_code: { value: "" },
        tare: "",
        goods_weight: "",
        places_quentity: "",
        pocket_quentity: "",
        container_length: "",
      };
    },
    /**
     * Adds carrier to RWB list
     */
    add_carrier() {
      this.RWB.carrier.push({ ...this.rwb_carrier });
      this.$bvModal.hide("modal-add-rwb-carrier");
      this.rwb_carrier = {
        id: "",
        carrier_name: "",
        carrier_code: "",
        from_station_code: "",
        from_station_name: "",
        from_rw_name: "",
        from_country: { value: "" },
        to_station_code: "",
        to_station_name: "",
        to_rw_name: "",
        to_country: { value: "" },
        tech_station: [],
      };
    },
    /**
     * Adds good to RWB list
     */
    add_good() {
      this.RWB.goods.push({ ...this.rwb_good });
      this.$bvModal.hide("modal-add-rwb-good");
      this.rwb_good = {
        container_indicator: "",
        work_tool_description: "",
        conductor_description: "",
        place_goods_quantity: "",
        places_quantity: "",
        gross_weight_quantity: "",
        places_description: "",
        harmonized_range_goods: "",
        packing: "",
        marking: "",
        carriage_number: "",
        container_number: "",
        goods_numeric: "",
        customs_code: "",
        gtd_number: "",
        gcost: "",
        currency: { value: "" },
        mrn: "",
      };
    },
    /**
     * Removes consignor_doc from RWB list
     */
    remove_rwb_consignor_doc(index) {
      this.RWB.consignor_doc.splice(index, 1);
    },
    /**
     * Removes paid_rw_code from RWB list
     */
    remove_rwb_paid_rw_code(index) {
      this.RWB.paid_rw_code.splice(index, 1);
    },
    /**
     * Removes carrier_charge from RWB list
     */
    remove_rwb_carrier_tech_station(index) {
      this.rwb_carrier.tech_station.splice(index, 1);
    },
    /**
     * Removes carrier_charge from RWB list
     */
    remove_rwb_carrier_charge(index) {
      this.RWB.carrier_charge.splice(index, 1);
    },
    /**
     * Removes stamp from selected RWB list
     */
    remove_rwb_stamp(index, current_stamp) {
      switch (current_stamp) {
        case 33:
          this.RWB.stamp33.splice(index, 1);
          break;
        case 34:
          this.RWB.stamp34.splice(index, 1);
          break;
        case 35:
          this.RWB.stamp35.splice(index, 1);
          break;
      }
    },
    /**
     * Removes seal from RWB list
     */
    remove_rwb_seal(index) {
      this.RWB.seal.splice(index, 1);
    },
    /**
     * Removes carriage from RWB list
     */
    remove_rwb_carriage(index) {
      this.RWB.carriage.splice(index, 1);
    },
    /**
     * Removes auto from RWB list
     */
    remove_rwb_auto(index) {
      this.RWB.auto.splice(index, 1);
    },
    /**
     * Removes container from RWB list
     */
    remove_rwb_container(index) {
      this.RWB.container.splice(index, 1);
    },
    /**
     * Removes carrier from RWB list
     */
    remove_rwb_carrier(index) {
      this.RWB.carrier.splice(index, 1);
    },
    /**
     * Removes good from RWB list
     */
    remove_rwb_good(index) {
      this.RWB.goods.splice(index, 1);
    },
    /**
     * Loads data from library using parameters type, query and qty,
     * sets results as an array to data-property with name of plural form of type
     */
    getLibrary(type, query, qty) {
      query = query.toLowerCase();
      axios
        .get(
          window.base +
            "/library?type=" +
            type +
            "&query=" +
            query +
            "&qty=" +
            qty +
            "&lang=" +
            this.$i18n.locale,
        )
        .then((response) => {
          var var_name = type;
          if (type[type.length - 1] == "s") {
            var_name = type + "es";
          } else if (type[type.length - 1] == "y") {
            var_name = type.substring(0, type.length - 1) + "ies";
          } else {
            var_name = type + "s";
          }
          this.$data[var_name] = [];
          response.data.forEach((item) => {
            if (item.value !== "··········") this.$data[var_name].push(item);
          });
        });
    },
    /**
     * Fetches list of measures from library
     */
    fetchMeasures(search, loading) {
      this.getLibrary("measure", search, 10000);
    },
    /**
     * Fetches list of currencies from library
     */
    fetchCurrencies(search, loading) {
      this.getLibrary("currency", search, 10000);
    },
    fetchPackagings(search, loading) {
      this.getLibrary("packaging", search, 10000);
    },
    /**
     * Fetches list of companies from library
     */
    fetchCountries(search, loading) {
      this.getLibrary("country", search, 10000);
    },
    fetchStations(search, loading) {
      this.getLibrary("rw_station", search, 10000);
    },
    /**
     * Fetches list of companies from library
     */
    fetchContragents(search, loading) {
      this.getLibrary("company", search, 10000);
    },
    /**
     * get contract XML and sends it to backend along with token from e-mail to sign data
     * after signing it gets the signature code and sends it back to the backend
     * to store signature in document
     */
    sign_with_code_phase2() {
      if (this.sign_with_code_code != "") {
        axios
          .get(
            window.base + "/document/LoadInvoiceXML?doc_id=" + this.document_id,
          )
          .then((response) => {
            var fd = new FormData();
            var xml = response.data.replace(
              '<?xml version="1.0" encoding="utf-16"?>',
              "",
            );
            fd.append("token", this.sign_with_code_code);
            fd.append("data", xml);
            axios
              .post(window.base + "/account/SignData", fd)
              .then((response) => {
                var fd = new FormData();
                fd.append("contract_id", this.document_id);
                fd.append("signature", response.data);
                axios
                  .post(window.base + "/document/AddDocumentSignature", fd)
                  .then(() => {
                    this.loading = false;
                    new Noty({
                      theme: "light",
                      type: "success",
                      text: this.$root.$t("message.message.contract_signed"),
                      timeout: 5000,
                    }).show();
                    this.$bvModal.hide("modal-select-ecp-type-invoice");
                  })
                  .catch((e) => {
                    this.loading = false;
                    new Noty({
                      theme: "light",
                      type: "error",
                      text: this.$root.$t(
                        "message.message.contract_not_signed",
                      ),
                      timeout: 5000,
                    }).show();
                    this.$bvModal.hide("modal-select-ecp-type-invoice");
                  });
              });
          });
      }
    },
    /**
     * Sends request to backend to send a code to sign a document without ECP
     */
    sign_with_code() {
      axios
        .get(window.base + "/account/GenerateToken?doc_id=" + this.document_id)
        .then((response) => {
          console.log(response.data);
          this.show_code_sign_type = true;
        });
    },
    /**
     * Displays a dialog to select which method of electronic signature fits user the best.
     */
    submit_and_sign_dialog() {
      this.$bvModal.show("modal-select-ecp-type-invoice");
    },
    /**
     * Initializes electorinc signature for the document.
     * Gets XML from backend.
     * Signs with NCA Layer.
     * Sends signature back to backend to store for future comparison.
     */
    signDocument() {
      this.loading = true;
      axios
        .get(
          window.base + "/document/LoadInvoiceXML?doc_id=" + this.document_id,
        )
        .then((response) => {
          this.xml = response.data.replace(
            '<?xml version="1.0" encoding="utf-16"?>',
            "",
          );
          window.webSocket = new WebSocket("wss://127.0.0.1:13579/");
          window.callback = null;

          window.webSocket.onopen = (event) => {
            window.signXml("PKCS12", "SIGNATURE", this.xml, () => {});
          };

          window.webSocket.onclose = function (event) {
            if (event.wasClean) {
            } else {
              openDialog();
            }
          };

          window.webSocket.onmessage = (event) => {
            var result = JSON.parse(event.data);
            if (result != null) {
              var rw = {
                code: result["code"],
                message: result["message"],
                responseObject: result["responseObject"],
                getResult: function () {
                  return this.result;
                },
                getMessage: function () {
                  return this.message;
                },
                getResponseObject: function () {
                  return this.responseObject;
                },
                getCode: function () {
                  return this.code;
                },
              };
              if (rw.code == "200") {
                var oParser = new DOMParser();
                var oDOM = oParser.parseFromString(
                  rw.getResponseObject(),
                  "application/xml",
                );
                var value =
                  oDOM.getElementsByTagName("ds:SignatureValue")[0].innerHTML;
                var certificate =
                  oDOM.getElementsByTagName("ds:X509Certificate")[0].innerHTML;

                axios
                  .get(window.base + "/account/loadSignatureDetails")
                  .then((response) => {
                    let cert = response.data.cert.replace(
                      /(?:\r\n|\r|\n)/g,
                      "",
                    );
                    if (cert == certificate.replace(/(?:\r\n|\r|\n)/g, "")) {
                      var fd = new FormData();
                      fd.append("document_id", this.document_id);
                      fd.append("contract_id", this.document_id);
                      fd.append("signature", value);
                      fd.append("type", "signature");
                      axios
                        .post(
                          window.base + "/document/AddDocumentSignature",
                          fd,
                        )
                        .then(() => {
                          this.loading = false;
                          this.load(); //refresh status of the contract
                          new Noty({
                            theme: "light",
                            type: "success",
                            text: this.$t("message.message.document_signed"),
                            timeout: 5000,
                          }).show();
                          this.$bvModal.hide("modal-select-ecp-type-cmr");
                        })
                        .catch((e) => {
                          this.loading = false;
                          new Noty({
                            theme: "light",
                            type: "error",
                            text:
                              this.$t("message.message.document_not_signed") +
                              " (" +
                              e +
                              ")",
                            timeout: 5000,
                          }).show();
                          this.$bvModal.hide("modal-select-ecp-type-cmr");
                        });
                    } else {
                      this.loading = false;
                      new Noty({
                        theme: "light",
                        type: "error",
                        text: this.$t(
                          "message.message.document_not_signed_cert_invalid",
                        ),
                        timeout: 5000,
                      }).show();
                    }
                  });

                // var fd = new FormData;
                // fd.append('contract_id', this.document_id)
                // fd.append('signature', value)
                // axios.post(window.base + '/document/AddDocumentSignature', fd).then(()=>{
                // 	this.loading = false
                // 	new Noty({
                // 		theme: 'light',
                // 		type: 'success',
                // 		text: this.$root.$t('message.message.document_signed'),
                // 		timeout: 5000,
                // 	}).show();
                // 	this.$bvModal.hide('modal-select-ecp-type-invoice')
                // }).catch(e=>{
                // 	this.loading = false
                // 	new Noty({
                // 		theme: 'light',
                // 		type: 'error',
                // 		text: this.$root.$t('message.message.document_not_signed'),
                // 		timeout: 5000,
                // 	}).show();
                // 	this.$bvModal.hide('modal-select-ecp-type-invoice')
                // })
                window.webSocket.close();
                // window.webSocket.removeEventListener('message', {})
              }
            }
          };
        });
    },
    load() {
      axios
        .get(window.base + "/Document/GetRWBill/?doc_id=" + this.document_id)
        .then((response) => {
          this.$emit("file", response.data.files);
          this.RWB.refdocid = response.data.refdocid;
          this.RWB.consignor_notice = response.data.consignor_notice;
          this.RWB.places_quantity = response.data.places_quantity;
          this.RWB.gross_weight_quantity = response.data.gross_weight_quantity;
          this.RWB.departure_mode_description =
            response.data.departure_mode_description;
          this.RWB.loader_mode_description =
            response.data.loader_mode_description;
          this.RWB.additional_sheet_quantity =
            response.data.additional_sheet_quantity;
          this.RWB.cargo_value = response.data.cargo_value;
          this.RWB.customs_notice = response.data.customs_notice;
          this.RWB.weight_definition_mode_description =
            response.data.weight_definition_mode_description;
          this.RWB.carrier_notice = response.data.carrier_notice;
          this.RWB.commerce_akt = response.data.commerce_akt;
          this.RWB.prolongation = response.data.prolongation;
          this.RWB.issue_marks = response.data.issue_marks;
          this.RWB.amount60 = response.data.amount60;
          this.RWB.amount61 = response.data.amount61;
          this.RWB.amount62 = response.data.amount62;
          this.RWB.amount63 = response.data.amount63;
          this.RWB.calculation_notice = response.data.calculation_notice;
          this.RWB.addition_payment = response.data.addition_payment;
          this.RWB.consignor_option_notice =
            response.data.consignor_option_notice;
          axios
            .get(
              window.base +
                "/document/getFirmbyBin?bin=" +
                response.data.consignor,
            )
            .then((response1) => {
              this.RWB.consignor.value = response1.data.organizations.org_code;
              this.RWB.consignor.display_text =
                response1.data.organizations.org_name;
            });
          axios
            .get(
              window.base +
                "/document/getFirmbyBin?bin=" +
                response.data.consignee,
            )
            .then((response1) => {
              this.RWB.consignee.value = response1.data.organizations.org_code;
              this.RWB.consignee.display_text =
                response1.data.organizations.org_name;
            });

          this.RWB.departure_station =
            this.rw_stations[
              this.rw_stations.findIndex(
                (itm) =>
                  itm.value == response.data.departure_station_code.trim(),
              )
            ];
          //this.RWB.departure_station.display_text = response.data.departure_station_name
          this.RWB.departure_rwcode = response.data.departure_rwcode;
          this.RWB.departure_rwname = response.data.departure_rwname;
          //this.RWB.departure_station.value = response.data.departure_rwcode;
          //this.RWB.departure_station.display_text = response.data.departure_rwname
          axios
            .get(
              window.base +
                "/library/country?code=" +
                response.data.departure_country +
                "&lang=" +
                this.$i18n.locale,
            )
            .then((response1) => {
              this.RWB.departure_country = response1.data[0];
            });
          this.RWB.destination_rwcode = response.data.destination_rwcode;
          //this.RWB.destination_station_code = response.data.destination_station_code
          this.RWB.destination_station =
            this.rw_stations[
              this.rw_stations.findIndex(
                (itm) =>
                  itm.value == response.data.destination_station_code.trim(),
              )
            ];
          //this.RWB.destination_station.display_text = response.data.destination_rwand_station_name
          //this.RWB.destination_rwand_station_name = response.data.destination_rwand_station_name
          //this.RWB.border_station_code = response.data.border_station_code
          //this.RWB.border_station_name = response.data.border_station_name
          this.RWB.border_station =
            this.rw_stations[
              this.rw_stations.findIndex(
                (itm) => itm.value == response.data.border_station_code.trim(),
              )
            ];
          //this.RWB.border_station.display_text = response.data.border_station_name;
          this.RWB.border_rwcode = response.data.border_rwcode;
          this.RWB.border_rwname = response.data.border_rwname;
          axios
            .get(
              window.base +
                "/library/country?code=" +
                response.data.border_country +
                "&lang=" +
                this.$i18n.locale,
            )
            .then((response1) => {
              this.RWB.border_country = response1.data[0];
            });
          this.RWB.contract_name = response.data.contract_name;
          this.RWB.contract_number = response.data.contract_number;
          this.RWB.contract_date = response.data.contract_date;
          this.RWB.flat_pallet_quantity = response.data.flat_pallet_quantity;
          this.RWB.box_pallet_quantity = response.data.box_pallet_quantity;
          this.RWB.pallet_exchange_mode = response.data.pallet_exchange_mode;
          this.RWB.work_tool_id = response.data.work_tool_id;
          this.RWB.work_tool_container_description =
            response.data.work_tool_container_description;
          this.RWB.work_tool_railway_code =
            response.data.work_tool_railway_code;
          this.RWB.mark_sing = response.data.mark_sing;
          this.RWB.mark_kind = response.data.mark_kind;
          this.RWB.mark_result_control = response.data.mark_result_control;
          this.RWB.contract_carrier_name = response.data.contract_carrier_name;
          this.RWB.contract_carrier_time = response.data.contract_carrier_time;
          this.RWB.contract_carrier_date = response.data.contract_carrier_date;

          this.RWB.contract_carrier_date_time_moscow =
            response.data.contract_carrier_date_time_moscow;
          //this.RWB.contract_carrier_station_code = response.data.contract_carrier_station_code
          //this.RWB.contract_carrier_station_name = response.data.contract_carrier_station_name
          this.RWB.contract_carrier_station =
            this.rw_stations[
              this.rw_stations.findIndex(
                (itm) =>
                  itm.value ==
                  response.data.contract_carrier_station_code.trim(),
              )
            ];
          //this.RWB.contract_carrier_station.display_text = response.data.contract_carrier_station_name
          this.RWB.contract_carrier_rw_name =
            response.data.contract_carrier_rw_name;
          axios
            .get(
              window.base +
                "/library/country?code=" +
                response.data.contract_carrier_country +
                "&lang=" +
                this.$i18n.locale,
            )
            .then((response1) => {
              this.RWB.contract_carrier_country = response1.data[0];
            });
          this.RWB.arrival_carrier_name = response.data.arrival_carrier_name;
          this.RWB.arrival_date = response.data.arrival_date;
          this.RWB.arrival_time = response.data.arrival_time;
          this.RWB.arrival_date_time_moscow =
            response.data.arrival_date_time_moscow;
          //this.RWB.arrival_station_code = response.data.arrival_station_code
          //this.RWB.arrival_station_name = response.data.arrival_station_name
          this.RWB.arrival_station =
            this.rw_stations[
              this.rw_stations.findIndex(
                (itm) => itm.value == response.data.arrival_station_code.trim(),
              )
            ];
          //this.RWB.arrival_station.display_text = response.data.arrival_station_name;
          this.RWB.arrival_rw_name = response.data.arrival_rw_name;
          this.RWB.arrival_rw_code = response.data.arrival_rw_code;
          this.RWB.arrival_country = response.data.arrival_country;
          axios
            .get(
              window.base +
                "/library/country?code=" +
                response.data.arrival_country +
                "&lang=" +
                this.$i18n.locale,
            )
            .then((response1) => {
              this.RWB.arrival_country = response1.data[0];
            });
          if (_.isArray(response.data.goods))
            response.data.goods.forEach((good) => {
              let g = {};
              g.container_indicator = good.container_indicator;
              g.work_tool_description = good.work_tool_description;
              g.conductor_description = good.conductor_description;
              g.place_goods_quantity = good.place_goods_quantity;
              g.places_quantity = good.places_quantity;
              g.gross_weight_quantity = good.gross_weight_quantity;
              g.places_description = good.places_description;
              g.harmonized_range_goods = good.harmonized_range_goods;
              g.packing = good.packing;
              g.marking = good.marking;
              g.carriage_number = good.carriage_number;
              g.container_number = good.container_number;
              g.goods_numeric = good.goods_numeric;
              g.customs_code = good.customs_code;
              g.gtd_number = good.gtd_number;
              g.gcost = good.gcost;
              if (typeof good.currency !== "undefined") {
                console.log("tikrinu currency");
                console.log(this.currencies);
                g.currency =
                  this.currencies[
                    this.currencies.findIndex(
                      (itm) => itm.value == good.currency.trim(),
                    )
                  ];
                // axios.get(window.base+'/library/currency?code='+good.currency+'&lang='+this.$i18n.locale).then(response1=>{
                // 	g.currency = response1.data[0]
                // })
              }

              g.mrn = good.mrn;
              this.RWB.goods.push(g);
            });
          if (_.isArray(response.data.carrier))
            response.data.carrier.forEach((carrier) => {
              let c = {};
              c.id = carrier.id;
              c.carrier_name = carrier.carrier_name;
              c.carrier_code = carrier.carrier_code;
              c.from_station_code = carrier.from_station_code;
              c.from_station_name = carrier.from_station_name;
              c.from_rw_name = carrier.from_rw_name;
              axios
                .get(
                  window.base +
                    "/library/country?code=" +
                    c.from_country +
                    "&lang=" +
                    this.$i18n.locale,
                )
                .then((response1) => {
                  c.from_country = response1.data[0];
                });
              c.to_station_code = carrier.to_station_code;
              c.to_station_name = carrier.to_station_name;
              c.to_rw_name = carrier.to_rw_name;

              axios
                .get(
                  window.base +
                    "/library/country?code=" +
                    c.to_country +
                    "&lang=" +
                    this.$i18n.locale,
                )
                .then((response1) => {
                  c.to_country = response1.data[0];
                });
              c.tech_station = [];
              carrier.tech_station.forEach((ts) => {
                let tss = {};
                tss.station = { value: "", display_text: "" };
                tss.order_number = ts.order_number;
                tss.tech_signs = ts.tech_signs;
                tss.station_code = ts.station_code;
                tss.station_name = ts.station_name;
                tss.station =
                  this.rw_stations[
                    this.rw_stations.findIndex(
                      (itm) => itm.value == ts.station_code.trim(),
                    )
                  ];
                //tss.station.display_text = ts.station_name;
                tss.rw_name = ts.rw_name;
                axios
                  .get(
                    window.base +
                      "/library/country?code=" +
                      ts.country +
                      "&lang=" +
                      this.$i18n.locale,
                  )
                  .then((response1) => {
                    tss.country = response1.data[0];
                  });
                c.tech_station.push(tss);
              });
              this.RWB.carrier.push(c);
            });
          if (_.isArray(response.data.container))
            response.data.container.forEach((container) => {
              let c = {};
              c.container_id = container.container_id;
              c.rw_code = container.rw_code;
              c.container_kind = container.container_kind;
              c.container_mode_desc = container.container_mode_desc;
              c.container_capacity = container.container_capacity;
              c.container_capacity_unit_code =
                container.container_capacity_unit_code;
              axios
                .get(
                  window.base +
                    "/library/measure?code=" +
                    container.container_capacity_unit_code +
                    "&lang=" +
                    this.$i18n.locale,
                )
                .then((response1) => {
                  c.container_capacity_unit_code = response1.data[0];
                });
              c.tare = container.tare;
              c.goods_weight = container.goods_weight;
              c.places_quentity = container.places_quentity;
              c.pocket_quentity = container.pocket_quentity;
              c.container_length = container.container_length;
              this.RWB.container.push(c);
            });
          if (_.isArray(response.data.auto))
            response.data.auto.forEach((auto) => {
              let a = {};
              a.vin = auto.vin;
              a.transport_kind = auto.transport_kind;
              a.transport_mark = auto.transport_mark;
              a.transport_identifier = auto.transport_identifier;
              axios
                .get(
                  window.base +
                    "/library/country?code=" +
                    auto.transport_nationality +
                    "&lang=" +
                    this.$i18n.locale,
                )
                .then((response1) => {
                  ca.transport_nationality = response1.data[0];
                });
              a.active_transport_identifier = auto.active_transport_identifier;
              a.transport_regnumber = auto.transport_regnumber;
              a.wagon_number = auto.wagon_number;
              a.tare = auto.tare;
              a.goods_weight = auto.goods_weight;
              a.places_quentity = auto.places_quentity;
              a.pocket_quentity = auto.pocket_quentity;
              a.container_length = auto.container_length;
              this.RWB.auto.push(a);
            });
          if (_.isArray(response.data.carriage))
            response.data.carriage.forEach((carriage) => {
              let c = {};
              c.carriage_id = carriage.carriage_id;
              c.rw_name = carriage.rw_name;
              c.owner_name = carriage.owner_name;
              c.owner_type = carriage.owner_type;
              c.rw_power = carriage.rw_power;
              c.axis_quentity = carriage.axis_quentity;
              c.tare = carriage.tare;
              c.goods_weight = carriage.goods_weight;
              c.caliber = carriage.caliber;
              this.RWB.carriage.push(c);
            });
          if (_.isArray(response.data.seal))
            response.data.seal.forEach((seal) => {
              let s = {};
              s.seal_id = seal.seal_id;
              s.seal_quentity = seal.seal_quentity;
              s.ident_kind = seal.ident_kind;
              s.ident_desc = seal.ident_desc;
              this.RWB.seal.push(s);
            });
          if (_.isArray(response.data.stamp33))
            response.data.stamp33.forEach((stamp33) => {
              let s = {};
              s.station = { value: "", display_text: "" };
              s.carrier_name = stamp33.carrier_name;
              s.date = stamp33.date;
              s.time = stamp33.time;
              s.date_time_moscow = stamp33.date_time_moscow;
              s.station_code = stamp33.station_code;
              s.station_name = stamp33.station_name;
              s.station =
                this.rw_stations[
                  this.rw_stations.findIndex(
                    (itm) => itm.value == stamp33.station_code.trim(),
                  )
                ];
              //s.station.display_text = stamp33.station_name
              s.rw_name = stamp33.rw_name;
              s.rw_code = stamp33.rw_code;
              axios
                .get(
                  window.base +
                    "/library/country?code=" +
                    stamp33.country +
                    "&lang=" +
                    this.$i18n.locale,
                )
                .then((response1) => {
                  s.country = response1.data[0];
                });
              this.RWB.stamp33.push(s);
            });
          if (_.isArray(response.data.stamp34))
            response.data.stamp34.forEach((stamp34) => {
              let s = {};
              s.carrier_name = stamp34.carrier_name;
              s.date = stamp34.date;
              s.time = stamp34.time;
              s.date_time_moscow = stamp34.date_time_moscow;
              s.station_code = stamp34.station_code;
              s.station_name = stamp34.station_name;
              s.station =
                his.rw_stations[
                  this.rw_stations.findIndex(
                    (itm) => itm.value == stamp34.station_code.trim(),
                  )
                ];
              //s.station.display_text = stamp35.station_name
              s.rw_name = stamp34.rw_name;
              s.rw_code = stamp34.rw_code;
              axios
                .get(
                  window.base +
                    "/library/country?code=" +
                    stamp34.country +
                    "&lang=" +
                    this.$i18n.locale,
                )
                .then((response1) => {
                  s.country = response1.data[0];
                });
              this.RWB.stamp34.push(s);
            });
          if (_.isArray(response.data.stamp35)) {
            response.data.stamp35.forEach((stamp35) => {
              let s = {};
              s.carrier_name = stamp35.carrier_name;
              s.date = stamp35.date;
              s.time = stamp35.time;
              s.date_time_moscow = stamp35.date_time_moscow;
              s.station_code = stamp35.station_code;
              s.station_name = stamp35.station_name;
              s.station =
                this.rw_stations[
                  this.rw_stations.findIndex(
                    (itm) => itm.value == stamp35.station_code.trim(),
                  )
                ];
              //s.station.display_text = stamp35.station_name
              s.rw_name = stamp35.rw_name;
              s.rw_code = stamp35.rw_code;
              axios
                .get(
                  window.base +
                    "/library/country?code=" +
                    stamp35.country +
                    "&lang=" +
                    this.$i18n.locale,
                )
                .then((response1) => {
                  s.country = response1.data[0];
                });
              this.RWB.stamp35.push(s);
            });
          } else if (_.isObject(response.data.stamp35)) {
            let stamp35 = response.data.stamp35;
            let s = {};
            s.carrier_name = stamp35.carrier_name;
            s.date = stamp35.date;
            s.time = stamp35.time;
            s.date_time_moscow = stamp35.date_time_moscow;
            s.station_code = stamp35.station_code;
            s.station_name = stamp35.station_name;
            s.rw_name = stamp35.rw_name;
            s.rw_code = stamp35.rw_code;
            axios
              .get(
                window.base +
                  "/library/country?code=" +
                  stamp35.country +
                  "&lang=" +
                  this.$i18n.locale,
              )
              .then((response1) => {
                s.country = response1.data[0];
              });
            this.RWB.stamp35.push(s);
          }
          if (_.isArray(response.data.carrier_charge))
            response.data.carrier_charge.forEach((carrier_charge) => {
              let c = {};
              c.from_station = { value: "", display_text: "" };
              c.to_station = { value: "", display_text: "" };
              c.order_no = carrier_charge.order_no;
              c.carrier_code = carrier_charge.carrier_code;
              c.from_station_code = carrier_charge.from_station_code;
              c.from_station_name = carrier_charge.from_station_name;
              c.from_station =
                this.rw_stations[
                  this.rw_stations.findIndex(
                    (itm) =>
                      itm.value == carrier_charge.from_station_code.trim(),
                  )
                ];
              //c.from_station.display_text = carrier_charge.from_station_name
              c.from_rw_name = carrier_charge.from_rw_name;
              axios
                .get(
                  window.base +
                    "/library/country?code=" +
                    carrier_charge.from_country +
                    "&lang=" +
                    this.$i18n.locale,
                )
                .then((response1) => {
                  c.from_country = response1.data[0];
                });
              c.to_station_code = carrier_charge.to_station_code;
              c.to_station_name = carrier_charge.to_station_name;
              c.to_station =
                this.rw_stations[
                  this.rw_stations.findIndex(
                    (itm) => itm.value == carrier_charge.to_station_code.trim(),
                  )
                ];
              //c.to_station.display_text = carrier_charge.to_station_name
              c.to_rw_name = carrier_charge.to_rw_name;
              axios
                .get(
                  window.base +
                    "/library/country?code=" +
                    carrier_charge.to_country +
                    "&lang=" +
                    this.$i18n.locale,
                )
                .then((response1) => {
                  c.to_country = response1.data[0];
                });
              c.distance = carrier_charge.distance;
              c.calc_weight = carrier_charge.calc_weight;
              c.extra_charge_code = carrier_charge.extra_charge_code;
              c.extra_charge_name = carrier_charge.extra_charge_name;
              c.extra_charge_amount = carrier_charge.extra_charge_amount;
              c.tarif_code = carrier_charge.tarif_code;
              c.calc_cargo_code = carrier_charge.calc_cargo_code;
              c.currency_rate = carrier_charge.currency_rate;
              axios
                .get(
                  window.base +
                    "/library/currency?code=" +
                    carrier_charge.snd_tarif_currency_code +
                    "&lang=" +
                    this.$i18n.locale,
                )
                .then((response1) => {
                  c.snd_tarif_currency_code = response1.data[0];
                });
              axios
                .get(
                  window.base +
                    "/library/currency?code=" +
                    carrier_charge.snd_payment_currency +
                    "&lang=" +
                    this.$i18n.locale,
                )
                .then((response1) => {
                  c.snd_payment_currency = response1.data[0];
                });
              axios
                .get(
                  window.base +
                    "/library/currency?code=" +
                    carrier_charge.rcv_tarif_currency_code +
                    "&lang=" +
                    this.$i18n.locale,
                )
                .then((response1) => {
                  c.rcv_tarif_currency_code = response1.data[0];
                });
              axios
                .get(
                  window.base +
                    "/library/currency?code=" +
                    carrier_charge.rcv_payment_currency +
                    "&lang=" +
                    this.$i18n.locale,
                )
                .then((response1) => {
                  c.rcv_payment_currency = response1.data[0];
                });
              c.amount48 = carrier_charge.amount48;
              c.amount49 = carrier_charge.amount49;
              c.amount50 = carrier_charge.amount50;
              c.amount51 = carrier_charge.amount51;
              c.amount52 = carrier_charge.amount52;
              c.amount53 = carrier_charge.amount53;
              c.amount54 = carrier_charge.amount54;
              c.amount55 = carrier_charge.amount55;
              c.amount56 = carrier_charge.amount56;
              c.amount57 = carrier_charge.amount57;
              c.amount58 = carrier_charge.amount58;
              c.amount59 = carrier_charge.amount59;
              this.RWB.carrier_charge.push(c);
            });
          if (_.isArray(response.data.paid_rw_code))
            response.data.paid_rw_code.forEach((paid_rw_code) => {
              let p = {};
              p.paid_rw_name = paid_rw_code.paid_rw_name;
              p.paid_rw_code = paid_rw_code.paid_rw_code;
              p.paid_rw_short = paid_rw_code.paid_rw_short;
              p.payer_code = paid_rw_code.payer_code;
              p.payer_name = paid_rw_code.payer_name;
              p.from_rw_name = paid_rw_code.from_rw_name;
              axios
                .get(
                  window.base +
                    "/library/country?code=" +
                    paid_rw_code.from_country +
                    "&lang=" +
                    this.$i18n.locale,
                )
                .then((response1) => {
                  p.from_country = response1.data[0];
                });
              this.RWB.paid_rw_code.push(p);
            });
          if (_.isArray(response.data.consignor_doc))
            response.data.consignor_doc.forEach((consignor) => {
              let c = {};
              c.doc_name = consignor.doc_name;
              c.doc_number = consignor.doc_number;
              c.doc_date = consignor.doc_date;
              c.mode_code = consignor.mode_code;
              c.expiration_date = consignor.expiration_date;
              c.release_customs = consignor.release_customs;
              this.RWB.consignor_doc.push(c);
            });
        });
    },
    /**
     * checks field value and if it should be int/decimal but is empty set's 0
     */
    check_field_value(field, value) {
      let list_of_decimal_fields = [
        "gross_weight_quantity",
        "amount60",
        "amount61",
        "amount62",
        "amount63",
        "cargo_value",
        "flat_pallet_quantity",
        "box_pallet_quantity",
        "place_goods_quantity",
        "places_quantity",
        "gross_weight_quantity",
        "gcost",
        "container_capacity",
        "tare",
        "goods_weight",
        "places_quentity",
        "pocket_quentity",
        "container_length",
        "tare",
        "goods_weight",
        "places_quentity",
        "pocket_quentity",
        "container_length",
        "rw_power",
        "axis_quentity",
        "tare",
        "goods_weight",
        "order_no",
        "distance",
        "calc_weight",
        "extra_charge_amount",
        "currency_rate",
        "amount48",
        "amount49",
        "amount50",
        "amount51",
        "amount52",
        "amount53",
        "amount54",
        "amount55",
        "amount56",
        "amount57",
        "amount58",
        "amount59",
      ];
      let list_of_int_fields = [
        "wagon_number",
        "goods_numeric",
        "gtd_number",
        "harmonized_range_goods",
        "container_indicator",
        "additional_sheet_quantity",
        "doc_id",
        "refdocid",
        "places_quantity",
      ];

      if (_.includes(list_of_decimal_fields, field)) {
        if (_.isEmpty(value) || value == "0" || value == "0.0")
          return 0.0; //zero double
        else return parseFloat(value);
      } else if (_.includes(list_of_int_fields, field)) {
        if (_.isEmpty(value) || value == "0" || value == "0.0")
          return 0; //zero int
        else return parseInt(value);
      } else {
        if (_.isEmpty(value)) return "";
        else return value;
      }
    },
    check_json_before_sending(json) {
      let tmp = {};
      for (let i in json) {
        if (_.isArray(json[i])) {
          if (json[i].length == 0) tmp[i] = [];
          json[i].forEach((array_item, j) => {
            tmp[i] = [];
            if (typeof array_item === "object") {
              tmp[i].push(this.check_json_before_sending(array_item));
            } else {
              tmp[i].push(this.check_field_value(j, array_item));
            }
          });
        } else if (typeof json[i] === "object") {
          tmp[i] = this.check_json_before_sending(json[i]);
        } else {
          tmp[i] = this.check_field_value(i, json[i]);
        }
      }
      return tmp;
    },
    saveDocument() {
      var data = {
        document: this.document,
      };
      this.$root.$emit("show-loading");
      this.buttons_loading = true;
      var tmp = this.RWB;
      if (_.isArray(tmp.goods))
        tmp.goods.forEach((g, i) => {
          if (
            typeof g.currency !== "undefined" &&
            typeof g.currency.value !== "undefined"
          )
            tmp.goods[i].currency = g.currency.value;
        });
      if (_.isArray(tmp.carrier))
        tmp.carrier.forEach((g, i) => {
          if (
            typeof g.from_country !== "undefined" &&
            typeof g.from_country.value !== "undefined"
          )
            tmp.carrier[i].from_country = g.from_country.value;
          if (
            typeof g.to_country !== "undefined" &&
            typeof g.to_country.value !== "undefined"
          )
            tmp.carrier[i].to_country = g.to_country.value;
          if (typeof g.tech_station != "undefined")
            g.tech_station.forEach((ts, j) => {
              tmp.carrier[i].tech_station[j].country = ts.country.value;
            });
        });
      if (_.isArray(tmp.carrier_charge))
        tmp.carrier_charge.forEach((g, i) => {
          if (
            typeof g.to_country !== "undefined" &&
            typeof g.to_country.value !== "undefined"
          )
            tmp.carrier_charge[i].to_country = g.to_country.value;
          if (
            typeof g.from_country !== "undefined" &&
            typeof g.from_country.value !== "undefined"
          )
            tmp.carrier_charge[i].from_country = g.from_country.value;
          if (
            typeof g.rcv_payment_currency !== "undefined" &&
            typeof g.rcv_payment_currency.value !== "undefined"
          )
            tmp.carrier_charge[i].rcv_payment_currency =
              g.rcv_payment_currency.value;
          if (
            typeof g.rcv_tarif_currency_code !== "undefined" &&
            typeof g.rcv_tarif_currency_code.value !== "undefined"
          )
            tmp.carrier_charge[i].rcv_tarif_currency_code =
              g.rcv_tarif_currency_code.value;
          if (
            typeof g.snd_payment_currency !== "undefined" &&
            typeof g.snd_payment_currency.value !== "undefined"
          )
            tmp.carrier_charge[i].snd_payment_currency =
              g.snd_payment_currency.value;
          if (
            typeof g.snd_tarif_currency_code !== "undefined" &&
            typeof g.snd_tarif_currency_code.value !== "undefined"
          )
            tmp.carrier_charge[i].snd_tarif_currency_code =
              g.snd_tarif_currency_code.value;
          if (
            typeof g.from_station !== "undefined" &&
            typeof g.from_station.value !== "undefined"
          ) {
            tmp.carrier_charge[i].from_station_code = g.from_station.value;
            tmp.carrier_charge[i].from_station_name =
              g.from_station.display_text;
          }

          if (
            typeof g.to_station !== "undefined" &&
            typeof g.to_station.value !== "undefined"
          ) {
            tmp.carrier_charge[i].to_station_code = g.to_station.value;
            tmp.carrier_charge[i].to_station_name = g.to_station.display_text;
          }
        });
      if (_.isArray(tmp.container))
        tmp.container.forEach((g, i) => {
          if (
            typeof g.container_capacity_unit_code !== "undefined" &&
            typeof g.container_capacity_unit_code.value !== "undefined"
          )
            tmp.container[i].container_capacity_unit_code =
              g.container_capacity_unit_code.value;
        });
      if (_.isArray(tmp.auto))
        tmp.auto.forEach((g, i) => {
          if (
            typeof g.transport_nationality !== "undefined" &&
            typeof g.transport_nationality.value !== "undefined"
          )
            tmp.auto[i].transport_nationality = g.transport_nationality.value;
        });
      if (_.isArray(tmp.stamp33))
        tmp.stamp33.forEach((g, i) => {
          if (
            typeof g.country !== "undefined" &&
            typeof g.country.value !== "undefined"
          )
            tmp.stamp33[i].country = g.country.value;
          if (
            typeof g.station !== "undefined" &&
            typeof g.station.value !== "undefined"
          ) {
            tmp.stamp33[i].station_code = g.station.value;
            tmp.stamp33[i].station_name = g.station.display_text;
          }
        });
      if (_.isArray(tmp.stamp34))
        tmp.stamp34.forEach((g, i) => {
          if (
            typeof g.country !== "undefined" &&
            typeof g.country.value !== "undefined"
          )
            tmp.stamp34[i].country = g.country.value;
          if (
            typeof g.station !== "undefined" &&
            typeof g.station.value !== "undefined"
          ) {
            tmp.stamp34[i].station_code = g.station.value;
            tmp.stamp34[i].station_name = g.station.display_text;
          }
        });
      if (_.isArray(tmp.stamp35))
        tmp.stamp35.forEach((g, i) => {
          if (
            typeof g.country !== "undefined" &&
            typeof g.country.value !== "undefined"
          )
            tmp.stamp35[i].country = g.country.value;
          if (
            typeof g.station !== "undefined" &&
            typeof g.station.value !== "undefined"
          ) {
            tmp.stamp35[i].station_code = g.station.value;
            tmp.stamp35[i].station_name = g.station.display_text;
          }
        });
      if (tmp.stamp35.length > 0) tmp.stamp35 = tmp.stamp35[0];
      else
        tmp.stamp35 = {
          carrier_name: "",
          date: "",
          time: "",
          date_time_moscow: "",
          station_code: "",
          station_name: "",
          station: { value: "", display_text: "" },
          rw_name: "",
          rw_code: "",
          country: "",
        };
      if (_.isArray(tmp.paid_rw_code))
        tmp.paid_rw_code.forEach((g, i) => {
          if (
            typeof g.from_country !== "undefined" &&
            typeof g.from_country.value !== "undefined"
          )
            tmp.paid_rw_code[i].from_country = g.from_country.value;
        });

      if (
        typeof tmp.consignor !== "undefined" &&
        typeof tmp.consignor.value !== "undefined"
      )
        tmp.consignor = tmp.consignor.value;
      if (
        typeof tmp.consignee !== "undefined" &&
        typeof tmp.consignee.value !== "undefined"
      )
        tmp.consignee = tmp.consignee.value;
      if (
        typeof tmp.departure_country !== "undefined" &&
        typeof tmp.departure_country.value !== "undefined"
      )
        tmp.departure_country = tmp.departure_country.value;
      if (
        typeof tmp.border_country !== "undefined" &&
        typeof tmp.border_country.value !== "undefined"
      )
        tmp.border_country = tmp.border_country.value;
      if (
        typeof tmp.contract_carrier_country !== "undefined" &&
        typeof tmp.contract_carrier_country.value !== "undefined"
      )
        tmp.contract_carrier_country = tmp.contract_carrier_country.value;
      if (
        typeof tmp.arrival_country !== "undefined" &&
        typeof tmp.arrival_country.value !== "undefined"
      )
        tmp.arrival_country = tmp.arrival_country.value;

      if (
        typeof tmp.departure_station !== "undefined" &&
        typeof tmp.departure_station.value !== "undefined"
      ) {
        tmp.departure_station_code = tmp.departure_station.value;
        tmp.departure_station_name = tmp.departure_station.display_text;
      }

      if (
        typeof tmp.border_station !== "undefined" &&
        typeof tmp.border_station.value !== "undefined"
      ) {
        tmp.border_station_code = tmp.border_station.value;
        tmp.border_station_name = tmp.border_station.display_text;
      }
      if (
        typeof tmp.contract_carrier_station !== "undefined" &&
        typeof tmp.contract_carrier_station.value !== "undefined"
      ) {
        tmp.contract_carrier_station_code = tmp.contract_carrier_station.value;
        tmp.contract_carrier_station_name =
          tmp.contract_carrier_station.display_text;
      }
      if (
        typeof tmp.arrival_station !== "undefined" &&
        typeof tmp.arrival_station.value !== "undefined"
      ) {
        tmp.arrival_station_code = tmp.arrival_station.value;
        tmp.arrival_station_name = tmp.arrival_station.display_text;
      }

      if (
        typeof tmp.destination_station !== "undefined" &&
        typeof tmp.destination_station.value !== "undefined"
      ) {
        tmp.destination_station_code = tmp.destination_station.value;
        tmp.destination_rwand_station_name =
          tmp.destination_station.display_text;
      }

      // var formData = new FormData();
      // for(var i in tmp){
      //     switch(i){
      //         case 'places_quantity':
      //         case 'gross_weight_quantity':
      //         case 'additional_sheet_quantity':
      //         case 'cargo_value':
      //         case 'amount60':
      //         case 'amount61':
      //         case 'amount62':
      //         case 'amount63':
      //             if(tmp[i]=='' || typeof tmp[i]=='undefined'){
      //                 formData.append(i, 0);
      //             }else{
      //                 formData.append(i, tmp[i]);
      //             }
      //         break;
      // 		case
      //         default:
      //             if(tmp[i]=='' || typeof tmp[i]=='undefined'){
      //                 formData.append(i, '');
      //             }else{
      //                 formData.append(i, tmp[i]);
      //             }
      //     }
      // }
      // formData.append('document_category', 'transport')
      // formData.append('file', data.document.file);
      var t1 = this.$t("message.error");
      axios
        .post(
          window.base +
            (this.is_new === true
              ? "/Document/AddRWBill" +
                "?attis_contract_id=" +
                this.$route.params.id
              : "/Document/UpdateRWBill" + "?document_id=" + this.document_id),
          this.check_json_before_sending(tmp),
        )
        .then((response) => {
          console.log(response.data);
          if (response.data == "ok") {
            new Noty({
              theme: "light",
              type: "success",
              text: this.$root.$t("message.message.rwb-created"),
              timeout: 5000,
            }).show();
            this.$root.$emit("loadDocuments", { category: "all" });
            this.$root.$emit("bv::hide::modal", "modal-document", "#btnShow");
            this.$root.$emit(
              "bv::hide::modal",
              "modal-document-new",
              "#btnShow",
            );
          } else {
            console.info("else case");
            this.loading = false;
            new Noty({
              theme: "light",
              type: "error",
              text:
                this.$root.$t("message.message.rwb-not-created") +
                " (" +
                response.data +
                ")",
              timeout: 5000,
            }).show();
            if (window.dev_mode) {
              this.$root.$emit("bv::hide::modal", "modal-document", "#btnShow");
              this.$root.$emit(
                "bv::hide::modal",
                "modal-document-new",
                "#btnShow",
              );
            }
          }
        })
        .catch((e) => {
          console.log(e);
          new Noty({
            theme: "light",
            type: "error",
            text: t1,
            timeout: 5000,
          }).show();
          this.$root.$emit("bv::hide::modal", "modal-document", "#btnShow");
          this.$root.$emit("bv::hide::modal", "modal-document-new", "#btnShow");
        });
    },
  },
  mounted() {
    this.fetchContragents("");
    this.fetchCountries("");
    this.fetchCurrencies("");
    this.fetchPackagings("");
    this.fetchMeasures("");
    this.fetchStations("");
    if (this.document_id != "new") {
      this.load();
    } else {
      var date = new Date();
      this.RWB.refdocid = parseInt(
        (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) +
          (date.getMonth() + 1 < 10
            ? "0" + (date.getMonth() + 1)
            : date.getMonth() + 1),
      );

      axios
        .get(
          window.base +
            "/document/RwbInitialData?attis_contract_id=" +
            this.$route.params.id,
        )
        .then((response) => {
          var invoiceGoods = [];
          var invoiceCurrency = "";
          var packingListGoods = [];
          response.data.invoice_list.forEach((invoice) => {
            invoice.product.forEach((good) => {
              good.invoice_id = invoice.DocumentID;
              invoiceGoods.push(good);
            });
          });
          response.data.packing_lists.forEach((packing) => {
            packing.goods.forEach((good) => {
              good.invoice_id = packing.invoice.DocumentID;
              packingListGoods.push(good);
            });
          });
          if (response.data.invoice_list[0] != null) {
            this.RWB.gross_weight_quantity =
              response.data.invoice_list[0].GrossWeightQuantity;
            invoiceCurrency = response.data.invoice_list[0].CurrencyCode.trim();
          }

          console.log("ateina i RWB initial");
          this.RWB.consignor.value =
            response.data.consignor.org_code; /*response.data.packing_lists[0].consignee.org_code*/
          this.RWB.consignor.display_text =
            response.data.consignor.org_name /*response.data.packing_lists[0].consignee.org_name*/;
          this.RWB.consignee.value = response.data.consignee.org_code;
          this.RWB.consignee.display_text = response.data.consignee.org_name;

          this.RWB.contract_date = response.data.when_signed_by_owner;
          this.RWB.contract_carrier_name = response.data.contrac_carrier_name;

          setTimeout(() => {
            var ktzh_resp = response.data.ktzh_resp[0];
            console.log("invoice goods", invoiceGoods);
            console.log("packing list goods", packingListGoods);
            for (var i = 0; i < invoiceGoods.length; i++) {
              var item = invoiceGoods[i];
              console.log("itemas");
              console.log(item);
              var data = {};
              var tmpList = packingListGoods.filter((obj) => {
                return (
                  item.invoice_id === obj.invoice_id &&
                  item.GoodMarking === obj.goodmarking
                );
              });
              var sum = 0;
              var packaging_type = "";
              tmpList.forEach((obj) => {
                obj.packagings.forEach((obj2) => {
                  sum += obj2.packging_placescount;
                  packaging_type = obj2.packaging_packagingtypecode.value;
                });
              });
              data.place_goods_quantity = item.GoodsQuantity;
              data.places_quantity = sum;

              data.marking = item.GoodsCode;
              data.gross_weight_quantity = item.GrossWeightQuantity;
              data.gcost = item.Price;
              data.currency =
                this.currencies[
                  this.currencies.findIndex(
                    (itm) => itm.value == invoiceCurrency.trim(),
                  )
                ];
              if (typeof ktzh_resp.container_no != "undefined") {
                data.container_indicator = ktzh_resp.container_no;
                data.container_number = ktzh_resp.container_no;
              }
              if (typeof ktzh_resp.vag_no != "undefined")
                data.carriage_number = ktzh_resp.vag_no;

              var tmpPacking =
                this.packagings[
                  this.packagings.findIndex(
                    (itm) => itm.value == packaging_type.trim(),
                  )
                ];
              if (typeof tmpPacking !== "undefined" && tmpPacking != null)
                data.packing = tmpPacking.display_text;
              console.log("pushing data");
              console.log(data);
              this.RWB.goods.push(data);
            }
            packingListGoods.forEach((tmp) => {
              var tmpTransport = {};
              tmpTransport.container_capacity = tmp.goodsvolume;
              tmpTransport.container_capacity_unit_code =
                tmp.volumeunitqualifier;
              if (
                typeof tmp.packagings[0] != "undefined" &&
                tmp.packagings[0].packaging_packagingtypecode != null
              )
                tmpTransport.tare =
                  tmp.packagings[0].packaging_packagingtypecode.display_text;
              tmpTransport.places_quentity = tmp.goodsquantity;
              if (typeof ktzh_resp.container_no != "undefined")
                tmpTransport.container_id = ktzh_resp.container_no;
              this.RWB.container.push(tmpTransport);
            });
            var ktzh_responses = response.data.ktzh_resp;
            ktzh_responses.forEach((item, i) => {
              // console.log("ktz response");
              // console.log(i);
              // console.log(item);
              // this.RWB.container[i].container_id = item.container_no;
              // this.RWB.goods[i].container_indicator = item.container_no;

              var tmpCarrier = {};
              tmpCarrier.from_rw_name = item.recive_station_name;
              tmpCarrier.to_rw_name = item.dest_station_name;
              this.RWB.carrier.push(tmpCarrier);
            });

            console.log("ktzh response");
            console.log(ktzh_resp);
            var d = moment(ktzh_resp.invc_dt);
            if (d.isValid())
              ktzh_resp.date = moment(ktzh_resp.invc_dt).format(
                "YYYY-MM-DD HH:mm",
              );
            else
              ktzh_resp.date = moment(
                ktzh_resp.invc_dt,
                "DD.MM.YYYY HH:mm:ss",
              ).format("YYYY-MM-DD HH:mm");

            //this.RWB.departure_station.value = ktzh_resp.recive_station_code;
            this.RWB.departure_station =
              this.rw_stations[
                this.rw_stations.findIndex(
                  (itm) => itm.value == ktzh_resp.recive_station_code.trim(),
                )
              ];
            //this.RWB.arrival_station.value = ktzh_resp.dest_station_code;
            this.RWB.arrival_station =
              this.rw_stations[
                this.rw_stations.findIndex(
                  (itm) => itm.value == ktzh_resp.dest_station_code.trim(),
                )
              ];
            this.contract_carrier_date_time_moscow_date = ktzh_resp.date;
            this.RWB.contract_number = this.$route.params.id;
            // this.RWB.goods.map(rwb_good => {
            // 	rwb_good.carriage_number = ktzh_resp.vag_no;
            // 	rwb_good.container_number = ktzh_resp.container_no;
            // });
          }, 2000);
        });
    }
  },
  computed: {
    locale() {
      var locale = this.$i18n.locale;
      var _this = this;
      switch (locale) {
        case "cn":
          locale = "zh-CN";
          break;
        case "en":
          locale = "en-US";
          break;
      }
      return locale;
    },
  },
  watch: {
    contract_carrier_date_time_moscow_date() {
      if (this.contract_carrier_date_time_moscow_time == "") {
        this.RWB.contract_carrier_date_time_moscow =
          this.contract_carrier_date_time_moscow_date + "T00:00:00";
      } else {
        this.RWB.contract_carrier_date_time_moscow =
          this.contract_carrier_date_time_moscow_date +
          "T" +
          this.contract_carrier_date_time_moscow_time;
      }
    },
    contract_carrier_date_time_moscow_time() {
      if (this.contract_carrier_date_time_moscow_date == "") {
        this.RWB.contract_carrier_date_time_moscow =
          "0001-01-01T" + this.contract_carrier_date_time_moscow_time;
      } else {
        this.RWB.contract_carrier_date_time_moscow =
          this.contract_carrier_date_time_moscow_date +
          "T" +
          this.contract_carrier_date_time_moscow_time;
      }
    },
    arrival_date_time_moscow_time() {
      if (this.arrival_date_time_moscow_time == "") {
        this.RWB.arrival_date_time_moscow =
          this.arrival_date_time_moscow_date + "T00:00:00";
      } else {
        this.RWB.arrival_date_time_moscow =
          this.arrival_date_time_moscow_date +
          "T" +
          this.arrival_date_time_moscow_time;
      }
    },
    arrival_date_time_moscow_date() {
      if (this.arrival_date_time_moscow_date == "") {
        this.RWB.arrival_date_time_moscow =
          "0001-01-01T" + this.arrival_date_time_moscow_time;
      } else {
        this.RWB.arrival_date_time_moscow =
          this.arrival_date_time_moscow_date +
          "T" +
          this.arrival_date_time_moscow_time;
      }
    },
    rwb_stamp_date_time_moscow_time() {
      if (this.rwb_stamp_date_time_moscow_time == "") {
        this.RWB.rwb_stamp_date_time_moscow =
          this.rwb_stamp_date_time_moscow_date + "T00:00:00";
      } else {
        this.RWB.rwb_stamp_date_time_moscow =
          this.rwb_stamp_date_time_moscow_date +
          "T" +
          this.rwb_stamp_date_time_moscow_time;
      }
    },
    rwb_stamp_date_time_moscow_date() {
      if (this.rwb_stamp_date_time_moscow_date == "") {
        this.RWB.rwb_stamp_date_time_moscow =
          "0001-01-01T" + this.rwb_stamp_date_time_moscow_time;
      } else {
        this.RWB.rwb_stamp_date_time_moscow =
          this.rwb_stamp_date_time_moscow_date +
          "T" +
          this.rwb_stamp_date_time_moscow_time;
      }
    },
  },
  validations: {},
};
</script>
<style>
#rwb_contract_date__outer_ {
  padding: 0 !important;
  height: 36px !important;
}
.b-form-timepicker label {
  background-image: none !important;
  align-self: center;
  padding-top: 6px;
  border: 0 !important;
}
.b-form-timepicker .btn {
  background: #fff !important;
  color: #3c4858;
  padding-top: 0 !important;
}
.b-form-timepicker.h-auto {
  height: 36px !important;
}
</style>
